var n$1, l$4, u$5, i$5, o$2, r$3, e$2, f$3, c$4, s$4, a$4, p$3 = {}, v$2 = [], y$2 = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, d$2 = Array.isArray;
function w$2(n2, l2) {
  for (var u2 in l2) n2[u2] = l2[u2];
  return n2;
}
function g$1(n2) {
  n2 && n2.parentNode && n2.parentNode.removeChild(n2);
}
function _$1(l2, u2, t2) {
  var i2, o2, r2, e2 = {};
  for (r2 in u2) "key" == r2 ? i2 = u2[r2] : "ref" == r2 ? o2 = u2[r2] : e2[r2] = u2[r2];
  if (arguments.length > 2 && (e2.children = arguments.length > 3 ? n$1.call(arguments, 2) : t2), "function" == typeof l2 && null != l2.defaultProps) for (r2 in l2.defaultProps) void 0 === e2[r2] && (e2[r2] = l2.defaultProps[r2]);
  return m$2(l2, e2, i2, o2, null);
}
function m$2(n2, t2, i2, o2, r2) {
  var e2 = { type: n2, props: t2, key: i2, ref: o2, __k: null, __: null, __b: 0, __e: null, __c: null, constructor: void 0, __v: null == r2 ? ++u$5 : r2, __i: -1, __u: 0 };
  return null == r2 && null != l$4.vnode && l$4.vnode(e2), e2;
}
function k$1(n2) {
  return n2.children;
}
function x(n2, l2) {
  this.props = n2, this.context = l2;
}
function S(n2, l2) {
  if (null == l2) return n2.__ ? S(n2.__, n2.__i + 1) : null;
  for (var u2; l2 < n2.__k.length; l2++) if (null != (u2 = n2.__k[l2]) && null != u2.__e) return u2.__e;
  return "function" == typeof n2.type ? S(n2) : null;
}
function C$1(n2) {
  var l2, u2;
  if (null != (n2 = n2.__) && null != n2.__c) {
    for (n2.__e = n2.__c.base = null, l2 = 0; l2 < n2.__k.length; l2++) if (null != (u2 = n2.__k[l2]) && null != u2.__e) {
      n2.__e = n2.__c.base = u2.__e;
      break;
    }
    return C$1(n2);
  }
}
function M(n2) {
  (!n2.__d && (n2.__d = true) && i$5.push(n2) && !$.__r++ || o$2 != l$4.debounceRendering) && ((o$2 = l$4.debounceRendering) || r$3)($);
}
function $() {
  for (var n2, u2, t2, o2, r2, f2, c2, s2 = 1; i$5.length; ) i$5.length > s2 && i$5.sort(e$2), n2 = i$5.shift(), s2 = i$5.length, n2.__d && (t2 = void 0, o2 = void 0, r2 = (o2 = (u2 = n2).__v).__e, f2 = [], c2 = [], u2.__P && ((t2 = w$2({}, o2)).__v = o2.__v + 1, l$4.vnode && l$4.vnode(t2), O(u2.__P, t2, o2, u2.__n, u2.__P.namespaceURI, 32 & o2.__u ? [r2] : null, f2, null == r2 ? S(o2) : r2, !!(32 & o2.__u), c2), t2.__v = o2.__v, t2.__.__k[t2.__i] = t2, N$1(f2, t2, c2), o2.__e = o2.__ = null, t2.__e != r2 && C$1(t2)));
  $.__r = 0;
}
function I(n2, l2, u2, t2, i2, o2, r2, e2, f2, c2, s2) {
  var a2, h2, y2, d2, w2, g2, _2, m2 = t2 && t2.__k || v$2, b2 = l2.length;
  for (f2 = P$1(u2, l2, m2, f2, b2), a2 = 0; a2 < b2; a2++) null != (y2 = u2.__k[a2]) && (h2 = -1 == y2.__i ? p$3 : m2[y2.__i] || p$3, y2.__i = a2, g2 = O(n2, y2, h2, i2, o2, r2, e2, f2, c2, s2), d2 = y2.__e, y2.ref && h2.ref != y2.ref && (h2.ref && B$2(h2.ref, null, y2), s2.push(y2.ref, y2.__c || d2, y2)), null == w2 && null != d2 && (w2 = d2), (_2 = !!(4 & y2.__u)) || h2.__k === y2.__k ? f2 = A$2(y2, f2, n2, _2) : "function" == typeof y2.type && void 0 !== g2 ? f2 = g2 : d2 && (f2 = d2.nextSibling), y2.__u &= -7);
  return u2.__e = w2, f2;
}
function P$1(n2, l2, u2, t2, i2) {
  var o2, r2, e2, f2, c2, s2 = u2.length, a2 = s2, h2 = 0;
  for (n2.__k = new Array(i2), o2 = 0; o2 < i2; o2++) null != (r2 = l2[o2]) && "boolean" != typeof r2 && "function" != typeof r2 ? ("string" == typeof r2 || "number" == typeof r2 || "bigint" == typeof r2 || r2.constructor == String ? r2 = n2.__k[o2] = m$2(null, r2, null, null, null) : d$2(r2) ? r2 = n2.__k[o2] = m$2(k$1, { children: r2 }, null, null, null) : void 0 === r2.constructor && r2.__b > 0 ? r2 = n2.__k[o2] = m$2(r2.type, r2.props, r2.key, r2.ref ? r2.ref : null, r2.__v) : n2.__k[o2] = r2, f2 = o2 + h2, r2.__ = n2, r2.__b = n2.__b + 1, e2 = null, -1 != (c2 = r2.__i = L(r2, u2, f2, a2)) && (a2--, (e2 = u2[c2]) && (e2.__u |= 2)), null == e2 || null == e2.__v ? (-1 == c2 && (i2 > s2 ? h2-- : i2 < s2 && h2++), "function" != typeof r2.type && (r2.__u |= 4)) : c2 != f2 && (c2 == f2 - 1 ? h2-- : c2 == f2 + 1 ? h2++ : (c2 > f2 ? h2-- : h2++, r2.__u |= 4))) : n2.__k[o2] = null;
  if (a2) for (o2 = 0; o2 < s2; o2++) null != (e2 = u2[o2]) && 0 == (2 & e2.__u) && (e2.__e == t2 && (t2 = S(e2)), D$2(e2, e2));
  return t2;
}
function A$2(n2, l2, u2, t2) {
  var i2, o2;
  if ("function" == typeof n2.type) {
    for (i2 = n2.__k, o2 = 0; i2 && o2 < i2.length; o2++) i2[o2] && (i2[o2].__ = n2, l2 = A$2(i2[o2], l2, u2, t2));
    return l2;
  }
  n2.__e != l2 && (t2 && (l2 && n2.type && !l2.parentNode && (l2 = S(n2)), u2.insertBefore(n2.__e, l2 || null)), l2 = n2.__e);
  do {
    l2 = l2 && l2.nextSibling;
  } while (null != l2 && 8 == l2.nodeType);
  return l2;
}
function H$1(n2, l2) {
  return l2 = l2 || [], null == n2 || "boolean" == typeof n2 || (d$2(n2) ? n2.some(function(n3) {
    H$1(n3, l2);
  }) : l2.push(n2)), l2;
}
function L(n2, l2, u2, t2) {
  var i2, o2, r2, e2 = n2.key, f2 = n2.type, c2 = l2[u2], s2 = null != c2 && 0 == (2 & c2.__u);
  if (null === c2 && null == e2 || s2 && e2 == c2.key && f2 == c2.type) return u2;
  if (t2 > (s2 ? 1 : 0)) {
    for (i2 = u2 - 1, o2 = u2 + 1; i2 >= 0 || o2 < l2.length; ) if (null != (c2 = l2[r2 = i2 >= 0 ? i2-- : o2++]) && 0 == (2 & c2.__u) && e2 == c2.key && f2 == c2.type) return r2;
  }
  return -1;
}
function T$2(n2, l2, u2) {
  "-" == l2[0] ? n2.setProperty(l2, null == u2 ? "" : u2) : n2[l2] = null == u2 ? "" : "number" != typeof u2 || y$2.test(l2) ? u2 : u2 + "px";
}
function j$2(n2, l2, u2, t2, i2) {
  var o2, r2;
  n: if ("style" == l2) if ("string" == typeof u2) n2.style.cssText = u2;
  else {
    if ("string" == typeof t2 && (n2.style.cssText = t2 = ""), t2) for (l2 in t2) u2 && l2 in u2 || T$2(n2.style, l2, "");
    if (u2) for (l2 in u2) t2 && u2[l2] == t2[l2] || T$2(n2.style, l2, u2[l2]);
  }
  else if ("o" == l2[0] && "n" == l2[1]) o2 = l2 != (l2 = l2.replace(f$3, "$1")), r2 = l2.toLowerCase(), l2 = r2 in n2 || "onFocusOut" == l2 || "onFocusIn" == l2 ? r2.slice(2) : l2.slice(2), n2.l || (n2.l = {}), n2.l[l2 + o2] = u2, u2 ? t2 ? u2.u = t2.u : (u2.u = c$4, n2.addEventListener(l2, o2 ? a$4 : s$4, o2)) : n2.removeEventListener(l2, o2 ? a$4 : s$4, o2);
  else {
    if ("http://www.w3.org/2000/svg" == i2) l2 = l2.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
    else if ("width" != l2 && "height" != l2 && "href" != l2 && "list" != l2 && "form" != l2 && "tabIndex" != l2 && "download" != l2 && "rowSpan" != l2 && "colSpan" != l2 && "role" != l2 && "popover" != l2 && l2 in n2) try {
      n2[l2] = null == u2 ? "" : u2;
      break n;
    } catch (n3) {
    }
    "function" == typeof u2 || (null == u2 || false === u2 && "-" != l2[4] ? n2.removeAttribute(l2) : n2.setAttribute(l2, "popover" == l2 && 1 == u2 ? "" : u2));
  }
}
function F$2(n2) {
  return function(u2) {
    if (this.l) {
      var t2 = this.l[u2.type + n2];
      if (null == u2.t) u2.t = c$4++;
      else if (u2.t < t2.u) return;
      return t2(l$4.event ? l$4.event(u2) : u2);
    }
  };
}
function O(n2, u2, t2, i2, o2, r2, e2, f2, c2, s2) {
  var a2, h2, p2, v2, y2, _2, m2, b2, S2, C2, M2, $2, P2, A2, H2, L2, T2, j2 = u2.type;
  if (void 0 !== u2.constructor) return null;
  128 & t2.__u && (c2 = !!(32 & t2.__u), r2 = [f2 = u2.__e = t2.__e]), (a2 = l$4.__b) && a2(u2);
  n: if ("function" == typeof j2) try {
    if (b2 = u2.props, S2 = "prototype" in j2 && j2.prototype.render, C2 = (a2 = j2.contextType) && i2[a2.__c], M2 = a2 ? C2 ? C2.props.value : a2.__ : i2, t2.__c ? m2 = (h2 = u2.__c = t2.__c).__ = h2.__E : (S2 ? u2.__c = h2 = new j2(b2, M2) : (u2.__c = h2 = new x(b2, M2), h2.constructor = j2, h2.render = E$1), C2 && C2.sub(h2), h2.state || (h2.state = {}), h2.__n = i2, p2 = h2.__d = true, h2.__h = [], h2._sb = []), S2 && null == h2.__s && (h2.__s = h2.state), S2 && null != j2.getDerivedStateFromProps && (h2.__s == h2.state && (h2.__s = w$2({}, h2.__s)), w$2(h2.__s, j2.getDerivedStateFromProps(b2, h2.__s))), v2 = h2.props, y2 = h2.state, h2.__v = u2, p2) S2 && null == j2.getDerivedStateFromProps && null != h2.componentWillMount && h2.componentWillMount(), S2 && null != h2.componentDidMount && h2.__h.push(h2.componentDidMount);
    else {
      if (S2 && null == j2.getDerivedStateFromProps && b2 !== v2 && null != h2.componentWillReceiveProps && h2.componentWillReceiveProps(b2, M2), u2.__v == t2.__v || !h2.__e && null != h2.shouldComponentUpdate && false === h2.shouldComponentUpdate(b2, h2.__s, M2)) {
        for (u2.__v != t2.__v && (h2.props = b2, h2.state = h2.__s, h2.__d = false), u2.__e = t2.__e, u2.__k = t2.__k, u2.__k.some(function(n3) {
          n3 && (n3.__ = u2);
        }), $2 = 0; $2 < h2._sb.length; $2++) h2.__h.push(h2._sb[$2]);
        h2._sb = [], h2.__h.length && e2.push(h2);
        break n;
      }
      null != h2.componentWillUpdate && h2.componentWillUpdate(b2, h2.__s, M2), S2 && null != h2.componentDidUpdate && h2.__h.push(function() {
        h2.componentDidUpdate(v2, y2, _2);
      });
    }
    if (h2.context = M2, h2.props = b2, h2.__P = n2, h2.__e = false, P2 = l$4.__r, A2 = 0, S2) {
      for (h2.state = h2.__s, h2.__d = false, P2 && P2(u2), a2 = h2.render(h2.props, h2.state, h2.context), H2 = 0; H2 < h2._sb.length; H2++) h2.__h.push(h2._sb[H2]);
      h2._sb = [];
    } else do {
      h2.__d = false, P2 && P2(u2), a2 = h2.render(h2.props, h2.state, h2.context), h2.state = h2.__s;
    } while (h2.__d && ++A2 < 25);
    h2.state = h2.__s, null != h2.getChildContext && (i2 = w$2(w$2({}, i2), h2.getChildContext())), S2 && !p2 && null != h2.getSnapshotBeforeUpdate && (_2 = h2.getSnapshotBeforeUpdate(v2, y2)), L2 = a2, null != a2 && a2.type === k$1 && null == a2.key && (L2 = V$1(a2.props.children)), f2 = I(n2, d$2(L2) ? L2 : [L2], u2, t2, i2, o2, r2, e2, f2, c2, s2), h2.base = u2.__e, u2.__u &= -161, h2.__h.length && e2.push(h2), m2 && (h2.__E = h2.__ = null);
  } catch (n3) {
    if (u2.__v = null, c2 || null != r2) if (n3.then) {
      for (u2.__u |= c2 ? 160 : 128; f2 && 8 == f2.nodeType && f2.nextSibling; ) f2 = f2.nextSibling;
      r2[r2.indexOf(f2)] = null, u2.__e = f2;
    } else {
      for (T2 = r2.length; T2--; ) g$1(r2[T2]);
      z$1(u2);
    }
    else u2.__e = t2.__e, u2.__k = t2.__k, n3.then || z$1(u2);
    l$4.__e(n3, u2, t2);
  }
  else null == r2 && u2.__v == t2.__v ? (u2.__k = t2.__k, u2.__e = t2.__e) : f2 = u2.__e = q$2(t2.__e, u2, t2, i2, o2, r2, e2, c2, s2);
  return (a2 = l$4.diffed) && a2(u2), 128 & u2.__u ? void 0 : f2;
}
function z$1(n2) {
  n2 && n2.__c && (n2.__c.__e = true), n2 && n2.__k && n2.__k.forEach(z$1);
}
function N$1(n2, u2, t2) {
  for (var i2 = 0; i2 < t2.length; i2++) B$2(t2[i2], t2[++i2], t2[++i2]);
  l$4.__c && l$4.__c(u2, n2), n2.some(function(u3) {
    try {
      n2 = u3.__h, u3.__h = [], n2.some(function(n3) {
        n3.call(u3);
      });
    } catch (n3) {
      l$4.__e(n3, u3.__v);
    }
  });
}
function V$1(n2) {
  return "object" != typeof n2 || null == n2 || n2.__b && n2.__b > 0 ? n2 : d$2(n2) ? n2.map(V$1) : w$2({}, n2);
}
function q$2(u2, t2, i2, o2, r2, e2, f2, c2, s2) {
  var a2, h2, v2, y2, w2, _2, m2, b2 = i2.props || p$3, k2 = t2.props, x2 = t2.type;
  if ("svg" == x2 ? r2 = "http://www.w3.org/2000/svg" : "math" == x2 ? r2 = "http://www.w3.org/1998/Math/MathML" : r2 || (r2 = "http://www.w3.org/1999/xhtml"), null != e2) {
    for (a2 = 0; a2 < e2.length; a2++) if ((w2 = e2[a2]) && "setAttribute" in w2 == !!x2 && (x2 ? w2.localName == x2 : 3 == w2.nodeType)) {
      u2 = w2, e2[a2] = null;
      break;
    }
  }
  if (null == u2) {
    if (null == x2) return document.createTextNode(k2);
    u2 = document.createElementNS(r2, x2, k2.is && k2), c2 && (l$4.__m && l$4.__m(t2, e2), c2 = false), e2 = null;
  }
  if (null == x2) b2 === k2 || c2 && u2.data == k2 || (u2.data = k2);
  else {
    if (e2 = e2 && n$1.call(u2.childNodes), !c2 && null != e2) for (b2 = {}, a2 = 0; a2 < u2.attributes.length; a2++) b2[(w2 = u2.attributes[a2]).name] = w2.value;
    for (a2 in b2) if (w2 = b2[a2], "children" == a2) ;
    else if ("dangerouslySetInnerHTML" == a2) v2 = w2;
    else if (!(a2 in k2)) {
      if ("value" == a2 && "defaultValue" in k2 || "checked" == a2 && "defaultChecked" in k2) continue;
      j$2(u2, a2, null, w2, r2);
    }
    for (a2 in k2) w2 = k2[a2], "children" == a2 ? y2 = w2 : "dangerouslySetInnerHTML" == a2 ? h2 = w2 : "value" == a2 ? _2 = w2 : "checked" == a2 ? m2 = w2 : c2 && "function" != typeof w2 || b2[a2] === w2 || j$2(u2, a2, w2, b2[a2], r2);
    if (h2) c2 || v2 && (h2.__html == v2.__html || h2.__html == u2.innerHTML) || (u2.innerHTML = h2.__html), t2.__k = [];
    else if (v2 && (u2.innerHTML = ""), I("template" == t2.type ? u2.content : u2, d$2(y2) ? y2 : [y2], t2, i2, o2, "foreignObject" == x2 ? "http://www.w3.org/1999/xhtml" : r2, e2, f2, e2 ? e2[0] : i2.__k && S(i2, 0), c2, s2), null != e2) for (a2 = e2.length; a2--; ) g$1(e2[a2]);
    c2 || (a2 = "value", "progress" == x2 && null == _2 ? u2.removeAttribute("value") : null != _2 && (_2 !== u2[a2] || "progress" == x2 && !_2 || "option" == x2 && _2 != b2[a2]) && j$2(u2, a2, _2, b2[a2], r2), a2 = "checked", null != m2 && m2 != u2[a2] && j$2(u2, a2, m2, b2[a2], r2));
  }
  return u2;
}
function B$2(n2, u2, t2) {
  try {
    if ("function" == typeof n2) {
      var i2 = "function" == typeof n2.__u;
      i2 && n2.__u(), i2 && null == u2 || (n2.__u = n2(u2));
    } else n2.current = u2;
  } catch (n3) {
    l$4.__e(n3, t2);
  }
}
function D$2(n2, u2, t2) {
  var i2, o2;
  if (l$4.unmount && l$4.unmount(n2), (i2 = n2.ref) && (i2.current && i2.current != n2.__e || B$2(i2, null, u2)), null != (i2 = n2.__c)) {
    if (i2.componentWillUnmount) try {
      i2.componentWillUnmount();
    } catch (n3) {
      l$4.__e(n3, u2);
    }
    i2.base = i2.__P = null;
  }
  if (i2 = n2.__k) for (o2 = 0; o2 < i2.length; o2++) i2[o2] && D$2(i2[o2], u2, t2 || "function" != typeof n2.type);
  t2 || g$1(n2.__e), n2.__c = n2.__ = n2.__e = void 0;
}
function E$1(n2, l2, u2) {
  return this.constructor(n2, u2);
}
function G$1(u2, t2, i2) {
  var o2, r2, e2, f2;
  t2 == document && (t2 = document.documentElement), l$4.__ && l$4.__(u2, t2), r2 = (o2 = "function" == typeof i2) ? null : i2 && i2.__k || t2.__k, e2 = [], f2 = [], O(t2, u2 = (!o2 && i2 || t2).__k = _$1(k$1, null, [u2]), r2 || p$3, p$3, t2.namespaceURI, !o2 && i2 ? [i2] : r2 ? null : t2.firstChild ? n$1.call(t2.childNodes) : null, e2, !o2 && i2 ? i2 : r2 ? r2.__e : t2.firstChild, o2, f2), N$1(e2, u2, f2);
}
function J$1(n2, l2) {
  G$1(n2, l2, J$1);
}
function K$1(l2, u2, t2) {
  var i2, o2, r2, e2, f2 = w$2({}, l2.props);
  for (r2 in l2.type && l2.type.defaultProps && (e2 = l2.type.defaultProps), u2) "key" == r2 ? i2 = u2[r2] : "ref" == r2 ? o2 = u2[r2] : f2[r2] = void 0 === u2[r2] && null != e2 ? e2[r2] : u2[r2];
  return arguments.length > 2 && (f2.children = arguments.length > 3 ? n$1.call(arguments, 2) : t2), m$2(l2.type, f2, i2 || l2.key, o2 || l2.ref, null);
}
n$1 = v$2.slice, l$4 = { __e: function(n2, l2, u2, t2) {
  for (var i2, o2, r2; l2 = l2.__; ) if ((i2 = l2.__c) && !i2.__) try {
    if ((o2 = i2.constructor) && null != o2.getDerivedStateFromError && (i2.setState(o2.getDerivedStateFromError(n2)), r2 = i2.__d), null != i2.componentDidCatch && (i2.componentDidCatch(n2, t2 || {}), r2 = i2.__d), r2) return i2.__E = i2;
  } catch (l3) {
    n2 = l3;
  }
  throw n2;
} }, u$5 = 0, x.prototype.setState = function(n2, l2) {
  var u2;
  u2 = null != this.__s && this.__s != this.state ? this.__s : this.__s = w$2({}, this.state), "function" == typeof n2 && (n2 = n2(w$2({}, u2), this.props)), n2 && w$2(u2, n2), null != n2 && this.__v && (l2 && this._sb.push(l2), M(this));
}, x.prototype.forceUpdate = function(n2) {
  this.__v && (this.__e = true, n2 && this.__h.push(n2), M(this));
}, x.prototype.render = k$1, i$5 = [], r$3 = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, e$2 = function(n2, l2) {
  return n2.__v.__b - l2.__v.__b;
}, $.__r = 0, f$3 = /(PointerCapture)$|Capture$/i, c$4 = 0, s$4 = F$2(false), a$4 = F$2(true);
var i$4;
function t$3(o2, e2) {
  return l$4.__a && l$4.__a(e2), o2;
}
null != (i$4 = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : void 0) && i$4.__PREACT_DEVTOOLS__ && i$4.__PREACT_DEVTOOLS__.attachPreact("10.28.2", l$4, { Fragment: k$1, Component: x });
var t$2 = {};
function a$3(e2) {
  return e2.type === k$1 ? "Fragment" : "function" == typeof e2.type ? e2.type.displayName || e2.type.name : "string" == typeof e2.type ? e2.type : "#text";
}
var i$3 = [], s$3 = [];
function c$3() {
  return i$3.length > 0 ? i$3[i$3.length - 1] : null;
}
var l$3 = true;
function u$4(e2) {
  return "function" == typeof e2.type && e2.type != k$1;
}
function f$2(n2) {
  for (var e2 = [n2], o2 = n2; null != o2.__o; ) e2.push(o2.__o), o2 = o2.__o;
  return e2.reduce(function(n3, e3) {
    n3 += "  in " + a$3(e3);
    var o3 = e3.__source;
    return o3 ? n3 += " (at " + o3.fileName + ":" + o3.lineNumber + ")" : l$3 && console.warn("Add @babel/plugin-transform-react-jsx-source to get a more detailed component stack. Note that you should not add it to production builds of your App for bundle size reasons."), l$3 = false, n3 + "\n";
  }, "");
}
var d$1 = "function" == typeof WeakMap;
function p$2(n2) {
  var e2 = [];
  return n2.__k ? (n2.__k.forEach(function(n3) {
    n3 && "function" == typeof n3.type ? e2.push.apply(e2, p$2(n3)) : n3 && "string" == typeof n3.type && e2.push(n3.type);
  }), e2) : e2;
}
function h$2(n2) {
  return n2 ? "function" == typeof n2.type ? null == n2.__ ? null != n2.__e && null != n2.__e.parentNode ? n2.__e.parentNode.localName : "" : h$2(n2.__) : n2.type : "";
}
var v$1 = x.prototype.setState;
function y$1(n2) {
  return "table" === n2 || "tfoot" === n2 || "tbody" === n2 || "thead" === n2 || "td" === n2 || "tr" === n2 || "th" === n2;
}
x.prototype.setState = function(n2, e2) {
  return null == this.__v && null == this.state && console.warn('Calling "this.setState" inside the constructor of a component is a no-op and might be a bug in your application. Instead, set "this.state = {}" directly.\n\n' + f$2(c$3())), v$1.call(this, n2, e2);
};
var m$1 = /^(address|article|aside|blockquote|details|div|dl|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hgroup|hr|main|menu|nav|ol|p|pre|search|section|table|ul)$/, b = x.prototype.forceUpdate;
function w$1(n2) {
  var e2 = n2.props, o2 = a$3(n2), t2 = "";
  for (var r2 in e2) if (e2.hasOwnProperty(r2) && "children" !== r2) {
    var i2 = e2[r2];
    "function" == typeof i2 && (i2 = "function " + (i2.displayName || i2.name) + "() {}"), i2 = Object(i2) !== i2 || i2.toString ? i2 + "" : Object.prototype.toString.call(i2), t2 += " " + r2 + "=" + JSON.stringify(i2);
  }
  var s2 = e2.children;
  return "<" + o2 + t2 + (s2 && s2.length ? ">..</" + o2 + ">" : " />");
}
x.prototype.forceUpdate = function(n2) {
  return null == this.__v ? console.warn('Calling "this.forceUpdate" inside the constructor of a component is a no-op and might be a bug in your application.\n\n' + f$2(c$3())) : null == this.__P && console.warn(`Can't call "this.forceUpdate" on an unmounted component. This is a no-op, but it indicates a memory leak in your application. To fix, cancel all subscriptions and asynchronous tasks in the componentWillUnmount method.

` + f$2(this.__v)), b.call(this, n2);
}, l$4.__m = function(n2, e2) {
  var o2 = n2.type, t2 = e2.map(function(n3) {
    return n3 && n3.localName;
  }).filter(Boolean);
  console.error('Expected a DOM node of type "' + o2 + '" but found "' + t2.join(", ") + `" as available DOM-node(s), this is caused by the SSR'd HTML containing different DOM-nodes compared to the hydrated one.

` + f$2(n2));
}, function() {
  !function() {
    var n3 = l$4.__b, o3 = l$4.diffed, t2 = l$4.__, r3 = l$4.vnode, a2 = l$4.__r;
    l$4.diffed = function(n4) {
      u$4(n4) && s$3.pop(), i$3.pop(), o3 && o3(n4);
    }, l$4.__b = function(e2) {
      u$4(e2) && i$3.push(e2), n3 && n3(e2);
    }, l$4.__ = function(n4, e2) {
      s$3 = [], t2 && t2(n4, e2);
    }, l$4.vnode = function(n4) {
      n4.__o = s$3.length > 0 ? s$3[s$3.length - 1] : null, r3 && r3(n4);
    }, l$4.__r = function(n4) {
      u$4(n4) && s$3.push(n4), a2 && a2(n4);
    };
  }();
  var n2 = false, o2 = l$4.__b, r2 = l$4.diffed, c2 = l$4.vnode, l2 = l$4.__r, v2 = l$4.__e, b2 = l$4.__, g2 = l$4.__h, E2 = d$1 ? { useEffect: /* @__PURE__ */ new WeakMap(), useLayoutEffect: /* @__PURE__ */ new WeakMap(), lazyPropTypes: /* @__PURE__ */ new WeakMap() } : null, k2 = [];
  l$4.__e = function(n3, e2, o3, t2) {
    if (e2 && e2.__c && "function" == typeof n3.then) {
      var r3 = n3;
      n3 = new Error("Missing Suspense. The throwing component was: " + a$3(e2));
      for (var i2 = e2; i2; i2 = i2.__) if (i2.__c && i2.__c.__c) {
        n3 = r3;
        break;
      }
      if (n3 instanceof Error) throw n3;
    }
    try {
      (t2 = t2 || {}).componentStack = f$2(e2), v2(n3, e2, o3, t2), "function" != typeof n3.then && setTimeout(function() {
        throw n3;
      });
    } catch (n4) {
      throw n4;
    }
  }, l$4.__ = function(n3, e2) {
    if (!e2) throw new Error("Undefined parent passed to render(), this is the second argument.\nCheck if the element is available in the DOM/has the correct id.");
    var o3;
    switch (e2.nodeType) {
      case 1:
      case 11:
      case 9:
        o3 = true;
        break;
      default:
        o3 = false;
    }
    if (!o3) {
      var t2 = a$3(n3);
      throw new Error("Expected a valid HTML node as a second argument to render.	Received " + e2 + " instead: render(<" + t2 + " />, " + e2 + ");");
    }
    b2 && b2(n3, e2);
  }, l$4.__b = function(e2) {
    var r3 = e2.type;
    if (n2 = true, void 0 === r3) throw new Error("Undefined component passed to createElement()\n\nYou likely forgot to export your component or might have mixed up default and named imports" + w$1(e2) + "\n\n" + f$2(e2));
    if (null != r3 && "object" == typeof r3) {
      if (void 0 !== r3.__k && void 0 !== r3.__e) throw new Error("Invalid type passed to createElement(): " + r3 + "\n\nDid you accidentally pass a JSX literal as JSX twice?\n\n  let My" + a$3(e2) + " = " + w$1(r3) + ";\n  let vnode = <My" + a$3(e2) + " />;\n\nThis usually happens when you export a JSX literal and not the component.\n\n" + f$2(e2));
      throw new Error("Invalid type passed to createElement(): " + (Array.isArray(r3) ? "array" : r3));
    }
    if (void 0 !== e2.ref && "function" != typeof e2.ref && "object" != typeof e2.ref && !("$$typeof" in e2)) throw new Error(`Component's "ref" property should be a function, or an object created by createRef(), but got [` + typeof e2.ref + "] instead\n" + w$1(e2) + "\n\n" + f$2(e2));
    if ("string" == typeof e2.type) {
      for (var i2 in e2.props) if ("o" === i2[0] && "n" === i2[1] && "function" != typeof e2.props[i2] && null != e2.props[i2]) throw new Error(`Component's "` + i2 + '" property should be a function, but got [' + typeof e2.props[i2] + "] instead\n" + w$1(e2) + "\n\n" + f$2(e2));
    }
    if ("function" == typeof e2.type && e2.type.propTypes) {
      if ("Lazy" === e2.type.displayName && E2 && !E2.lazyPropTypes.has(e2.type)) {
        var s2 = "PropTypes are not supported on lazy(). Use propTypes on the wrapped component itself. ";
        try {
          var c3 = e2.type();
          E2.lazyPropTypes.set(e2.type, true), console.warn(s2 + "Component wrapped in lazy() is " + a$3(c3));
        } catch (n3) {
          console.warn(s2 + "We will log the wrapped component's name once it is loaded.");
        }
      }
      var l3 = e2.props;
      e2.type.__f && delete (l3 = function(n3, e3) {
        for (var o3 in e3) n3[o3] = e3[o3];
        return n3;
      }({}, l3)).ref, function(n3, e3, o3, r4, a2) {
        Object.keys(n3).forEach(function(o4) {
          var i3;
          try {
            i3 = n3[o4](e3, o4, r4, "prop", null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
          } catch (n4) {
            i3 = n4;
          }
          i3 && !(i3.message in t$2) && (t$2[i3.message] = true, console.error("Failed prop type: " + i3.message + (a2 && "\n" + a2() || "")));
        });
      }(e2.type.propTypes, l3, 0, a$3(e2), function() {
        return f$2(e2);
      });
    }
    o2 && o2(e2);
  };
  var T2, _2 = 0;
  l$4.__r = function(e2) {
    l2 && l2(e2), n2 = true;
    var o3 = e2.__c;
    if (o3 === T2 ? _2++ : _2 = 1, _2 >= 25) throw new Error("Too many re-renders. This is limited to prevent an infinite loop which may lock up your browser. The component causing this is: " + a$3(e2));
    T2 = o3;
  }, l$4.__h = function(e2, o3, t2) {
    if (!e2 || !n2) throw new Error("Hook can only be invoked from render methods.");
    g2 && g2(e2, o3, t2);
  };
  var O2 = function(n3, e2) {
    return { get: function() {
      var o3 = "get" + n3 + e2;
      k2 && k2.indexOf(o3) < 0 && (k2.push(o3), console.warn("getting vnode." + n3 + " is deprecated, " + e2));
    }, set: function() {
      var o3 = "set" + n3 + e2;
      k2 && k2.indexOf(o3) < 0 && (k2.push(o3), console.warn("setting vnode." + n3 + " is not allowed, " + e2));
    } };
  }, I2 = { nodeName: O2("nodeName", "use vnode.type"), attributes: O2("attributes", "use vnode.props"), children: O2("children", "use vnode.props.children") }, M2 = Object.create({}, I2);
  l$4.vnode = function(n3) {
    var e2 = n3.props;
    if (null !== n3.type && null != e2 && ("__source" in e2 || "__self" in e2)) {
      var o3 = n3.props = {};
      for (var t2 in e2) {
        var r3 = e2[t2];
        "__source" === t2 ? n3.__source = r3 : "__self" === t2 ? n3.__self = r3 : o3[t2] = r3;
      }
    }
    n3.__proto__ = M2, c2 && c2(n3);
  }, l$4.diffed = function(e2) {
    var o3, t2 = e2.type, i2 = e2.__;
    if (e2.__k && e2.__k.forEach(function(n3) {
      if ("object" == typeof n3 && n3 && void 0 === n3.type) {
        var o4 = Object.keys(n3).join(",");
        throw new Error("Objects are not valid as a child. Encountered an object with the keys {" + o4 + "}.\n\n" + f$2(e2));
      }
    }), e2.__c === T2 && (_2 = 0), "string" == typeof t2 && (y$1(t2) || "p" === t2 || "a" === t2 || "button" === t2)) {
      var s2 = h$2(i2);
      if ("" !== s2 && y$1(t2)) "table" === t2 && "td" !== s2 && y$1(s2) ? console.error("Improper nesting of table. Your <table> should not have a table-node parent." + w$1(e2) + "\n\n" + f$2(e2)) : "thead" !== t2 && "tfoot" !== t2 && "tbody" !== t2 || "table" === s2 ? "tr" === t2 && "thead" !== s2 && "tfoot" !== s2 && "tbody" !== s2 ? console.error("Improper nesting of table. Your <tr> should have a <thead/tbody/tfoot> parent." + w$1(e2) + "\n\n" + f$2(e2)) : "td" === t2 && "tr" !== s2 ? console.error("Improper nesting of table. Your <td> should have a <tr> parent." + w$1(e2) + "\n\n" + f$2(e2)) : "th" === t2 && "tr" !== s2 && console.error("Improper nesting of table. Your <th> should have a <tr>." + w$1(e2) + "\n\n" + f$2(e2)) : console.error("Improper nesting of table. Your <thead/tbody/tfoot> should have a <table> parent." + w$1(e2) + "\n\n" + f$2(e2));
      else if ("p" === t2) {
        var c3 = p$2(e2).filter(function(n3) {
          return m$1.test(n3);
        });
        c3.length && console.error("Improper nesting of paragraph. Your <p> should not have " + c3.join(", ") + " as child-elements." + w$1(e2) + "\n\n" + f$2(e2));
      } else "a" !== t2 && "button" !== t2 || -1 !== p$2(e2).indexOf(t2) && console.error("Improper nesting of interactive content. Your <" + t2 + "> should not have other " + ("a" === t2 ? "anchor" : "button") + " tags as child-elements." + w$1(e2) + "\n\n" + f$2(e2));
    }
    if (n2 = false, r2 && r2(e2), null != e2.__k) for (var l3 = [], u2 = 0; u2 < e2.__k.length; u2++) {
      var d2 = e2.__k[u2];
      if (d2 && null != d2.key) {
        var v3 = d2.key;
        if (-1 !== l3.indexOf(v3)) {
          console.error('Following component has two or more children with the same key attribute: "' + v3 + '". This may cause glitches and misbehavior in rendering process. Component: \n\n' + w$1(e2) + "\n\n" + f$2(e2));
          break;
        }
        l3.push(v3);
      }
    }
    if (null != e2.__c && null != e2.__c.__H) {
      var b3 = e2.__c.__H.__;
      if (b3) for (var g3 = 0; g3 < b3.length; g3 += 1) {
        var E3 = b3[g3];
        if (E3.__H) {
          for (var k3 = 0; k3 < E3.__H.length; k3++) if ((o3 = E3.__H[k3]) != o3) {
            var O3 = a$3(e2);
            console.warn("Invalid argument passed to hook. Hooks should not be called with NaN in the dependency array. Hook index " + g3 + " in component " + O3 + " was called with NaN.");
          }
        }
      }
    }
  };
}();
(function polyfill() {
  const relList = document.createElement("link").relList;
  if (relList && relList.supports && relList.supports("modulepreload")) {
    return;
  }
  for (const link of document.querySelectorAll('link[rel="modulepreload"]')) {
    processPreload(link);
  }
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type !== "childList") {
        continue;
      }
      for (const node of mutation.addedNodes) {
        if (node.tagName === "LINK" && node.rel === "modulepreload")
          processPreload(node);
      }
    }
  }).observe(document, { childList: true, subtree: true });
  function getFetchOpts(link) {
    const fetchOpts = {};
    if (link.integrity) fetchOpts.integrity = link.integrity;
    if (link.referrerPolicy) fetchOpts.referrerPolicy = link.referrerPolicy;
    if (link.crossOrigin === "use-credentials")
      fetchOpts.credentials = "include";
    else if (link.crossOrigin === "anonymous") fetchOpts.credentials = "omit";
    else fetchOpts.credentials = "same-origin";
    return fetchOpts;
  }
  function processPreload(link) {
    if (link.ep)
      return;
    link.ep = true;
    const fetchOpts = getFetchOpts(link);
    fetch(link.href, fetchOpts);
  }
})();
function r$2() {
  return (r$2 = Object.assign ? Object.assign.bind() : function(t2) {
    for (var e2 = 1; e2 < arguments.length; e2++) {
      var n2 = arguments[e2];
      for (var o2 in n2) Object.prototype.hasOwnProperty.call(n2, o2) && (t2[o2] = n2[o2]);
    }
    return t2;
  }).apply(this, arguments);
}
var i$2 = ["context", "children"];
function a$2(t2) {
  this.getChildContext = function() {
    return t2.context;
  };
  var e2 = t2.children, n2 = function(t3, e3) {
    if (null == t3) return {};
    var n3, o2, r2 = {}, i2 = Object.keys(t3);
    for (o2 = 0; o2 < i2.length; o2++) e3.indexOf(n3 = i2[o2]) >= 0 || (r2[n3] = t3[n3]);
    return r2;
  }(t2, i$2);
  return K$1(e2, n2);
}
function s$2() {
  var o2 = new CustomEvent("_preact", { detail: {}, bubbles: true, cancelable: true });
  this.dispatchEvent(o2), this._vdom = _$1(a$2, r$2({}, this._props, { context: o2.detail.context }), function e2(n2, o3) {
    if (3 === n2.nodeType) return n2.data;
    if (1 !== n2.nodeType) return null;
    var r2 = [], i2 = {}, a2 = 0, s2 = n2.attributes, l2 = n2.childNodes;
    for (a2 = s2.length; a2--; ) "slot" !== s2[a2].name && (i2[s2[a2].name] = s2[a2].value, i2[c$2(s2[a2].name)] = s2[a2].value);
    for (a2 = l2.length; a2--; ) {
      var u2 = e2(l2[a2], null), d2 = l2[a2].slot;
      d2 ? i2[d2] = _$1(p$1, { name: d2 }, u2) : r2[a2] = u2;
    }
    var h2 = o3 ? _$1(p$1, null, r2) : r2;
    return _$1(o3 || n2.nodeName.toLowerCase(), i2, h2);
  }(this, this._vdomComponent)), (this.hasAttribute("hydrate") ? J$1 : G$1)(this._vdom, this._root);
}
function c$2(t2) {
  return t2.replace(/-(\w)/g, function(t3, e2) {
    return e2 ? e2.toUpperCase() : "";
  });
}
function l$2(t2, e2, r2) {
  if (this._vdom) {
    var i2 = {};
    i2[t2] = r2 = null == r2 ? void 0 : r2, i2[c$2(t2)] = r2, this._vdom = K$1(this._vdom, i2), G$1(this._vdom, this._root);
  }
}
function u$3() {
  G$1(this._vdom = null, this._root);
}
function p$1(e2, n2) {
  var o2 = this;
  return _$1("slot", r$2({}, e2, { ref: function(t2) {
    t2 ? (o2.ref = t2, o2._listener || (o2._listener = function(t3) {
      t3.stopPropagation(), t3.detail.context = n2;
    }, t2.addEventListener("_preact", o2._listener))) : o2.ref.removeEventListener("_preact", o2._listener);
  } }));
}
function register(t2, e2, n2, o2) {
  function r2() {
    var e3 = Reflect.construct(HTMLElement, [], r2);
    return e3._vdomComponent = t2, e3._root = e3, e3;
  }
  return (r2.prototype = Object.create(HTMLElement.prototype)).constructor = r2, r2.prototype.connectedCallback = s$2, r2.prototype.attributeChangedCallback = l$2, r2.prototype.disconnectedCallback = u$3, n2 = n2 || t2.observedAttributes || Object.keys(t2.propTypes || {}), r2.observedAttributes = n2, n2.forEach(function(t3) {
    Object.defineProperty(r2.prototype, t3, { get: function() {
      return this._vdom.props[t3];
    }, set: function(e3) {
      this._vdom ? this.attributeChangedCallback(t3, null, e3) : (this._props || (this._props = {}), this._props[t3] = e3, this.connectedCallback());
      var n3 = typeof e3;
      null != e3 && "string" !== n3 && "boolean" !== n3 && "number" !== n3 || this.setAttribute(t3, e3);
    } });
  }), customElements.define(e2 || t2.tagName || t2.displayName || t2.name, r2);
}
var t$1, r$1, u$2, i$1, o$1 = 0, f$1 = [], c$1 = l$4, e$1 = c$1.__b, a$1 = c$1.__r, v = c$1.diffed, l$1 = c$1.__c, m = c$1.unmount, s$1 = c$1.__;
function p(n2, t2) {
  c$1.__h && c$1.__h(r$1, n2, o$1 || t2), o$1 = 0;
  var u2 = r$1.__H || (r$1.__H = { __: [], __h: [] });
  return n2 >= u2.__.length && u2.__.push({}), u2.__[n2];
}
function d(n2) {
  return o$1 = 1, h$1(D$1, n2);
}
function h$1(n2, u2, i2) {
  var o2 = p(t$1++, 2);
  if (o2.t = n2, !o2.__c && (o2.__ = [i2 ? i2(u2) : D$1(void 0, u2), function(n3) {
    var t2 = o2.__N ? o2.__N[0] : o2.__[0], r2 = o2.t(t2, n3);
    t2 !== r2 && (o2.__N = [r2, o2.__[1]], o2.__c.setState({}));
  }], o2.__c = r$1, !r$1.__f)) {
    var f2 = function(n3, t2, r2) {
      if (!o2.__c.__H) return true;
      var u3 = o2.__c.__H.__.filter(function(n4) {
        return !!n4.__c;
      });
      if (u3.every(function(n4) {
        return !n4.__N;
      })) return !c2 || c2.call(this, n3, t2, r2);
      var i3 = o2.__c.props !== n3;
      return u3.forEach(function(n4) {
        if (n4.__N) {
          var t3 = n4.__[0];
          n4.__ = n4.__N, n4.__N = void 0, t3 !== n4.__[0] && (i3 = true);
        }
      }), c2 && c2.call(this, n3, t2, r2) || i3;
    };
    r$1.__f = true;
    var c2 = r$1.shouldComponentUpdate, e2 = r$1.componentWillUpdate;
    r$1.componentWillUpdate = function(n3, t2, r2) {
      if (this.__e) {
        var u3 = c2;
        c2 = void 0, f2(n3, t2, r2), c2 = u3;
      }
      e2 && e2.call(this, n3, t2, r2);
    }, r$1.shouldComponentUpdate = f2;
  }
  return o2.__N || o2.__;
}
function y(n2, u2) {
  var i2 = p(t$1++, 3);
  !c$1.__s && C(i2.__H, u2) && (i2.__ = n2, i2.u = u2, r$1.__H.__h.push(i2));
}
function _(n2, u2) {
  var i2 = p(t$1++, 4);
  !c$1.__s && C(i2.__H, u2) && (i2.__ = n2, i2.u = u2, r$1.__h.push(i2));
}
function A$1(n2) {
  return o$1 = 5, T$1(function() {
    return { current: n2 };
  }, []);
}
function F$1(n2, t2, r2) {
  o$1 = 6, _(function() {
    if ("function" == typeof n2) {
      var r3 = n2(t2());
      return function() {
        n2(null), r3 && "function" == typeof r3 && r3();
      };
    }
    if (n2) return n2.current = t2(), function() {
      return n2.current = null;
    };
  }, null == r2 ? r2 : r2.concat(n2));
}
function T$1(n2, r2) {
  var u2 = p(t$1++, 7);
  return C(u2.__H, r2) && (u2.__ = n2(), u2.__H = r2, u2.__h = n2), u2.__;
}
function q$1(n2, t2) {
  return o$1 = 8, T$1(function() {
    return n2;
  }, t2);
}
function j$1() {
  for (var n2; n2 = f$1.shift(); ) if (n2.__P && n2.__H) try {
    n2.__H.__h.forEach(z), n2.__H.__h.forEach(B$1), n2.__H.__h = [];
  } catch (t2) {
    n2.__H.__h = [], c$1.__e(t2, n2.__v);
  }
}
c$1.__b = function(n2) {
  r$1 = null, e$1 && e$1(n2);
}, c$1.__ = function(n2, t2) {
  n2 && t2.__k && t2.__k.__m && (n2.__m = t2.__k.__m), s$1 && s$1(n2, t2);
}, c$1.__r = function(n2) {
  a$1 && a$1(n2), t$1 = 0;
  var i2 = (r$1 = n2.__c).__H;
  i2 && (u$2 === r$1 ? (i2.__h = [], r$1.__h = [], i2.__.forEach(function(n3) {
    n3.__N && (n3.__ = n3.__N), n3.u = n3.__N = void 0;
  })) : (i2.__h.forEach(z), i2.__h.forEach(B$1), i2.__h = [], t$1 = 0)), u$2 = r$1;
}, c$1.diffed = function(n2) {
  v && v(n2);
  var t2 = n2.__c;
  t2 && t2.__H && (t2.__H.__h.length && (1 !== f$1.push(t2) && i$1 === c$1.requestAnimationFrame || ((i$1 = c$1.requestAnimationFrame) || w)(j$1)), t2.__H.__.forEach(function(n3) {
    n3.u && (n3.__H = n3.u), n3.u = void 0;
  })), u$2 = r$1 = null;
}, c$1.__c = function(n2, t2) {
  t2.some(function(n3) {
    try {
      n3.__h.forEach(z), n3.__h = n3.__h.filter(function(n4) {
        return !n4.__ || B$1(n4);
      });
    } catch (r2) {
      t2.some(function(n4) {
        n4.__h && (n4.__h = []);
      }), t2 = [], c$1.__e(r2, n3.__v);
    }
  }), l$1 && l$1(n2, t2);
}, c$1.unmount = function(n2) {
  m && m(n2);
  var t2, r2 = n2.__c;
  r2 && r2.__H && (r2.__H.__.forEach(function(n3) {
    try {
      z(n3);
    } catch (n4) {
      t2 = n4;
    }
  }), r2.__H = void 0, t2 && c$1.__e(t2, r2.__v));
};
var k = "function" == typeof requestAnimationFrame;
function w(n2) {
  var t2, r2 = function() {
    clearTimeout(u2), k && cancelAnimationFrame(t2), setTimeout(n2);
  }, u2 = setTimeout(r2, 35);
  k && (t2 = requestAnimationFrame(r2));
}
function z(n2) {
  var t2 = r$1, u2 = n2.__c;
  "function" == typeof u2 && (n2.__c = void 0, u2()), r$1 = t2;
}
function B$1(n2) {
  var t2 = r$1;
  n2.__c = n2.__(), r$1 = t2;
}
function C(n2, t2) {
  return !n2 || n2.length !== t2.length || t2.some(function(t3, r2) {
    return t3 !== n2[r2];
  });
}
function D$1(n2, t2) {
  return "function" == typeof t2 ? t2(n2) : t2;
}
var f = 0;
function u$1(e2, t2, n2, o2, i2, u2) {
  t2 || (t2 = {});
  var a2, c2, p2 = t2;
  if ("ref" in p2) for (c2 in p2 = {}, t2) "ref" == c2 ? a2 = t2[c2] : p2[c2] = t2[c2];
  var l2 = { type: e2, props: p2, key: n2, ref: a2, __k: null, __: null, __b: 0, __e: null, __c: null, constructor: void 0, __v: --f, __i: -1, __u: 0, __source: i2, __self: u2 };
  if ("function" == typeof e2 && (a2 = e2.defaultProps)) for (c2 in a2) void 0 === p2[c2] && (p2[c2] = a2[c2]);
  return l$4.vnode && l$4.vnode(l2), l2;
}
var _jsxFileName$e = "/home/runner/work/GIK2024_GIK/GIK2024_GIK/src/components/HelloWorld.tsx";
function HelloWorld({
  firstName,
  lastName,
  initialCount = 1
}) {
  const [counter, setCounter] = t$3(d(initialCount || 1), "counter");
  const handleClick = () => {
    setCounter(counter + 1);
  };
  return u$1("div", {
    children: [u$1("h1", {
      children: ["Hello ", firstName, " ", lastName]
    }, void 0, true, {
      fileName: _jsxFileName$e,
      lineNumber: 28,
      columnNumber: 7
    }, this), u$1("p", {
      className: "font-primary",
      children: ["Counter: ", counter]
    }, void 0, true, {
      fileName: _jsxFileName$e,
      lineNumber: 32,
      columnNumber: 7
    }, this), u$1("button", {
      onClick: handleClick,
      children: "Increase Counter"
    }, void 0, false, {
      fileName: _jsxFileName$e,
      lineNumber: 33,
      columnNumber: 7
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$e,
    lineNumber: 26,
    columnNumber: 5
  }, this);
}
register(HelloWorld, "hello-world");
var _jsxFileName$d = "/home/runner/work/GIK2024_GIK/GIK2024_GIK/src/components/AcousticCalculator.tsx";
function AcousticCalculator({
  heading = "",
  headingSize = "h1",
  title = "Acoustic Panel Calculator",
  description = "Whether you're treating a home theater, recording studio, office, or restaurant, the right number and placement of acoustic panels can significantly improve sound quality, reduce reverberation, and control sound reflections. This guide explores the most important factors and gives you a smart, simple way to estimate your panel count using our Acoustic Panel Calculator.",
  buttonText = "Get Free Advice From Our Experts",
  buttonUrl = "#contact"
}) {
  const [dimensions, setDimensions] = t$3(d({
    length: "",
    width: "",
    height: ""
  }), "dimensions");
  const [panelSize, setPanelSize] = t$3(d("24in x 48in"), "panelSize");
  const [results, setResults] = t$3(d({
    coverage10: 0,
    coverage15: 0,
    coverage25: 0,
    rt60Before: "",
    rt60After10: "",
    rt60After15: "",
    rt60After25: ""
  }), "results");
  const panelSizes = ["24in x 24in", "12in x 48in", "24in x 48in"];
  const calculatePanels = () => {
    const length = parseFloat(dimensions.length);
    const width = parseFloat(dimensions.width);
    const height = parseFloat(dimensions.height);
    if (!length || !width || !height) return;
    let coverage10, coverage15, coverage25;
    if (panelSize === "24in x 24in") {
      coverage10 = Math.round(length / 3.5 * 2 + width / 3.5 * 2);
      coverage15 = Math.round(length / 3 * 2 + width / 3 * 2);
      coverage25 = Math.round(length / 2 * 2 + width / 2 * 2);
    } else if (panelSize === "12in x 48in") {
      coverage10 = Math.round(length / 4.5 * 2 + width / 4.5 * 2);
      coverage15 = Math.round(length / 4 * 2 + width / 4 * 2);
      coverage25 = Math.round(length / 3 * 2 + width / 3 * 2);
    } else if (panelSize === "24in x 48in") {
      coverage10 = Math.round(length / 3.5 * 2 + width / 3.5 * 2);
      coverage15 = Math.round(length / 3 * 2 + width / 3 * 2);
      coverage25 = Math.round(length / 2 * 2 + width / 2 * 2);
    }
    const roomVolume = length * width * height;
    const rt60Before = (roomVolume / 1e3 * 1.2).toFixed(2);
    const rt60After10 = (parseFloat(rt60Before) * 0.85).toFixed(2);
    const rt60After15 = (parseFloat(rt60Before) * 0.75).toFixed(2);
    const rt60After25 = (parseFloat(rt60Before) * 0.6).toFixed(2);
    setResults({
      coverage10,
      coverage15,
      coverage25,
      rt60Before,
      rt60After10,
      rt60After15,
      rt60After25
    });
  };
  y(() => {
    calculatePanels();
  }, [dimensions, panelSize]);
  const handleDimensionChange = (field, value) => {
    setDimensions((prev) => ({
      ...prev,
      [field]: value
    }));
  };
  return u$1("div", {
    className: "acoustic-calculator",
    children: u$1("div", {
      className: "acoustic-calculator__container",
      children: u$1("div", {
        className: "acoustic-calculator__content",
        children: [heading && u$1("div", {
          className: "acoustic-calculator__heading",
          children: [headingSize === "h0" && u$1("h1", {
            className: "heading h0",
            children: heading
          }, void 0, false, {
            fileName: _jsxFileName$d,
            lineNumber: 115,
            columnNumber: 17
          }, this), headingSize === "h1" && u$1("h1", {
            className: "heading h1",
            children: heading
          }, void 0, false, {
            fileName: _jsxFileName$d,
            lineNumber: 118,
            columnNumber: 17
          }, this), headingSize === "h2" && u$1("h2", {
            className: "heading h2",
            children: heading
          }, void 0, false, {
            fileName: _jsxFileName$d,
            lineNumber: 121,
            columnNumber: 17
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$d,
          lineNumber: 113,
          columnNumber: 13
        }, this), u$1("div", {
          className: "acoustic-calculator__header",
          children: [u$1("div", {
            className: "acoustic-calculator__description rte",
            dangerouslySetInnerHTML: {
              __html: description
            }
          }, void 0, false, {
            fileName: _jsxFileName$d,
            lineNumber: 128,
            columnNumber: 13
          }, this), u$1("a", {
            href: buttonUrl,
            className: "acoustic-calculator__button",
            children: buttonText
          }, void 0, false, {
            fileName: _jsxFileName$d,
            lineNumber: 132,
            columnNumber: 13
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$d,
          lineNumber: 127,
          columnNumber: 11
        }, this), u$1("div", {
          className: "acoustic-calculator__main",
          children: u$1("div", {
            className: "acoustic-calculator__form",
            children: u$1("div", {
              className: "acoustic-calculator__section",
              children: [u$1("h3", {
                className: "acoustic-calculator__section-title",
                children: "Room Dimensions (Feet)"
              }, void 0, false, {
                fileName: _jsxFileName$d,
                lineNumber: 142,
                columnNumber: 17
              }, this), u$1("div", {
                className: "acoustic-calculator__input-row",
                children: [u$1("div", {
                  className: "acoustic-calculator__input-group",
                  children: [u$1("label", {
                    className: "acoustic-calculator__label",
                    children: "Length"
                  }, void 0, false, {
                    fileName: _jsxFileName$d,
                    lineNumber: 147,
                    columnNumber: 21
                  }, this), u$1("input", {
                    type: "number",
                    className: "acoustic-calculator__input",
                    value: dimensions.length,
                    onChange: (e2) => handleDimensionChange("length", e2.currentTarget.value),
                    placeholder: "Value"
                  }, void 0, false, {
                    fileName: _jsxFileName$d,
                    lineNumber: 148,
                    columnNumber: 21
                  }, this)]
                }, void 0, true, {
                  fileName: _jsxFileName$d,
                  lineNumber: 146,
                  columnNumber: 19
                }, this), u$1("div", {
                  className: "acoustic-calculator__input-group",
                  children: [u$1("label", {
                    className: "acoustic-calculator__label",
                    children: "Width"
                  }, void 0, false, {
                    fileName: _jsxFileName$d,
                    lineNumber: 159,
                    columnNumber: 21
                  }, this), u$1("input", {
                    type: "number",
                    className: "acoustic-calculator__input",
                    value: dimensions.width,
                    onChange: (e2) => handleDimensionChange("width", e2.currentTarget.value),
                    placeholder: "Value"
                  }, void 0, false, {
                    fileName: _jsxFileName$d,
                    lineNumber: 160,
                    columnNumber: 21
                  }, this)]
                }, void 0, true, {
                  fileName: _jsxFileName$d,
                  lineNumber: 158,
                  columnNumber: 19
                }, this), u$1("div", {
                  className: "acoustic-calculator__input-group",
                  children: [u$1("label", {
                    className: "acoustic-calculator__label",
                    children: "Height"
                  }, void 0, false, {
                    fileName: _jsxFileName$d,
                    lineNumber: 171,
                    columnNumber: 21
                  }, this), u$1("input", {
                    type: "number",
                    className: "acoustic-calculator__input",
                    value: dimensions.height,
                    onChange: (e2) => handleDimensionChange("height", e2.currentTarget.value),
                    placeholder: "Value"
                  }, void 0, false, {
                    fileName: _jsxFileName$d,
                    lineNumber: 172,
                    columnNumber: 21
                  }, this)]
                }, void 0, true, {
                  fileName: _jsxFileName$d,
                  lineNumber: 170,
                  columnNumber: 19
                }, this)]
              }, void 0, true, {
                fileName: _jsxFileName$d,
                lineNumber: 145,
                columnNumber: 17
              }, this), u$1("div", {
                className: "acoustic-calculator__results-container",
                children: [u$1("div", {
                  className: "acoustic-calculator__panel-selector",
                  children: [u$1("label", {
                    className: "acoustic-calculator__section-title",
                    children: "Select Panel Size"
                  }, void 0, false, {
                    fileName: _jsxFileName$d,
                    lineNumber: 187,
                    columnNumber: 21
                  }, this), u$1("select", {
                    className: "acoustic-calculator__select",
                    value: panelSize,
                    onChange: (e2) => setPanelSize(e2.currentTarget.value),
                    children: panelSizes.map((size) => u$1("option", {
                      value: size,
                      children: size
                    }, size, false, {
                      fileName: _jsxFileName$d,
                      lineNumber: 196,
                      columnNumber: 25
                    }, this))
                  }, void 0, false, {
                    fileName: _jsxFileName$d,
                    lineNumber: 190,
                    columnNumber: 21
                  }, this)]
                }, void 0, true, {
                  fileName: _jsxFileName$d,
                  lineNumber: 186,
                  columnNumber: 19
                }, this), u$1("div", {
                  className: "acoustic-calculator__results-section",
                  children: [u$1("h4", {
                    className: "acoustic-calculator__section-title",
                    children: "Suggested Number of Panels"
                  }, void 0, false, {
                    fileName: _jsxFileName$d,
                    lineNumber: 205,
                    columnNumber: 21
                  }, this), u$1("p", {
                    className: "acoustic-calculator__results-subtitle",
                    children: "Approximately how many acoustic panels you should place on the walls and ceiling"
                  }, void 0, false, {
                    fileName: _jsxFileName$d,
                    lineNumber: 208,
                    columnNumber: 21
                  }, this), u$1("div", {
                    className: "acoustic-calculator__input-row",
                    children: [u$1("div", {
                      className: "acoustic-calculator__input-group",
                      children: [u$1("label", {
                        className: "acoustic-calculator__label",
                        children: "10% Coverage (minimum)"
                      }, void 0, false, {
                        fileName: _jsxFileName$d,
                        lineNumber: 215,
                        columnNumber: 25
                      }, this), u$1("input", {
                        type: "text",
                        className: "acoustic-calculator__input",
                        value: results.coverage10,
                        readOnly: true
                      }, void 0, false, {
                        fileName: _jsxFileName$d,
                        lineNumber: 218,
                        columnNumber: 25
                      }, this)]
                    }, void 0, true, {
                      fileName: _jsxFileName$d,
                      lineNumber: 214,
                      columnNumber: 23
                    }, this), u$1("div", {
                      className: "acoustic-calculator__input-group",
                      children: [u$1("label", {
                        className: "acoustic-calculator__label",
                        children: "15% Coverage (recommended)"
                      }, void 0, false, {
                        fileName: _jsxFileName$d,
                        lineNumber: 226,
                        columnNumber: 25
                      }, this), u$1("input", {
                        type: "text",
                        className: "acoustic-calculator__input",
                        value: results.coverage15,
                        readOnly: true
                      }, void 0, false, {
                        fileName: _jsxFileName$d,
                        lineNumber: 229,
                        columnNumber: 25
                      }, this)]
                    }, void 0, true, {
                      fileName: _jsxFileName$d,
                      lineNumber: 225,
                      columnNumber: 23
                    }, this), u$1("div", {
                      className: "acoustic-calculator__input-group",
                      children: [u$1("label", {
                        className: "acoustic-calculator__label",
                        children: "25% Coverage (ideal)"
                      }, void 0, false, {
                        fileName: _jsxFileName$d,
                        lineNumber: 237,
                        columnNumber: 25
                      }, this), u$1("input", {
                        type: "text",
                        className: "acoustic-calculator__input",
                        value: results.coverage25,
                        readOnly: true
                      }, void 0, false, {
                        fileName: _jsxFileName$d,
                        lineNumber: 240,
                        columnNumber: 25
                      }, this)]
                    }, void 0, true, {
                      fileName: _jsxFileName$d,
                      lineNumber: 236,
                      columnNumber: 23
                    }, this)]
                  }, void 0, true, {
                    fileName: _jsxFileName$d,
                    lineNumber: 213,
                    columnNumber: 21
                  }, this)]
                }, void 0, true, {
                  fileName: _jsxFileName$d,
                  lineNumber: 204,
                  columnNumber: 19
                }, this)]
              }, void 0, true, {
                fileName: _jsxFileName$d,
                lineNumber: 185,
                columnNumber: 17
              }, this), u$1("h3", {
                className: "acoustic-calculator__section-title",
                children: "RT60 (Reverberation Time) Reduction When Using 2IN Thick Panels"
              }, void 0, false, {
                fileName: _jsxFileName$d,
                lineNumber: 252,
                columnNumber: 17
              }, this), u$1("div", {
                className: "acoustic-calculator__rt60-section",
                children: [u$1("div", {
                  className: "acoustic-calculator__input-group",
                  children: [u$1("label", {
                    className: "acoustic-calculator__label",
                    children: "RT60 Before (seconds)"
                  }, void 0, false, {
                    fileName: _jsxFileName$d,
                    lineNumber: 259,
                    columnNumber: 21
                  }, this), u$1("input", {
                    type: "text",
                    className: "acoustic-calculator__input acoustic-calculator__input--result",
                    value: results.rt60Before || "Result will appear here",
                    readOnly: true
                  }, void 0, false, {
                    fileName: _jsxFileName$d,
                    lineNumber: 262,
                    columnNumber: 21
                  }, this)]
                }, void 0, true, {
                  fileName: _jsxFileName$d,
                  lineNumber: 258,
                  columnNumber: 19
                }, this), u$1("div", {
                  className: "acoustic-calculator__input-group",
                  children: [u$1("label", {
                    className: "acoustic-calculator__label",
                    children: "RT60 (seconds) After Minimal Treatment"
                  }, void 0, false, {
                    fileName: _jsxFileName$d,
                    lineNumber: 270,
                    columnNumber: 21
                  }, this), u$1("input", {
                    type: "text",
                    className: "acoustic-calculator__input acoustic-calculator__input--result",
                    value: results.rt60After10 || "Result will appear here",
                    readOnly: true
                  }, void 0, false, {
                    fileName: _jsxFileName$d,
                    lineNumber: 273,
                    columnNumber: 21
                  }, this)]
                }, void 0, true, {
                  fileName: _jsxFileName$d,
                  lineNumber: 269,
                  columnNumber: 19
                }, this), u$1("div", {
                  className: "acoustic-calculator__input-group",
                  children: [u$1("label", {
                    className: "acoustic-calculator__label",
                    children: "RT60 (seconds) After Recommended Treatment"
                  }, void 0, false, {
                    fileName: _jsxFileName$d,
                    lineNumber: 281,
                    columnNumber: 21
                  }, this), u$1("input", {
                    type: "text",
                    className: "acoustic-calculator__input acoustic-calculator__input--result",
                    value: results.rt60After15 || "Result will appear here",
                    readOnly: true
                  }, void 0, false, {
                    fileName: _jsxFileName$d,
                    lineNumber: 284,
                    columnNumber: 21
                  }, this)]
                }, void 0, true, {
                  fileName: _jsxFileName$d,
                  lineNumber: 280,
                  columnNumber: 19
                }, this), u$1("div", {
                  className: "acoustic-calculator__input-group",
                  children: [u$1("label", {
                    className: "acoustic-calculator__label",
                    children: "RT60 (seconds) After Ideal Treatment"
                  }, void 0, false, {
                    fileName: _jsxFileName$d,
                    lineNumber: 292,
                    columnNumber: 21
                  }, this), u$1("input", {
                    type: "text",
                    className: "acoustic-calculator__input acoustic-calculator__input--result",
                    value: results.rt60After25 || "Result will appear here",
                    readOnly: true
                  }, void 0, false, {
                    fileName: _jsxFileName$d,
                    lineNumber: 295,
                    columnNumber: 21
                  }, this)]
                }, void 0, true, {
                  fileName: _jsxFileName$d,
                  lineNumber: 291,
                  columnNumber: 19
                }, this)]
              }, void 0, true, {
                fileName: _jsxFileName$d,
                lineNumber: 257,
                columnNumber: 17
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName$d,
              lineNumber: 140,
              columnNumber: 15
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$d,
            lineNumber: 139,
            columnNumber: 13
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$d,
          lineNumber: 138,
          columnNumber: 11
        }, this), u$1("p", {
          className: "acoustic-calculator__footer",
          children: "We recommend reaching out to us for advice for recording rooms, control rooms, mixing rooms, studios, and any musical applications."
        }, void 0, false, {
          fileName: _jsxFileName$d,
          lineNumber: 308,
          columnNumber: 11
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$d,
        lineNumber: 110,
        columnNumber: 9
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$d,
      lineNumber: 109,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName$d,
    lineNumber: 108,
    columnNumber: 5
  }, this);
}
register(AcousticCalculator, "acoustic-calculator");
class t {
  constructor(t2, e2, r2, s2) {
    this.t = null, this.s = null, this.i = t2, this.o = e2, this.t = r2, this.s = s2, this.o.addEventListener("message", this.l.bind(this));
  }
  setOutgoingMessageBus(t2) {
    this.t = t2;
  }
  setMessageExecution(t2) {
    this.s = t2;
  }
  sendMessage(t2, e2 = []) {
    return new Promise((r2, s2) => {
      const i2 = new MessageChannel();
      i2.port1.onmessage = (t3) => {
        if (!t3 || !t3.data) return i2.port1.close(), i2.port2.close(), s2(new Error(this.i + " received message but response can not be interpreted"));
        let e3;
        try {
          e3 = JSON.parse(t3.data);
        } catch (t4) {
          return i2.port1.close(), i2.port2.close(), this.h(t4), s2(t4);
        }
        e3.error ? s2(e3.error) : void 0 !== e3.result ? r2(e3.result) : r2(), i2.port1.close(), i2.port2.close();
      };
      let o2 = "";
      try {
        o2 = JSON.stringify({ message: t2, args: e2 });
      } catch (t3) {
        return s2(new Error(this.i + ": can not create command because it is not JSON.stringify able"));
      }
      if (!this.t) return s2(new Error(this.i + ": outgoing bus not set yet"));
      this.t.postMessage(o2, "*", [i2.port2]);
    });
  }
  l(t2) {
    const e2 = t2.ports && Array.isArray(t2.ports) && t2.ports.length > 0 ? t2.ports[0] : null;
    if (t2.data && e2) try {
      const r2 = JSON.parse(t2.data);
      if (!this.s) return e2.postMessage(JSON.stringify({ error: this.i + " is not ready to handle messages" }));
      Array.isArray(r2.args) || (r2.args = [r2.args]);
      const s2 = this.s(r2, t2);
      if (void 0 === s2) return;
      s2.then((t3 = {}) => {
        let r3 = void 0, s3 = void 0;
        "object" == typeof t3 && null !== t3 && (r3 = t3.error, s3 = t3.result), r3 ? e2.postMessage(JSON.stringify({ error: r3 })) : void 0 !== s3 ? e2.postMessage(JSON.stringify({ result: s3 })) : e2.postMessage(JSON.stringify({ result: t3 }));
      }, (t3) => {
        e2.postMessage(JSON.stringify({ error: this.h(t3) }));
      });
    } catch (t3) {
      e2.postMessage(JSON.stringify({ error: this.h(t3) }));
    }
  }
  h(t2) {
    if ("string" == typeof t2) {
      const e2 = this.i + ": " + t2;
      return console.error(e2), e2;
    }
    return t2.message = this.i + ": " + t2.message, console.error(t2), t2.message;
  }
}
const e = ["127.0.0.1", "localhost", "0.0.0.0"], r = (t2, e2) => {
  for (const s2 in e2) try {
    e2[s2].constructor === Object ? t2[s2] = r(t2[s2], e2[s2]) : t2[s2] = e2[s2];
  } catch (r2) {
    t2[s2] = e2[s2];
  }
  return t2;
}, s = ["language", "browserLanguage", "userLanguage", "systemLanguage"], i = (t2) => {
  if (!t2) return;
  const e2 = Object.keys(t2);
  for (const r2 of e2) {
    const e3 = t2[r2];
    if (!Array.isArray(e3) && "object" == typeof e3 && null !== e3) return i(e3);
    if (Array.isArray(e3)) {
      for (const t3 of e3) i(t3);
      return;
    }
    "true" !== e3 && "false" !== e3 || (t2[r2] = "true" === e3);
  }
}, o = () => /(android)/i.test(navigator.userAgent), n = (t2, e2, r2) => {
  let s2 = null;
  Object.defineProperty(t2, e2, { get: () => s2 || r2, set(t3) {
    (null == t3 ? void 0 : t3.mute) ? s2 = t3.value : (console.warn("You override Roomle defined behaviour. To disalbe this warning pass in an object with the following properties"), console.warn("{ mute: true, value: () => void }"), s2 = t3);
  } });
}, a = () => 0.01 * window.innerHeight + "px", l = (t2) => {
  t2 && setTimeout(() => t2.style.setProperty(h, a()), 0);
}, h = "--rml-full-height", c = /* @__PURE__ */ new Map();
class u {
  constructor(e2, r2, s2, i2) {
    if (this.ui = { callbacks: null }, this.extended = { callbacks: null }, this.analytics = { callbacks: {} }, this.global = { callbacks: {} }, this.u = {}, !e2 || "string" != typeof e2.id) throw new Error("Please provide a correct configuratorId, you get the correct ID from your Roomle Contact Person");
    if (c.has(r2)) throw new Error("There is already an instance on this DOM element");
    if (!document.getElementById("rml-styles")) {
      const t2 = s2.zIndex || 9999999, e3 = document.createElement("style");
      e3.type = "text/css", e3.id = "rml-styles";
      const r3 = "transition:all ease-in-out 450ms;", i3 = ["-webkit-", "-o-"].reduce((t3, e4) => t3 + (e4 + r3), "") + r3, o2 = a();
      e3.innerHTML = `
        .rml-container{${h}:${o2};}
        .rml-pos{position:fixed;top:0;left:0;z-index:${t2};opacity:0}
        .rml-transition{${i3}}
        .rml-fill{width:100%;height:100%;opacity:1}
        .rml-android-height{height:calc(var(${h},1vh)*100)}
        .rml-overflow-hidden{overflow:hidden}
      `, document.head.appendChild(e3);
    }
    this.m = this.m.bind(this), o() && window.addEventListener("resize", this.m), this.g = r2, this.u = s2, this.p = e2;
    const n2 = this.v();
    this.O = this.O.bind(this), this.N = this.N.bind(this), this.P = this.P.bind(this), this._ = new t("website", window, null, this.N), this.J = i2, this.g.appendChild(n2), this.S = n2, c.set(r2, true);
  }
  static createPlanner(t2, e2, r2) {
    return this.k(t2, e2, r2);
  }
  static createConfigurator(t2, e2, r2) {
    return this.k(t2, e2, r2);
  }
  static create(t2, e2, r2) {
    return this.k(t2, e2, r2);
  }
  static createViewer(t2, e2, r2) {
    return this.k(t2, e2, r2);
  }
  static k(t2, o2, n2) {
    return new Promise(async (a2, l2) => {
      try {
        const l3 = r((() => {
          const t3 = {};
          t3.locale || (t3.locale = ((t4 = null) => {
            const e2 = window.navigator;
            if (t4) return t4.substr(0, 2);
            if (Array.isArray(e2.languages) && e2.languages.length > 0) return e2.languages[0].substr(0, 2);
            for (let t5 = 0, r3 = s.length; t5 < r3; t5++) {
              const r4 = e2[s[t5]];
              if (r4) return r4.substr(0, 2);
            }
            return "en";
          })()), "(idle)" === t3.id && delete t3.id;
          const r2 = (() => {
            const t4 = (() => {
              try {
                return window.self !== window.top;
              } catch (t5) {
                return true;
              }
            })();
            let e2 = window.location.href;
            if (t4) {
              if (!document.referrer) return null;
              e2 = document.referrer;
            }
            const { hostname: r3 } = new URL(e2);
            return r3;
          })();
          return r2 && ((t4) => !!e.includes(t4) || !!t4.endsWith("roomle.com") || !(!t4.endsWith("gitlab.io") && !t4.endsWith("gitlab.com")))(r2) && (t3.configuratorId = "demoConfigurator"), t3.customApiUrl = "https://www.roomle.com/api/v2", t3.emails = false, t3;
        })(), ((t3) => (i(t3), (null == t3 ? void 0 : t3.customApiUrl) && (t3.customApiUrl = decodeURIComponent(t3.customApiUrl)), t3.shareUrl && (t3.deeplink = t3.shareUrl.replace("<CONF_ID>", "#CONFIGURATIONID#")), t3))(n2));
        l3.featureFlags || (l3.featureFlags = {}), "boolean" != typeof l3.featureFlags.realPartList && (l3.featureFlags.realPartList = true), "boolean" != typeof l3.featureFlags.globalCallbacks && (l3.featureFlags.globalCallbacks = true);
        const h2 = await (async (t3, e2) => {
          if ("string" != typeof t3) throw new Error('Configurator ID is not a string type: "' + typeof t3 + '"');
          const r2 = e2.customApiUrl ? e2.customApiUrl : "https://api.roomle.com/v2", s2 = e2.overrideTenant || 9, i2 = r2 + "/configurators/" + t3, o3 = "03-" + window.btoa((/* @__PURE__ */ new Date()).toISOString() + ";anonymous;roomle_portal_v2"), n3 = new Request(i2, { method: "GET", headers: new Headers({ apiKey: "roomle_portal_v2", currentTenant: s2, locale: "en", language: "en", device: 1, token: o3, platform: "web" }), mode: "cors", cache: "default" }), a3 = await fetch(n3), { configurator: l4 } = await a3.json();
          return l4;
        })(t2, l3);
        return n2 = ((t3, e2) => {
          e2.configuratorId = t3.id;
          const s2 = t3.settings || {};
          return !e2.overrideTenant && t3.tenant && (e2.overrideTenant = t3.tenant), ((t4, e3) => {
            const s3 = JSON.parse(JSON.stringify(t4));
            return r(s3, e3);
          })(s2, e2);
        })(h2, l3), new this(h2, o2, n2, a2);
      } catch (t3) {
        return l2(t3);
      }
    });
  }
  teardown() {
    this.g && c.delete(this.g);
    const t2 = this.g.querySelector("iframe");
    t2 && this.g.removeChild(t2), window.removeEventListener("resize", this.m);
  }
  v() {
    var t2;
    const e2 = document.createElement("iframe");
    let r2 = (null === (t2 = this.p) || void 0 === t2 ? void 0 : t2.url) || "https://www.roomle.com/t/cp/";
    return this.u.useLocalRoomle && (r2 = location.href.replace("embedding.html", "")), location.href.includes("roomle.gitlab.io") && (r2 = location.href.replace("embedding.html", "index.html")), this.u.overrideServerUrl && (r2 = this.u.overrideServerUrl), e2.src = r2, e2.classList.add("rml-container"), e2.classList.add("rml-fill"), e2;
  }
  m() {
    l(this.S);
  }
  O() {
    this.S.classList.add("rml-pos"), document.documentElement.classList.add("rml-overflow-hidden"), window.document.body.classList.add("rml-overflow-hidden"), o() && (l(this.S), this.S.classList.add("rml-android-height"));
  }
  P() {
    this.S.classList.remove("rml-pos"), this.S.classList.remove("rml-android-height"), document.documentElement.classList.remove("rml-overflow-hidden"), window.document.body.classList.remove("rml-overflow-hidden");
  }
  N({ message: t2, args: e2 }, r2) {
    var s2;
    if (!r2.source) return;
    if (r2.source !== (null === (s2 = this.S) || void 0 === s2 ? void 0 : s2.contentWindow)) return;
    if ("requestBoot" === t2) return this._.setOutgoingMessageBus(r2.source), Promise.resolve({ result: this.u });
    if ("setup" === t2) {
      const { methods: t3, callbacks: r3 } = e2[0];
      return t3.forEach((t4) => {
        const e3 = t4.split("."), r4 = e3[0], s3 = e3[1];
        this[r4] || (this[r4] = {}), this[r4][s3] = (function() {
          return this._.sendMessage(t4, [...arguments]);
        }).bind(this);
      }), r3.forEach((t4) => {
        const e3 = t4.split("."), r4 = e3[0], s3 = e3[1], i3 = e3[2];
        this[r4] || (this[r4] = {}), this[r4][s3] || (this[r4][s3] = {}), this[r4][s3][i3] = () => {
        };
      }), n(this.ui.callbacks, "onUseFullPage", this.O), n(this.ui.callbacks, "onBackToWebsite", this.P), this.J(this), setTimeout(() => this._.sendMessage("websiteReady"), 0), Promise.resolve({ result: null });
    }
    const i2 = t2.split("."), o2 = i2[0], a2 = i2[1], l2 = 3 === i2.length ? i2[2] : null;
    if (l2 && this[o2][a2][l2]) {
      const t3 = this[o2][a2][l2](...e2);
      return t3 instanceof Promise ? t3.then((t4) => ({ result: t4 })) : void 0 !== t3 ? Promise.resolve({ result: t3 }) : Promise.resolve({ result: null });
    }
    return Promise.reject('Message "' + t2 + '" is unkown');
  }
}
var _jsxFileName$c = "/home/runner/work/GIK2024_GIK/GIK2024_GIK/src/components/RoomleConfigurator.tsx";
function RoomleConfigurator({
  productId = "",
  configuratorId = "",
  width = "100%",
  height = "100%",
  buttonText = "Configure Product"
}) {
  const modalRef = t$3(A$1(null), "modalRef");
  const triggerButtonRef = t$3(A$1(null), "triggerButtonRef");
  const closeButtonRef = t$3(A$1(null), "closeButtonRef");
  const [isModalOpen, setIsModalOpen] = t$3(d(false), "isModalOpen");
  const [isLoading, setIsLoading] = t$3(d(false), "isLoading");
  const [error, setError] = t$3(d(null), "error");
  const [configuratorInstance, setConfiguratorInstance] = t$3(d(null), "configuratorInstance");
  y(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" && isModalOpen) {
        closeModal();
      }
    };
    if (isModalOpen) {
      document.addEventListener("keydown", handleEscapeKey);
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
      document.body.style.overflow = "";
    };
  }, [isModalOpen]);
  y(() => {
    if (!isModalOpen || !productId || !configuratorId) {
      return;
    }
    const createConfigurator = async () => {
      setIsLoading(true);
      setError(null);
      await new Promise((resolve) => setTimeout(resolve, 0));
      const containerElement = document.getElementById("roomle-configurator-container");
      if (!containerElement) {
        setError("Configurator container not found");
        setIsLoading(false);
        return;
      }
      try {
        const configurator = await u.createConfigurator(configuratorId, containerElement, {});
        await configurator.ui.loadObject(`${configuratorId}:${productId}`);
        configurator.ui.callbacks.onRequestProduct = (configurationId, image, partlist, price, labels, configuration) => {
          console.log("Request Product data:", configurationId, image, partlist, price, labels, configuration);
        };
        setConfiguratorInstance(configurator);
        setIsLoading(false);
      } catch (err) {
        setError("Failed to load configurator");
        setIsLoading(false);
        console.error("Roomle configurator error:", err);
      }
    };
    createConfigurator();
  }, [isModalOpen, productId, configuratorId]);
  const handleModalBackdropClick = (event) => {
    if (event.target === modalRef.current) {
      closeModal();
    }
  };
  const openModal = () => {
    if (!productId || !configuratorId) {
      setError("Configurator ID and Product ID are required");
      return;
    }
    setIsModalOpen(true);
  };
  const closeModal = () => {
    var _a;
    setIsModalOpen(false);
    setIsLoading(false);
    setError(null);
    if (configuratorInstance) {
      try {
        (_a = configuratorInstance.destroy) == null ? void 0 : _a.call(configuratorInstance);
      } catch (err) {
        console.warn("Error destroying configurator:", err);
      }
      setConfiguratorInstance(null);
    }
    setTimeout(() => {
      var _a2;
      (_a2 = triggerButtonRef.current) == null ? void 0 : _a2.focus();
    }, 100);
  };
  const handleTabKey = (event) => {
    var _a;
    if (!isModalOpen) return;
    const focusableElements = (_a = modalRef.current) == null ? void 0 : _a.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!focusableElements || focusableElements.length === 0) return;
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];
    if (event.key === "Tab") {
      if (event.shiftKey) {
        if (document.activeElement === firstElement) {
          lastElement.focus();
          event.preventDefault();
        }
      } else {
        if (document.activeElement === lastElement) {
          firstElement.focus();
          event.preventDefault();
        }
      }
    }
  };
  y(() => {
    document.addEventListener("keydown", handleTabKey);
    return () => document.removeEventListener("keydown", handleTabKey);
  }, [isModalOpen]);
  return u$1("div", {
    className: "roomle-configurator",
    children: [u$1("a", {
      className: "button button--primary button--sm button--fixed",
      is: "hover-link",
      ref: triggerButtonRef,
      type: "button",
      onClick: openModal,
      "aria-describedby": error ? "roomle-error" : void 0,
      children: [u$1("span", {
        class: "btn-fill",
        "data-fill": "",
        style: "transform: translateY(var(--motion-translateY)); --motion-translateY: -76%;"
      }, void 0, false, {
        fileName: _jsxFileName$c,
        lineNumber: 169,
        columnNumber: 9
      }, this), u$1("span", {
        class: "btn-text",
        children: buttonText
      }, void 0, false, {
        fileName: _jsxFileName$c,
        lineNumber: 170,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$c,
      lineNumber: 161,
      columnNumber: 7
    }, this), error && !isModalOpen && u$1("div", {
      id: "roomle-error",
      className: "roomle-configurator__error",
      role: "alert",
      children: error
    }, void 0, false, {
      fileName: _jsxFileName$c,
      lineNumber: 174,
      columnNumber: 9
    }, this), isModalOpen && u$1("div", {
      ref: modalRef,
      className: "roomle-configurator__modal",
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": "roomle-modal-title",
      onClick: handleModalBackdropClick,
      children: u$1("div", {
        className: "roomle-configurator__modal-content",
        children: [u$1("header", {
          className: "roomle-configurator__modal-header",
          children: [u$1("h2", {
            className: "heading leading-none",
            children: "Product Configurator"
          }, void 0, false, {
            fileName: _jsxFileName$c,
            lineNumber: 190,
            columnNumber: 15
          }, this), u$1("button", {
            ref: closeButtonRef,
            type: "button",
            className: "roomle-configurator__close-button",
            onClick: closeModal,
            "aria-label": "Close configurator",
            children: u$1("span", {
              "aria-hidden": "true",
              children: "×"
            }, void 0, false, {
              fileName: _jsxFileName$c,
              lineNumber: 200,
              columnNumber: 17
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$c,
            lineNumber: 193,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$c,
          lineNumber: 189,
          columnNumber: 13
        }, this), u$1("div", {
          className: "roomle-configurator__modal-body",
          children: [error && u$1("div", {
            className: "roomle-configurator__error",
            role: "alert",
            children: error
          }, void 0, false, {
            fileName: _jsxFileName$c,
            lineNumber: 206,
            columnNumber: 17
          }, this), u$1("div", {
            className: "roomle-configurator__container",
            id: "roomle-configurator-container",
            style: {
              width,
              height: isLoading ? "400px" : height,
              minHeight: "400px"
            }
          }, void 0, false, {
            fileName: _jsxFileName$c,
            lineNumber: 211,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName$c,
          lineNumber: 204,
          columnNumber: 13
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$c,
        lineNumber: 188,
        columnNumber: 11
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$c,
      lineNumber: 180,
      columnNumber: 9
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName$c,
    lineNumber: 160,
    columnNumber: 5
  }, this);
}
register(RoomleConfigurator, "roomle-configurator");
var _jsxFileName$b = "/home/runner/work/GIK2024_GIK/GIK2024_GIK/src/components/ComparisonTool/ComparisonSearch.tsx";
const ComparisonSearch = ({
  searchTerm,
  onSearchChange,
  onDebouncedSearchChange,
  placeholder = "Search Table",
  debounceMs = 1500
}) => {
  const [localSearchTerm, setLocalSearchTerm] = t$3(d(searchTerm), "localSearchTerm");
  const [isSearching, setIsSearching] = t$3(d(false), "isSearching");
  const timeoutRef = t$3(A$1(null), "timeoutRef");
  y(() => {
    setLocalSearchTerm(searchTerm);
  }, [searchTerm]);
  y(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setIsSearching(localSearchTerm.length > 0);
    onSearchChange(localSearchTerm);
    timeoutRef.current = setTimeout(() => {
      setIsSearching(false);
      onDebouncedSearchChange(localSearchTerm);
      timeoutRef.current = null;
    }, debounceMs);
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, [localSearchTerm, debounceMs, onSearchChange, onDebouncedSearchChange]);
  const handleInputChange = (e2) => {
    const value = e2.target.value;
    setLocalSearchTerm(value);
  };
  return u$1("div", {
    className: "comparison-chart__search-container",
    children: [u$1("input", {
      type: "text",
      placeholder,
      value: localSearchTerm,
      onInput: handleInputChange,
      className: "comparison-chart__search-input"
    }, void 0, false, {
      fileName: _jsxFileName$b,
      lineNumber: 62,
      columnNumber: 7
    }, void 0), isSearching && u$1("div", {
      className: "comparison-chart__search-loading",
      children: u$1("svg", {
        className: "comparison-chart__search-loading-icon",
        viewBox: "0 0 24 24",
        children: u$1("circle", {
          className: "comparison-chart__search-loading-circle",
          cx: "12",
          cy: "12",
          r: "10",
          stroke: "currentColor",
          strokeWidth: "4",
          fill: "none"
        }, void 0, false, {
          fileName: _jsxFileName$b,
          lineNumber: 72,
          columnNumber: 13
        }, void 0)
      }, void 0, false, {
        fileName: _jsxFileName$b,
        lineNumber: 71,
        columnNumber: 11
      }, void 0)
    }, void 0, false, {
      fileName: _jsxFileName$b,
      lineNumber: 70,
      columnNumber: 9
    }, void 0)]
  }, void 0, true, {
    fileName: _jsxFileName$b,
    lineNumber: 61,
    columnNumber: 5
  }, void 0);
};
var _jsxFileName$a = "/home/runner/work/GIK2024_GIK/GIK2024_GIK/src/components/ComparisonTool/ComparisonMobileFilters.tsx";
const ComparisonMobileFilters = ({
  selectedFilters,
  onFiltersChange,
  parsedMetaobjects,
  productData,
  getProductName: getProductName2,
  onClearFilters
}) => {
  const [isDrawerOpen, setIsDrawerOpen] = t$3(d(false), "isDrawerOpen");
  const [isAnimating, setIsAnimating] = t$3(d(false), "isAnimating");
  const [isCompareDropdownOpen, setIsCompareDropdownOpen] = t$3(d(false), "isCompareDropdownOpen");
  const [isEffectiveRangeDropdownOpen, setIsEffectiveRangeDropdownOpen] = t$3(d(false), "isEffectiveRangeDropdownOpen");
  const [isThicknessDropdownOpen, setIsThicknessDropdownOpen] = t$3(d(false), "isThicknessDropdownOpen");
  const [mousePosition, setMousePosition] = t$3(d({
    x: -9999,
    y: -9999
  }), "mousePosition");
  const [showCustomCursor, setShowCustomCursor] = t$3(d(false), "showCustomCursor");
  const [cursorExpanded, setCursorExpanded] = t$3(d(false), "cursorExpanded");
  t$3(A$1(null), "drawerRef");
  const dropdownRef = t$3(A$1(null), "dropdownRef");
  const effectiveRangeDropdownRef = t$3(A$1(null), "effectiveRangeDropdownRef");
  const thicknessDropdownRef = t$3(A$1(null), "thicknessDropdownRef");
  y(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsCompareDropdownOpen(false);
      }
      if (effectiveRangeDropdownRef.current && !effectiveRangeDropdownRef.current.contains(event.target)) {
        setIsEffectiveRangeDropdownOpen(false);
      }
      if (thicknessDropdownRef.current && !thicknessDropdownRef.current.contains(event.target)) {
        setIsThicknessDropdownOpen(false);
      }
    };
    if (isCompareDropdownOpen || isEffectiveRangeDropdownOpen || isThicknessDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [isCompareDropdownOpen, isEffectiveRangeDropdownOpen, isThicknessDropdownOpen]);
  y(() => {
    if (isDrawerOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isDrawerOpen]);
  y(() => {
    let animationFrameId;
    const handleMouseMove = (e2) => {
      if (!showCustomCursor) return;
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
      animationFrameId = requestAnimationFrame(() => {
        setMousePosition({
          x: e2.clientX,
          y: e2.clientY
        });
      });
    };
    if (isDrawerOpen && showCustomCursor) {
      document.addEventListener("mousemove", handleMouseMove, {
        passive: true
      });
      return () => {
        document.removeEventListener("mousemove", handleMouseMove);
        if (animationFrameId) {
          cancelAnimationFrame(animationFrameId);
        }
      };
    }
  }, [isDrawerOpen, showCustomCursor]);
  const handleOpenDrawer = () => {
    setIsDrawerOpen(true);
    setShowCustomCursor(false);
    setCursorExpanded(false);
    setTimeout(() => setIsAnimating(true), 10);
  };
  const handleCloseDrawer = () => {
    setIsAnimating(false);
    setShowCustomCursor(false);
    setCursorExpanded(false);
    setMousePosition({
      x: -9999,
      y: -9999
    });
    setTimeout(() => setIsDrawerOpen(false), 300);
  };
  const handleMouseEnterOverlay = (e2) => {
    setMousePosition({
      x: e2.clientX,
      y: e2.clientY
    });
    setShowCustomCursor(true);
    setTimeout(() => setCursorExpanded(true), 10);
  };
  const handleMouseLeaveOverlay = () => {
    setCursorExpanded(false);
    setTimeout(() => {
      setShowCustomCursor(false);
      setMousePosition({
        x: -9999,
        y: -9999
      });
    }, 200);
  };
  const getUniqueValues2 = () => {
    if (!Array.isArray(parsedMetaobjects) || parsedMetaobjects.length === 0) {
      return {
        frequencies: [],
        thicknesses: [],
        productTitles: []
      };
    }
    const frequencies2 = Array.from(new Set(parsedMetaobjects.map((item) => item.lowest_frequency).filter((freq) => freq && freq !== "N/A").map((freq) => String(freq).trim()))).sort((a2, b2) => {
      const numA = parseInt(String(a2).replace(/[^\d]/g, "")) || 0;
      const numB = parseInt(String(b2).replace(/[^\d]/g, "")) || 0;
      return numA - numB;
    });
    const thicknesses2 = Array.from(new Set(parsedMetaobjects.map((item) => item.thickness).filter((thickness) => thickness && thickness !== "N/A").map((thickness) => String(thickness).trim()))).sort((a2, b2) => {
      const numA = parseFloat(String(a2).replace(/[^\d.]/g, "")) || 0;
      const numB = parseFloat(String(b2).replace(/[^\d.]/g, "")) || 0;
      return numA - numB;
    });
    const productTitles2 = Array.from(new Set(parsedMetaobjects.map((item, index) => getProductName2(item.product, index)).filter((title) => title && title !== "N/A"))).sort();
    return {
      frequencies: frequencies2,
      thicknesses: thicknesses2,
      productTitles: productTitles2
    };
  };
  const {
    frequencies,
    thicknesses,
    productTitles
  } = getUniqueValues2();
  const handleFilterChange = (filterType, value) => {
    if (filterType === "selectedProducts") {
      const currentSelected = selectedFilters.selectedProducts;
      const newSelected = currentSelected.includes(value) ? currentSelected.filter((item) => item !== value) : [...currentSelected, value];
      onFiltersChange({
        ...selectedFilters,
        selectedProducts: newSelected
      });
    } else {
      onFiltersChange({
        ...selectedFilters,
        [filterType]: value
      });
    }
  };
  const handleProductToggle = (productTitle) => {
    handleFilterChange("selectedProducts", productTitle);
  };
  const handleEffectiveRangeSelect = (frequency) => {
    handleFilterChange("effectiveRange", frequency);
    setIsEffectiveRangeDropdownOpen(false);
  };
  const handleThicknessSelect = (thickness) => {
    handleFilterChange("thickness", thickness);
    setIsThicknessDropdownOpen(false);
  };
  const handleApplyFilters = () => {
    setIsCompareDropdownOpen(false);
    handleCloseDrawer();
  };
  const handleClearFilters = () => {
    setIsCompareDropdownOpen(false);
    onClearFilters();
  };
  const getTotalFilterCount = () => {
    let count = 0;
    if (selectedFilters.selectedProducts.length > 0) count++;
    if (selectedFilters.effectiveRange) count++;
    if (selectedFilters.thickness) count++;
    return count;
  };
  return u$1(k$1, {
    children: [u$1("div", {
      className: "comparison-chart__mobile-filter-wrapper",
      children: u$1("button", {
        className: "comparison-chart__mobile-filter-button",
        type: "button",
        onClick: handleOpenDrawer,
        "aria-controls": "ComparisonDrawer",
        "aria-expanded": isDrawerOpen,
        "aria-label": "Open filters",
        children: u$1("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 32 24",
          fill: "none",
          children: u$1("path", {
            d: "M22.5625 12.75C22.5625 12.8992 22.5032 13.0423 22.3977 13.1477C22.2923 13.2532 22.1492 13.3125 22 13.3125H10C9.85082 13.3125 9.70774 13.2532 9.60225 13.1477C9.49676 13.0423 9.4375 12.8992 9.4375 12.75C9.4375 12.6008 9.49676 12.4577 9.60225 12.3523C9.70774 12.2468 9.85082 12.1875 10 12.1875H22C22.1492 12.1875 22.2923 12.2468 22.3977 12.3523C22.5032 12.4577 22.5625 12.6008 22.5625 12.75ZM25.75 7.6875H6.25C6.10082 7.6875 5.95774 7.74676 5.85225 7.85225C5.74676 7.95774 5.6875 8.10082 5.6875 8.25C5.6875 8.39918 5.74676 8.54226 5.85225 8.64775C5.95774 8.75324 6.10082 8.8125 6.25 8.8125H25.75C25.8992 8.8125 26.0423 8.75324 26.1477 8.64775C26.2532 8.54226 26.3125 8.39918 26.3125 8.25C26.3125 8.10082 26.2532 7.95774 26.1477 7.85225C26.0423 7.74676 25.8992 7.6875 25.75 7.6875ZM18.25 16.6875H13.75C13.6008 16.6875 13.4577 16.7468 13.3523 16.8523C13.2468 16.9577 13.1875 17.1008 13.1875 17.25C13.1875 17.3992 13.2468 17.5423 13.3523 17.6477C13.4577 17.7532 13.6008 17.8125 13.75 17.8125H18.25C18.3992 17.8125 18.5423 17.7532 18.6477 17.6477C18.7532 17.5423 18.8125 17.3992 18.8125 17.25C18.8125 17.1008 18.7532 16.9577 18.6477 16.8523C18.5423 16.7468 18.3992 16.6875 18.25 16.6875Z",
            fill: "#187380"
          }, void 0, false, {
            fileName: _jsxFileName$a,
            lineNumber: 262,
            columnNumber: 1
          }, void 0)
        }, void 0, false, {
          fileName: _jsxFileName$a,
          lineNumber: 261,
          columnNumber: 11
        }, void 0)
      }, void 0, false, {
        fileName: _jsxFileName$a,
        lineNumber: 253,
        columnNumber: 9
      }, void 0)
    }, void 0, false, {
      fileName: _jsxFileName$a,
      lineNumber: 252,
      columnNumber: 7
    }, void 0), isDrawerOpen && u$1("div", {
      className: "comparison-chart__mobile-drawer-element",
      role: "dialog",
      "aria-modal": "true",
      "aria-label": "Filter comparison",
      id: "ComparisonDrawer",
      children: [showCustomCursor && u$1("div", {
        className: `mouse-cursor z-50 fixed select-none flex items-center justify-center pointer-events-none rounded-full ${cursorExpanded ? "mouse-cursor--expanded" : "mouse-cursor--contracted"}`,
        style: {
          left: mousePosition.x,
          top: mousePosition.y
        },
        children: u$1("svg", {
          className: "icon icon-cursor",
          stroke: "currentColor",
          viewBox: "0 0 40 40",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: u$1("path", {
            d: "M10 30L30 10M10 10L30 30",
            strokeWidth: "2.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }, void 0, false, {
            fileName: _jsxFileName$a,
            lineNumber: 292,
            columnNumber: 17
          }, void 0)
        }, void 0, false, {
          fileName: _jsxFileName$a,
          lineNumber: 285,
          columnNumber: 15
        }, void 0)
      }, void 0, false, {
        fileName: _jsxFileName$a,
        lineNumber: 278,
        columnNumber: 13
      }, void 0), u$1("div", {
        className: `overlay ${isAnimating ? "overlay--visible" : "overlay--hidden"}`,
        onClick: handleCloseDrawer,
        onMouseEnter: handleMouseEnterOverlay,
        onMouseLeave: handleMouseLeaveOverlay
      }, void 0, false, {
        fileName: _jsxFileName$a,
        lineNumber: 303,
        columnNumber: 11
      }, void 0), u$1("div", {
        className: `drawer__inner flex flex-col overflow-hidden ${isAnimating ? "drawer__inner--visible" : "drawer__inner--hidden"}`,
        children: [u$1("div", {
          className: "drawer__header flex justify-between items-center",
          children: [u$1("span", {
            className: "drawer__title",
            children: "Filter By"
          }, void 0, false, {
            fileName: _jsxFileName$a,
            lineNumber: 317,
            columnNumber: 15
          }, void 0), u$1("div", {
            className: "flex items-center gap-4",
            children: [getTotalFilterCount() > 0 && u$1("button", {
              className: "comparison-chart__header-clear-button",
              type: "button",
              onClick: handleClearFilters,
              children: "Clear"
            }, void 0, false, {
              fileName: _jsxFileName$a,
              lineNumber: 320,
              columnNumber: 19
            }, void 0), u$1("button", {
              className: "button button--secondary button--close drawer__close hidden sm:flex items-center justify-center",
              type: "button",
              onClick: handleCloseDrawer,
              "aria-controls": "ComparisonDrawer",
              "aria-expanded": isDrawerOpen,
              "aria-label": "Close",
              children: [u$1("span", {
                className: "btn-fill",
                "data-fill": true
              }, void 0, false, {
                fileName: _jsxFileName$a,
                lineNumber: 336,
                columnNumber: 19
              }, void 0), u$1("span", {
                className: "btn-text",
                children: u$1("svg", {
                  className: "icon icon-close icon-sm",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 20 20",
                  children: u$1("path", {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M5 15L15 5M5 5L15 15"
                  }, void 0, false, {
                    fileName: _jsxFileName$a,
                    lineNumber: 344,
                    columnNumber: 23
                  }, void 0)
                }, void 0, false, {
                  fileName: _jsxFileName$a,
                  lineNumber: 338,
                  columnNumber: 21
                }, void 0)
              }, void 0, false, {
                fileName: _jsxFileName$a,
                lineNumber: 337,
                columnNumber: 19
              }, void 0), u$1("span", {
                className: "btn-loader",
                children: [u$1("span", {}, void 0, false, {
                  fileName: _jsxFileName$a,
                  lineNumber: 348,
                  columnNumber: 21
                }, void 0), u$1("span", {}, void 0, false, {
                  fileName: _jsxFileName$a,
                  lineNumber: 349,
                  columnNumber: 21
                }, void 0), u$1("span", {}, void 0, false, {
                  fileName: _jsxFileName$a,
                  lineNumber: 350,
                  columnNumber: 21
                }, void 0)]
              }, void 0, true, {
                fileName: _jsxFileName$a,
                lineNumber: 347,
                columnNumber: 19
              }, void 0)]
            }, void 0, true, {
              fileName: _jsxFileName$a,
              lineNumber: 328,
              columnNumber: 17
            }, void 0)]
          }, void 0, true, {
            fileName: _jsxFileName$a,
            lineNumber: 318,
            columnNumber: 15
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName$a,
          lineNumber: 316,
          columnNumber: 13
        }, void 0), u$1("div", {
          className: "drawer__content flex flex-col",
          children: [u$1("div", {
            className: "drawer__scrollable",
            children: [u$1("div", {
              className: "comparison-chart__mobile-filter-group",
              children: u$1("div", {
                className: "details",
                children: [u$1("div", {
                  className: "details__summary flex items-center justify-between gap-2",
                  children: u$1("span", {
                    className: "text-base-xl font-medium",
                    children: "Compare Products"
                  }, void 0, false, {
                    fileName: _jsxFileName$a,
                    lineNumber: 364,
                    columnNumber: 23
                  }, void 0)
                }, void 0, false, {
                  fileName: _jsxFileName$a,
                  lineNumber: 363,
                  columnNumber: 21
                }, void 0), u$1("div", {
                  className: "details__content",
                  children: u$1("div", {
                    className: "comparison-chart__mobile-multiselect-container",
                    ref: dropdownRef,
                    children: [u$1("button", {
                      className: "comparison-chart__mobile-multiselect-button",
                      onClick: () => setIsCompareDropdownOpen(!isCompareDropdownOpen),
                      children: [u$1("span", {
                        children: selectedFilters.selectedProducts.length === 0 ? "Select Products" : `${selectedFilters.selectedProducts.length} selected`
                      }, void 0, false, {
                        fileName: _jsxFileName$a,
                        lineNumber: 372,
                        columnNumber: 27
                      }, void 0), u$1("svg", {
                        className: `comparison-chart__mobile-dropdown-arrow ${isCompareDropdownOpen ? "comparison-chart__mobile-dropdown-arrow--open" : ""}`,
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24",
                        children: u$1("path", {
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeWidth: 2,
                          d: "M19 9l-7 7-7-7"
                        }, void 0, false, {
                          fileName: _jsxFileName$a,
                          lineNumber: 384,
                          columnNumber: 29
                        }, void 0)
                      }, void 0, false, {
                        fileName: _jsxFileName$a,
                        lineNumber: 378,
                        columnNumber: 27
                      }, void 0)]
                    }, void 0, true, {
                      fileName: _jsxFileName$a,
                      lineNumber: 368,
                      columnNumber: 25
                    }, void 0), isCompareDropdownOpen && u$1("div", {
                      className: "comparison-chart__mobile-multiselect-dropdown",
                      children: productTitles.map((productTitle) => u$1("div", {
                        className: "comparison-chart__mobile-multiselect-option",
                        onClick: () => handleProductToggle(productTitle),
                        children: [u$1("span", {
                          className: "comparison-chart__mobile-option-text",
                          children: productTitle
                        }, void 0, false, {
                          fileName: _jsxFileName$a,
                          lineNumber: 396,
                          columnNumber: 33
                        }, void 0), selectedFilters.selectedProducts.includes(productTitle) && u$1("svg", {
                          className: "comparison-chart__mobile-checkmark",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24",
                          children: u$1("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M5 13l4 4L19 7"
                          }, void 0, false, {
                            fileName: _jsxFileName$a,
                            lineNumber: 404,
                            columnNumber: 37
                          }, void 0)
                        }, void 0, false, {
                          fileName: _jsxFileName$a,
                          lineNumber: 398,
                          columnNumber: 35
                        }, void 0)]
                      }, productTitle, true, {
                        fileName: _jsxFileName$a,
                        lineNumber: 391,
                        columnNumber: 31
                      }, void 0))
                    }, void 0, false, {
                      fileName: _jsxFileName$a,
                      lineNumber: 389,
                      columnNumber: 27
                    }, void 0)]
                  }, void 0, true, {
                    fileName: _jsxFileName$a,
                    lineNumber: 367,
                    columnNumber: 23
                  }, void 0)
                }, void 0, false, {
                  fileName: _jsxFileName$a,
                  lineNumber: 366,
                  columnNumber: 21
                }, void 0)]
              }, void 0, true, {
                fileName: _jsxFileName$a,
                lineNumber: 362,
                columnNumber: 19
              }, void 0)
            }, void 0, false, {
              fileName: _jsxFileName$a,
              lineNumber: 361,
              columnNumber: 17
            }, void 0), u$1("div", {
              className: "comparison-chart__mobile-filter-group",
              children: u$1("div", {
                className: "details",
                children: [u$1("div", {
                  className: "details__summary flex items-center justify-between gap-2",
                  children: u$1("span", {
                    className: "text-base-xl font-medium",
                    children: "Effective Range"
                  }, void 0, false, {
                    fileName: _jsxFileName$a,
                    lineNumber: 420,
                    columnNumber: 23
                  }, void 0)
                }, void 0, false, {
                  fileName: _jsxFileName$a,
                  lineNumber: 419,
                  columnNumber: 21
                }, void 0), u$1("div", {
                  className: "details__content",
                  children: u$1("div", {
                    className: "comparison-chart__mobile-multiselect-container",
                    ref: effectiveRangeDropdownRef,
                    children: [u$1("button", {
                      className: "comparison-chart__mobile-multiselect-button",
                      onClick: () => setIsEffectiveRangeDropdownOpen(!isEffectiveRangeDropdownOpen),
                      children: [u$1("span", {
                        children: selectedFilters.effectiveRange || "Select Range"
                      }, void 0, false, {
                        fileName: _jsxFileName$a,
                        lineNumber: 428,
                        columnNumber: 27
                      }, void 0), u$1("svg", {
                        className: `comparison-chart__mobile-dropdown-arrow ${isEffectiveRangeDropdownOpen ? "comparison-chart__mobile-dropdown-arrow--open" : ""}`,
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24",
                        children: u$1("path", {
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeWidth: 2,
                          d: "M19 9l-7 7-7-7"
                        }, void 0, false, {
                          fileName: _jsxFileName$a,
                          lineNumber: 437,
                          columnNumber: 29
                        }, void 0)
                      }, void 0, false, {
                        fileName: _jsxFileName$a,
                        lineNumber: 431,
                        columnNumber: 27
                      }, void 0)]
                    }, void 0, true, {
                      fileName: _jsxFileName$a,
                      lineNumber: 424,
                      columnNumber: 25
                    }, void 0), isEffectiveRangeDropdownOpen && u$1("div", {
                      className: "comparison-chart__mobile-multiselect-dropdown",
                      children: [u$1("div", {
                        className: "comparison-chart__mobile-multiselect-option",
                        onClick: () => handleEffectiveRangeSelect(""),
                        children: [u$1("span", {
                          className: "comparison-chart__mobile-option-text",
                          children: "Select Range"
                        }, void 0, false, {
                          fileName: _jsxFileName$a,
                          lineNumber: 447,
                          columnNumber: 31
                        }, void 0), !selectedFilters.effectiveRange && u$1("svg", {
                          className: "comparison-chart__mobile-checkmark",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24",
                          children: u$1("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M5 13l4 4L19 7"
                          }, void 0, false, {
                            fileName: _jsxFileName$a,
                            lineNumber: 455,
                            columnNumber: 35
                          }, void 0)
                        }, void 0, false, {
                          fileName: _jsxFileName$a,
                          lineNumber: 449,
                          columnNumber: 33
                        }, void 0)]
                      }, void 0, true, {
                        fileName: _jsxFileName$a,
                        lineNumber: 443,
                        columnNumber: 29
                      }, void 0), frequencies.map((frequency) => u$1("div", {
                        className: "comparison-chart__mobile-multiselect-option",
                        onClick: () => handleEffectiveRangeSelect(frequency),
                        children: [u$1("span", {
                          className: "comparison-chart__mobile-option-text",
                          children: frequency
                        }, void 0, false, {
                          fileName: _jsxFileName$a,
                          lineNumber: 465,
                          columnNumber: 33
                        }, void 0), selectedFilters.effectiveRange === frequency && u$1("svg", {
                          className: "comparison-chart__mobile-checkmark",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24",
                          children: u$1("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M5 13l4 4L19 7"
                          }, void 0, false, {
                            fileName: _jsxFileName$a,
                            lineNumber: 473,
                            columnNumber: 37
                          }, void 0)
                        }, void 0, false, {
                          fileName: _jsxFileName$a,
                          lineNumber: 467,
                          columnNumber: 35
                        }, void 0)]
                      }, frequency, true, {
                        fileName: _jsxFileName$a,
                        lineNumber: 460,
                        columnNumber: 31
                      }, void 0))]
                    }, void 0, true, {
                      fileName: _jsxFileName$a,
                      lineNumber: 442,
                      columnNumber: 27
                    }, void 0)]
                  }, void 0, true, {
                    fileName: _jsxFileName$a,
                    lineNumber: 423,
                    columnNumber: 23
                  }, void 0)
                }, void 0, false, {
                  fileName: _jsxFileName$a,
                  lineNumber: 422,
                  columnNumber: 21
                }, void 0)]
              }, void 0, true, {
                fileName: _jsxFileName$a,
                lineNumber: 418,
                columnNumber: 19
              }, void 0)
            }, void 0, false, {
              fileName: _jsxFileName$a,
              lineNumber: 417,
              columnNumber: 17
            }, void 0), u$1("div", {
              className: "comparison-chart__mobile-filter-group",
              children: u$1("div", {
                className: "details",
                children: [u$1("div", {
                  className: "details__summary flex items-center justify-between gap-2",
                  children: u$1("span", {
                    className: "text-base-xl font-medium",
                    children: "Thickness"
                  }, void 0, false, {
                    fileName: _jsxFileName$a,
                    lineNumber: 489,
                    columnNumber: 23
                  }, void 0)
                }, void 0, false, {
                  fileName: _jsxFileName$a,
                  lineNumber: 488,
                  columnNumber: 21
                }, void 0), u$1("div", {
                  className: "details__content",
                  children: u$1("div", {
                    className: "comparison-chart__mobile-multiselect-container",
                    ref: thicknessDropdownRef,
                    children: [u$1("button", {
                      className: "comparison-chart__mobile-multiselect-button",
                      onClick: () => setIsThicknessDropdownOpen(!isThicknessDropdownOpen),
                      children: [u$1("span", {
                        children: selectedFilters.thickness || "Select Thickness"
                      }, void 0, false, {
                        fileName: _jsxFileName$a,
                        lineNumber: 497,
                        columnNumber: 27
                      }, void 0), u$1("svg", {
                        className: `comparison-chart__mobile-dropdown-arrow ${isThicknessDropdownOpen ? "comparison-chart__mobile-dropdown-arrow--open" : ""}`,
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24",
                        children: u$1("path", {
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeWidth: 2,
                          d: "M19 9l-7 7-7-7"
                        }, void 0, false, {
                          fileName: _jsxFileName$a,
                          lineNumber: 506,
                          columnNumber: 29
                        }, void 0)
                      }, void 0, false, {
                        fileName: _jsxFileName$a,
                        lineNumber: 500,
                        columnNumber: 27
                      }, void 0)]
                    }, void 0, true, {
                      fileName: _jsxFileName$a,
                      lineNumber: 493,
                      columnNumber: 25
                    }, void 0), isThicknessDropdownOpen && u$1("div", {
                      className: "comparison-chart__mobile-multiselect-dropdown",
                      children: [u$1("div", {
                        className: "comparison-chart__mobile-multiselect-option",
                        onClick: () => handleThicknessSelect(""),
                        children: [u$1("span", {
                          className: "comparison-chart__mobile-option-text",
                          children: "Select Thickness"
                        }, void 0, false, {
                          fileName: _jsxFileName$a,
                          lineNumber: 516,
                          columnNumber: 31
                        }, void 0), !selectedFilters.thickness && u$1("svg", {
                          className: "comparison-chart__mobile-checkmark",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24",
                          children: u$1("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M5 13l4 4L19 7"
                          }, void 0, false, {
                            fileName: _jsxFileName$a,
                            lineNumber: 524,
                            columnNumber: 35
                          }, void 0)
                        }, void 0, false, {
                          fileName: _jsxFileName$a,
                          lineNumber: 518,
                          columnNumber: 33
                        }, void 0)]
                      }, void 0, true, {
                        fileName: _jsxFileName$a,
                        lineNumber: 512,
                        columnNumber: 29
                      }, void 0), thicknesses.map((thickness) => u$1("div", {
                        className: "comparison-chart__mobile-multiselect-option",
                        onClick: () => handleThicknessSelect(thickness),
                        children: [u$1("span", {
                          className: "comparison-chart__mobile-option-text",
                          children: thickness
                        }, void 0, false, {
                          fileName: _jsxFileName$a,
                          lineNumber: 534,
                          columnNumber: 33
                        }, void 0), selectedFilters.thickness === thickness && u$1("svg", {
                          className: "comparison-chart__mobile-checkmark",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24",
                          children: u$1("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M5 13l4 4L19 7"
                          }, void 0, false, {
                            fileName: _jsxFileName$a,
                            lineNumber: 542,
                            columnNumber: 37
                          }, void 0)
                        }, void 0, false, {
                          fileName: _jsxFileName$a,
                          lineNumber: 536,
                          columnNumber: 35
                        }, void 0)]
                      }, thickness, true, {
                        fileName: _jsxFileName$a,
                        lineNumber: 529,
                        columnNumber: 31
                      }, void 0))]
                    }, void 0, true, {
                      fileName: _jsxFileName$a,
                      lineNumber: 511,
                      columnNumber: 27
                    }, void 0)]
                  }, void 0, true, {
                    fileName: _jsxFileName$a,
                    lineNumber: 492,
                    columnNumber: 23
                  }, void 0)
                }, void 0, false, {
                  fileName: _jsxFileName$a,
                  lineNumber: 491,
                  columnNumber: 21
                }, void 0)]
              }, void 0, true, {
                fileName: _jsxFileName$a,
                lineNumber: 487,
                columnNumber: 19
              }, void 0)
            }, void 0, false, {
              fileName: _jsxFileName$a,
              lineNumber: 486,
              columnNumber: 17
            }, void 0)]
          }, void 0, true, {
            fileName: _jsxFileName$a,
            lineNumber: 358,
            columnNumber: 15
          }, void 0), u$1("div", {
            className: "drawer__sticky",
            children: u$1("button", {
              className: "button button--primary w-full",
              type: "button",
              is: "hover-button",
              onClick: handleApplyFilters,
              "aria-controls": "ComparisonDrawer",
              "aria-expanded": isDrawerOpen,
              children: [u$1("span", {
                className: "btn-fill",
                "data-fill": true
              }, void 0, false, {
                fileName: _jsxFileName$a,
                lineNumber: 565,
                columnNumber: 19
              }, void 0), u$1("span", {
                className: "btn-text flex gap-1",
                children: ["Apply Filters", getTotalFilterCount() > 0 && u$1("span", {
                  className: "comparison-chart__mobile-filter-count block",
                  children: getTotalFilterCount()
                }, void 0, false, {
                  fileName: _jsxFileName$a,
                  lineNumber: 569,
                  columnNumber: 23
                }, void 0)]
              }, void 0, true, {
                fileName: _jsxFileName$a,
                lineNumber: 566,
                columnNumber: 19
              }, void 0), u$1("span", {
                className: "btn-loader",
                children: [u$1("span", {}, void 0, false, {
                  fileName: _jsxFileName$a,
                  lineNumber: 575,
                  columnNumber: 21
                }, void 0), u$1("span", {}, void 0, false, {
                  fileName: _jsxFileName$a,
                  lineNumber: 576,
                  columnNumber: 21
                }, void 0), u$1("span", {}, void 0, false, {
                  fileName: _jsxFileName$a,
                  lineNumber: 577,
                  columnNumber: 21
                }, void 0)]
              }, void 0, true, {
                fileName: _jsxFileName$a,
                lineNumber: 574,
                columnNumber: 19
              }, void 0)]
            }, void 0, true, {
              fileName: _jsxFileName$a,
              lineNumber: 557,
              columnNumber: 17
            }, void 0)
          }, void 0, false, {
            fileName: _jsxFileName$a,
            lineNumber: 556,
            columnNumber: 15
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName$a,
          lineNumber: 357,
          columnNumber: 13
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$a,
        lineNumber: 311,
        columnNumber: 11
      }, void 0)]
    }, void 0, true, {
      fileName: _jsxFileName$a,
      lineNumber: 269,
      columnNumber: 9
    }, void 0)]
  }, void 0);
};
var _jsxFileName$9 = "/home/runner/work/GIK2024_GIK/GIK2024_GIK/src/components/ComparisonTool/ComparisonFilters.tsx";
const ComparisonFilters = ({
  selectedFilters,
  onFiltersChange,
  parsedMetaobjects,
  productData,
  getProductName: getProductName2,
  onClearFilters
}) => {
  const [isCompareDropdownOpen, setIsCompareDropdownOpen] = t$3(d(false), "isCompareDropdownOpen");
  const [isEffectiveRangeDropdownOpen, setIsEffectiveRangeDropdownOpen] = t$3(d(false), "isEffectiveRangeDropdownOpen");
  const [isThicknessDropdownOpen, setIsThicknessDropdownOpen] = t$3(d(false), "isThicknessDropdownOpen");
  const dropdownRef = t$3(A$1(null), "dropdownRef");
  const effectiveRangeDropdownRef = t$3(A$1(null), "effectiveRangeDropdownRef");
  const thicknessDropdownRef = t$3(A$1(null), "thicknessDropdownRef");
  y(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsCompareDropdownOpen(false);
      }
      if (effectiveRangeDropdownRef.current && !effectiveRangeDropdownRef.current.contains(event.target)) {
        setIsEffectiveRangeDropdownOpen(false);
      }
      if (thicknessDropdownRef.current && !thicknessDropdownRef.current.contains(event.target)) {
        setIsThicknessDropdownOpen(false);
      }
    };
    if (isCompareDropdownOpen || isEffectiveRangeDropdownOpen || isThicknessDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [isCompareDropdownOpen, isEffectiveRangeDropdownOpen, isThicknessDropdownOpen]);
  const getUniqueValues2 = () => {
    if (!Array.isArray(parsedMetaobjects) || parsedMetaobjects.length === 0) {
      return {
        frequencies: [],
        thicknesses: [],
        productTitles: []
      };
    }
    const frequencies2 = Array.from(new Set(parsedMetaobjects.map((item) => item.lowest_frequency).filter((freq) => freq && freq !== "N/A").map((freq) => String(freq).trim()))).sort((a2, b2) => {
      const numA = parseInt(String(a2).replace(/[^\d]/g, "")) || 0;
      const numB = parseInt(String(b2).replace(/[^\d]/g, "")) || 0;
      return numA - numB;
    });
    const thicknesses2 = Array.from(new Set(parsedMetaobjects.map((item) => item.thickness).filter((thickness) => thickness && thickness !== "N/A").map((thickness) => String(thickness).trim()))).sort((a2, b2) => {
      const numA = parseFloat(String(a2).replace(/[^\d.]/g, "")) || 0;
      const numB = parseFloat(String(b2).replace(/[^\d.]/g, "")) || 0;
      return numA - numB;
    });
    const productTitles2 = Array.from(new Set(parsedMetaobjects.map((item, index) => getProductName2(item.product, index)).filter((title) => title && title !== "N/A"))).sort();
    return {
      frequencies: frequencies2,
      thicknesses: thicknesses2,
      productTitles: productTitles2
    };
  };
  const {
    frequencies,
    thicknesses,
    productTitles
  } = getUniqueValues2();
  const handleFilterChange = (filterType, value) => {
    if (filterType === "selectedProducts") {
      const currentSelected = selectedFilters.selectedProducts;
      const newSelected = currentSelected.includes(value) ? currentSelected.filter((item) => item !== value) : [...currentSelected, value];
      onFiltersChange({
        ...selectedFilters,
        selectedProducts: newSelected
      });
    } else {
      onFiltersChange({
        ...selectedFilters,
        [filterType]: value
      });
    }
  };
  const handleProductToggle = (productTitle) => {
    handleFilterChange("selectedProducts", productTitle);
  };
  const handleEffectiveRangeSelect = (frequency) => {
    handleFilterChange("effectiveRange", frequency);
    setIsEffectiveRangeDropdownOpen(false);
  };
  const handleThicknessSelect = (thickness) => {
    handleFilterChange("thickness", thickness);
    setIsThicknessDropdownOpen(false);
  };
  const handleClearFilters = () => {
    setIsCompareDropdownOpen(false);
    setIsEffectiveRangeDropdownOpen(false);
    setIsThicknessDropdownOpen(false);
    onClearFilters();
  };
  return u$1("div", {
    className: "comparison-chart__filters",
    children: [u$1("div", {
      className: "comparison-chart__mobile-filters",
      children: u$1(ComparisonMobileFilters, {
        selectedFilters,
        onFiltersChange,
        parsedMetaobjects,
        productData,
        getProductName: getProductName2,
        onClearFilters
      }, void 0, false, {
        fileName: _jsxFileName$9,
        lineNumber: 158,
        columnNumber: 9
      }, void 0)
    }, void 0, false, {
      fileName: _jsxFileName$9,
      lineNumber: 157,
      columnNumber: 7
    }, void 0), u$1("div", {
      className: "comparison-chart__desktop-filters",
      children: [u$1("div", {
        className: "comparison-chart__multiselect-container",
        ref: dropdownRef,
        children: [u$1("button", {
          className: "comparison-chart__multiselect-button",
          onClick: () => setIsCompareDropdownOpen(!isCompareDropdownOpen),
          children: [u$1("span", {
            children: selectedFilters.selectedProducts.length === 0 ? "Compare Products" : `${selectedFilters.selectedProducts.length} selected`
          }, void 0, false, {
            fileName: _jsxFileName$9,
            lineNumber: 176,
            columnNumber: 13
          }, void 0), u$1("svg", {
            className: `comparison-chart__dropdown-arrow ${isCompareDropdownOpen ? "comparison-chart__dropdown-arrow--open" : ""}`,
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            children: u$1("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 2,
              d: "M19 9l-7 7-7-7"
            }, void 0, false, {
              fileName: _jsxFileName$9,
              lineNumber: 188,
              columnNumber: 15
            }, void 0)
          }, void 0, false, {
            fileName: _jsxFileName$9,
            lineNumber: 182,
            columnNumber: 13
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName$9,
          lineNumber: 172,
          columnNumber: 11
        }, void 0), isCompareDropdownOpen && u$1("div", {
          className: "comparison-chart__multiselect-dropdown",
          children: productTitles.map((productTitle) => u$1("div", {
            className: "comparison-chart__multiselect-option",
            onClick: () => handleProductToggle(productTitle),
            children: [u$1("span", {
              className: "comparison-chart__option-text",
              children: productTitle
            }, void 0, false, {
              fileName: _jsxFileName$9,
              lineNumber: 200,
              columnNumber: 19
            }, void 0), selectedFilters.selectedProducts.includes(productTitle) && u$1("svg", {
              className: "comparison-chart__checkmark",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24",
              children: u$1("path", {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M5 13l4 4L19 7"
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 208,
                columnNumber: 23
              }, void 0)
            }, void 0, false, {
              fileName: _jsxFileName$9,
              lineNumber: 202,
              columnNumber: 21
            }, void 0)]
          }, productTitle, true, {
            fileName: _jsxFileName$9,
            lineNumber: 195,
            columnNumber: 17
          }, void 0))
        }, void 0, false, {
          fileName: _jsxFileName$9,
          lineNumber: 193,
          columnNumber: 13
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$9,
        lineNumber: 171,
        columnNumber: 9
      }, void 0), u$1("div", {
        className: "comparison-chart__multiselect-container",
        ref: effectiveRangeDropdownRef,
        children: [u$1("button", {
          className: "comparison-chart__multiselect-button",
          onClick: () => setIsEffectiveRangeDropdownOpen(!isEffectiveRangeDropdownOpen),
          children: [u$1("span", {
            children: selectedFilters.effectiveRange || "Effective Range"
          }, void 0, false, {
            fileName: _jsxFileName$9,
            lineNumber: 222,
            columnNumber: 13
          }, void 0), u$1("svg", {
            className: `comparison-chart__dropdown-arrow ${isEffectiveRangeDropdownOpen ? "comparison-chart__dropdown-arrow--open" : ""}`,
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            children: u$1("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 2,
              d: "M19 9l-7 7-7-7"
            }, void 0, false, {
              fileName: _jsxFileName$9,
              lineNumber: 231,
              columnNumber: 15
            }, void 0)
          }, void 0, false, {
            fileName: _jsxFileName$9,
            lineNumber: 225,
            columnNumber: 13
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName$9,
          lineNumber: 218,
          columnNumber: 11
        }, void 0), isEffectiveRangeDropdownOpen && u$1("div", {
          className: "comparison-chart__multiselect-dropdown",
          children: [u$1("div", {
            className: "comparison-chart__multiselect-option",
            onClick: () => handleEffectiveRangeSelect(""),
            children: [u$1("span", {
              className: "comparison-chart__option-text",
              children: "Effective Range"
            }, void 0, false, {
              fileName: _jsxFileName$9,
              lineNumber: 241,
              columnNumber: 17
            }, void 0), !selectedFilters.effectiveRange && u$1("svg", {
              className: "comparison-chart__checkmark",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24",
              children: u$1("path", {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M5 13l4 4L19 7"
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 249,
                columnNumber: 21
              }, void 0)
            }, void 0, false, {
              fileName: _jsxFileName$9,
              lineNumber: 243,
              columnNumber: 19
            }, void 0)]
          }, void 0, true, {
            fileName: _jsxFileName$9,
            lineNumber: 237,
            columnNumber: 15
          }, void 0), frequencies.map((frequency) => u$1("div", {
            className: "comparison-chart__multiselect-option",
            onClick: () => handleEffectiveRangeSelect(frequency),
            children: [u$1("span", {
              className: "comparison-chart__option-text",
              children: frequency
            }, void 0, false, {
              fileName: _jsxFileName$9,
              lineNumber: 259,
              columnNumber: 19
            }, void 0), selectedFilters.effectiveRange === frequency && u$1("svg", {
              className: "comparison-chart__checkmark",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24",
              children: u$1("path", {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M5 13l4 4L19 7"
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 267,
                columnNumber: 23
              }, void 0)
            }, void 0, false, {
              fileName: _jsxFileName$9,
              lineNumber: 261,
              columnNumber: 21
            }, void 0)]
          }, frequency, true, {
            fileName: _jsxFileName$9,
            lineNumber: 254,
            columnNumber: 17
          }, void 0))]
        }, void 0, true, {
          fileName: _jsxFileName$9,
          lineNumber: 236,
          columnNumber: 13
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$9,
        lineNumber: 217,
        columnNumber: 9
      }, void 0), u$1("div", {
        className: "comparison-chart__multiselect-container",
        ref: thicknessDropdownRef,
        children: [u$1("button", {
          className: "comparison-chart__multiselect-button",
          onClick: () => setIsThicknessDropdownOpen(!isThicknessDropdownOpen),
          children: [u$1("span", {
            children: selectedFilters.thickness || "Thickness"
          }, void 0, false, {
            fileName: _jsxFileName$9,
            lineNumber: 281,
            columnNumber: 13
          }, void 0), u$1("svg", {
            className: `comparison-chart__dropdown-arrow ${isThicknessDropdownOpen ? "comparison-chart__dropdown-arrow--open" : ""}`,
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            children: u$1("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 2,
              d: "M19 9l-7 7-7-7"
            }, void 0, false, {
              fileName: _jsxFileName$9,
              lineNumber: 290,
              columnNumber: 15
            }, void 0)
          }, void 0, false, {
            fileName: _jsxFileName$9,
            lineNumber: 284,
            columnNumber: 13
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName$9,
          lineNumber: 277,
          columnNumber: 11
        }, void 0), isThicknessDropdownOpen && u$1("div", {
          className: "comparison-chart__multiselect-dropdown",
          children: [u$1("div", {
            className: "comparison-chart__multiselect-option",
            onClick: () => handleThicknessSelect(""),
            children: [u$1("span", {
              className: "comparison-chart__option-text",
              children: "Thickness"
            }, void 0, false, {
              fileName: _jsxFileName$9,
              lineNumber: 300,
              columnNumber: 17
            }, void 0), !selectedFilters.thickness && u$1("svg", {
              className: "comparison-chart__checkmark",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24",
              children: u$1("path", {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M5 13l4 4L19 7"
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 308,
                columnNumber: 21
              }, void 0)
            }, void 0, false, {
              fileName: _jsxFileName$9,
              lineNumber: 302,
              columnNumber: 19
            }, void 0)]
          }, void 0, true, {
            fileName: _jsxFileName$9,
            lineNumber: 296,
            columnNumber: 15
          }, void 0), thicknesses.map((thickness) => u$1("div", {
            className: "comparison-chart__multiselect-option",
            onClick: () => handleThicknessSelect(thickness),
            children: [u$1("span", {
              className: "comparison-chart__option-text",
              children: thickness
            }, void 0, false, {
              fileName: _jsxFileName$9,
              lineNumber: 318,
              columnNumber: 19
            }, void 0), selectedFilters.thickness === thickness && u$1("svg", {
              className: "comparison-chart__checkmark",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24",
              children: u$1("path", {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M5 13l4 4L19 7"
              }, void 0, false, {
                fileName: _jsxFileName$9,
                lineNumber: 326,
                columnNumber: 23
              }, void 0)
            }, void 0, false, {
              fileName: _jsxFileName$9,
              lineNumber: 320,
              columnNumber: 21
            }, void 0)]
          }, thickness, true, {
            fileName: _jsxFileName$9,
            lineNumber: 313,
            columnNumber: 17
          }, void 0))]
        }, void 0, true, {
          fileName: _jsxFileName$9,
          lineNumber: 295,
          columnNumber: 13
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$9,
        lineNumber: 276,
        columnNumber: 9
      }, void 0), u$1("button", {
        className: "comparison-chart__clear-button",
        onClick: handleClearFilters,
        children: "Clear Filters"
      }, void 0, false, {
        fileName: _jsxFileName$9,
        lineNumber: 335,
        columnNumber: 9
      }, void 0)]
    }, void 0, true, {
      fileName: _jsxFileName$9,
      lineNumber: 169,
      columnNumber: 7
    }, void 0)]
  }, void 0, true, {
    fileName: _jsxFileName$9,
    lineNumber: 155,
    columnNumber: 5
  }, void 0);
};
var _jsxFileName$8 = "/home/runner/work/GIK2024_GIK/GIK2024_GIK/src/components/ComparisonTool/ComparisonActions.tsx";
const ComparisonActions = ({
  onColumnsChange,
  onExport,
  onPrint
}) => {
  const availableColumns = [{
    key: "fire_rated",
    label: "Fire Rated"
  }, {
    key: "absorber",
    label: "Absorber"
  }, {
    key: "thickness",
    label: "Thickness"
  }, {
    key: "lowest_frequency",
    label: "Lowest Frequency"
  }, {
    key: "bass_control",
    label: "Bass Control"
  }, {
    key: "backing_type",
    label: "Backing Type"
  }, {
    key: "custom_sizes",
    label: "Custom Sizes"
  }, {
    key: "diffuser",
    label: "Diffuser"
  }, {
    key: "fits_in_corners",
    label: "Fits in Corners"
  }, {
    key: "free_standing",
    label: "Free Standing"
  }, {
    key: "mounting_hardware",
    label: "Mounting Hardware"
  }, {
    key: "stocked_fabrics",
    label: "Stocked Fabrics"
  }, {
    key: "variety_of_sizes",
    label: "Variety of Sizes"
  }, {
    key: "wall_mountable",
    label: "Wall Mountable"
  }];
  const [isColumnsDropdownOpen, setIsColumnsDropdownOpen] = t$3(d(false), "isColumnsDropdownOpen");
  const [isExportDropdownOpen, setIsExportDropdownOpen] = t$3(d(false), "isExportDropdownOpen");
  const [selectedColumns, setSelectedColumns] = t$3(d(availableColumns.map((col) => col.key)), "selectedColumns");
  const columnsDropdownRef = t$3(A$1(null), "columnsDropdownRef");
  const exportDropdownRef = t$3(A$1(null), "exportDropdownRef");
  y(() => {
    const handleClickOutside = (event) => {
      if (columnsDropdownRef.current && !columnsDropdownRef.current.contains(event.target)) {
        setIsColumnsDropdownOpen(false);
      }
      if (exportDropdownRef.current && !exportDropdownRef.current.contains(event.target)) {
        setIsExportDropdownOpen(false);
      }
    };
    if (isColumnsDropdownOpen || isExportDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [isColumnsDropdownOpen, isExportDropdownOpen]);
  y(() => {
    if (onColumnsChange) {
      onColumnsChange(selectedColumns);
    }
  }, []);
  const handleColumnToggle = (columnKey) => {
    const newSelectedColumns = selectedColumns.includes(columnKey) ? selectedColumns.filter((key) => key !== columnKey) : [...selectedColumns, columnKey];
    setSelectedColumns(newSelectedColumns);
    if (onColumnsChange) {
      onColumnsChange(newSelectedColumns);
    }
  };
  const handleExportSelect = (value) => {
    if (value && onExport) {
      onExport(value);
    }
    setIsExportDropdownOpen(false);
  };
  const handlePrint = () => {
    if (onPrint) {
      onPrint();
    } else {
      window.print();
    }
  };
  return u$1("div", {
    className: "comparison-chart__secondary-controls",
    children: [u$1("div", {
      className: "comparison-chart__mobile-multiselect-container",
      ref: columnsDropdownRef,
      children: [u$1("button", {
        className: "comparison-chart__mobile-multiselect-button",
        onClick: () => setIsColumnsDropdownOpen(!isColumnsDropdownOpen),
        style: {
          minWidth: "auto",
          width: "auto"
        },
        children: [u$1("span", {
          children: "Columns"
        }, void 0, false, {
          fileName: _jsxFileName$8,
          lineNumber: 103,
          columnNumber: 11
        }, void 0), u$1("svg", {
          className: `comparison-chart__mobile-dropdown-arrow ${isColumnsDropdownOpen ? "comparison-chart__mobile-dropdown-arrow--open" : ""}`,
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24",
          children: u$1("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M19 9l-7 7-7-7"
          }, void 0, false, {
            fileName: _jsxFileName$8,
            lineNumber: 110,
            columnNumber: 13
          }, void 0)
        }, void 0, false, {
          fileName: _jsxFileName$8,
          lineNumber: 104,
          columnNumber: 11
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$8,
        lineNumber: 98,
        columnNumber: 9
      }, void 0), isColumnsDropdownOpen && u$1("div", {
        className: "comparison-chart__mobile-multiselect-dropdown",
        children: availableColumns.map((column) => u$1("div", {
          className: "comparison-chart__mobile-multiselect-option",
          onClick: () => handleColumnToggle(column.key),
          children: [u$1("span", {
            className: "comparison-chart__mobile-option-text",
            children: column.label
          }, void 0, false, {
            fileName: _jsxFileName$8,
            lineNumber: 122,
            columnNumber: 17
          }, void 0), selectedColumns.includes(column.key) && u$1("svg", {
            className: "comparison-chart__mobile-checkmark",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            children: u$1("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 2,
              d: "M5 13l4 4L19 7"
            }, void 0, false, {
              fileName: _jsxFileName$8,
              lineNumber: 130,
              columnNumber: 21
            }, void 0)
          }, void 0, false, {
            fileName: _jsxFileName$8,
            lineNumber: 124,
            columnNumber: 19
          }, void 0)]
        }, column.key, true, {
          fileName: _jsxFileName$8,
          lineNumber: 117,
          columnNumber: 15
        }, void 0))
      }, void 0, false, {
        fileName: _jsxFileName$8,
        lineNumber: 115,
        columnNumber: 11
      }, void 0)]
    }, void 0, true, {
      fileName: _jsxFileName$8,
      lineNumber: 97,
      columnNumber: 7
    }, void 0), u$1("div", {
      className: "comparison-chart__mobile-multiselect-container",
      ref: exportDropdownRef,
      children: [u$1("button", {
        className: "comparison-chart__mobile-multiselect-button",
        onClick: () => setIsExportDropdownOpen(!isExportDropdownOpen),
        style: {
          minWidth: "auto",
          width: "auto"
        },
        children: [u$1("span", {
          children: "Export"
        }, void 0, false, {
          fileName: _jsxFileName$8,
          lineNumber: 146,
          columnNumber: 11
        }, void 0), u$1("svg", {
          className: `comparison-chart__mobile-dropdown-arrow ${isExportDropdownOpen ? "comparison-chart__mobile-dropdown-arrow--open" : ""}`,
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24",
          children: u$1("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M19 9l-7 7-7-7"
          }, void 0, false, {
            fileName: _jsxFileName$8,
            lineNumber: 153,
            columnNumber: 13
          }, void 0)
        }, void 0, false, {
          fileName: _jsxFileName$8,
          lineNumber: 147,
          columnNumber: 11
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$8,
        lineNumber: 141,
        columnNumber: 9
      }, void 0), isExportDropdownOpen && u$1("div", {
        className: "comparison-chart__mobile-multiselect-dropdown",
        children: [u$1("div", {
          className: "comparison-chart__mobile-multiselect-option",
          onClick: () => handleExportSelect("csv"),
          children: u$1("span", {
            className: "comparison-chart__mobile-option-text",
            children: "Export as CSV"
          }, void 0, false, {
            fileName: _jsxFileName$8,
            lineNumber: 163,
            columnNumber: 15
          }, void 0)
        }, void 0, false, {
          fileName: _jsxFileName$8,
          lineNumber: 159,
          columnNumber: 13
        }, void 0), u$1("div", {
          className: "comparison-chart__mobile-multiselect-option",
          onClick: () => handleExportSelect("pdf"),
          children: u$1("span", {
            className: "comparison-chart__mobile-option-text",
            children: "Export as PDF"
          }, void 0, false, {
            fileName: _jsxFileName$8,
            lineNumber: 169,
            columnNumber: 15
          }, void 0)
        }, void 0, false, {
          fileName: _jsxFileName$8,
          lineNumber: 165,
          columnNumber: 13
        }, void 0), u$1("div", {
          className: "comparison-chart__mobile-multiselect-option",
          onClick: () => handleExportSelect("excel"),
          children: u$1("span", {
            className: "comparison-chart__mobile-option-text",
            children: "Export as Excel"
          }, void 0, false, {
            fileName: _jsxFileName$8,
            lineNumber: 175,
            columnNumber: 15
          }, void 0)
        }, void 0, false, {
          fileName: _jsxFileName$8,
          lineNumber: 171,
          columnNumber: 13
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$8,
        lineNumber: 158,
        columnNumber: 11
      }, void 0)]
    }, void 0, true, {
      fileName: _jsxFileName$8,
      lineNumber: 140,
      columnNumber: 7
    }, void 0), u$1("button", {
      className: "comparison-chart__print-button",
      onClick: handlePrint,
      children: "Print"
    }, void 0, false, {
      fileName: _jsxFileName$8,
      lineNumber: 182,
      columnNumber: 7
    }, void 0)]
  }, void 0, true, {
    fileName: _jsxFileName$8,
    lineNumber: 95,
    columnNumber: 5
  }, void 0);
};
const getProductName = (product, index, productData) => {
  if (typeof product === "string" && product.includes("Product/")) {
    const productInfo = productData[product];
    if (productInfo && productInfo.title) {
      return productInfo.title;
    }
    const productId = product.split("Product/")[1];
    return `Product ${productId.slice(-4)}`;
  }
  return `Product ${index + 1}`;
};
const getProductHandle = (product, productData) => {
  if (typeof product === "string" && product.includes("Product/")) {
    const productInfo = productData[product];
    return (productInfo == null ? void 0 : productInfo.handle) || null;
  }
  return null;
};
const getProductImage = (product, productData) => {
  if (typeof product === "string" && product.includes("Product/")) {
    const productInfo = productData[product];
    return (productInfo == null ? void 0 : productInfo.featuredImage) || null;
  }
  return null;
};
const formatBooleanValue = (value) => {
  if (typeof value === "boolean") {
    return value ? "Yes" : "No";
  }
  if (typeof value === "string") {
    if (value.toLowerCase() === "true") return "Yes";
    if (value.toLowerCase() === "false") return "No";
  }
  return value || "N/A";
};
const getUniqueValues = (parsedMetaobjects, productData) => {
  if (!Array.isArray(parsedMetaobjects) || parsedMetaobjects.length === 0) {
    return {
      frequencies: [],
      thicknesses: [],
      productTitles: []
    };
  }
  const frequencies = Array.from(new Set(parsedMetaobjects.map((item) => item.lowest_frequency).filter((freq) => freq && freq !== "N/A").map((freq) => String(freq).trim()))).sort((a2, b2) => {
    const numA = parseInt(String(a2).replace(/[^\d]/g, "")) || 0;
    const numB = parseInt(String(b2).replace(/[^\d]/g, "")) || 0;
    return numA - numB;
  });
  const thicknesses = Array.from(new Set(parsedMetaobjects.map((item) => item.thickness).filter((thickness) => thickness && thickness !== "N/A").map((thickness) => String(thickness).trim()))).sort((a2, b2) => {
    const numA = parseFloat(String(a2).replace(/[^\d.]/g, "")) || 0;
    const numB = parseFloat(String(b2).replace(/[^\d.]/g, "")) || 0;
    return numA - numB;
  });
  const productTitles = Array.from(new Set(parsedMetaobjects.map((item, index) => getProductName(item.product, index, productData)).filter((title) => title && title !== "N/A"))).sort();
  return {
    frequencies,
    thicknesses,
    productTitles
  };
};
const parseFrequency = (frequency) => {
  if (!frequency) return 0;
  const numericValue = frequency.toString().replace(/[^\d.]/g, "");
  return parseFloat(numericValue) || 0;
};
const sortByFrequency = (data, sortOrder) => {
  if (sortOrder === null) {
    return data;
  }
  const sortedData = [...data];
  sortedData.sort((a2, b2) => {
    const freqA = parseFrequency(a2.lowest_frequency);
    const freqB = parseFrequency(b2.lowest_frequency);
    if (sortOrder === "asc") {
      return freqA - freqB;
    } else {
      return freqB - freqA;
    }
  });
  return sortedData;
};
const exportToCSV = (data) => {
  if (data.length === 0) return;
  try {
    const headers = Object.keys(data[0]);
    const csvContent = [headers.join(","), ...data.map((row) => headers.map((header) => {
      const cell = row[header];
      if (typeof cell === "string" && (cell.includes(",") || cell.includes('"') || cell.includes("\n"))) {
        return `"${cell.replace(/"/g, '""')}"`;
      }
      return cell;
    }).join(","))].join("\n");
    const BOM = "\uFEFF";
    const csvData = BOM + csvContent;
    const blob = new Blob([csvData], {
      type: "text/csv;charset=utf-8;"
    });
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, "product-comparison.csv");
    } else {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", "product-comparison.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      setTimeout(() => {
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
    }
    console.log("CSV export completed successfully");
  } catch (error) {
    console.error("Error exporting CSV:", error);
    alert("Error exporting CSV file. Please try again.");
  }
};
const exportToExcel = (data) => {
  if (data.length === 0) return;
  try {
    const headers = Object.keys(data[0]);
    const tsvContent = [
      // Header row
      headers.join("	"),
      // Data rows
      ...data.map((row) => headers.map((header) => {
        const cell = row[header];
        if (typeof cell === "string") {
          return cell.replace(/\t/g, " ").replace(/\n/g, " ").replace(/\r/g, " ");
        }
        return cell || "";
      }).join("	"))
    ].join("\n");
    const blob = new Blob([tsvContent], {
      type: "application/vnd.ms-excel;charset=utf-8;"
    });
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, "product-comparison.xls");
    } else {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", "product-comparison.xls");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      setTimeout(() => {
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
    }
    console.log("Excel export completed successfully");
  } catch (error) {
    console.error("Error exporting Excel:", error);
    alert("Error exporting Excel file. Please try again.");
  }
};
const exportToPDF = (data) => {
  if (data.length === 0) return;
  try {
    const headers = Object.keys(data[0]);
    const printWindow = window.open("", "_blank", "width=800,height=600");
    if (!printWindow) {
      alert("Please allow popups for this site to export PDF, or try using the Print button instead.");
      return;
    }
    let htmlContent = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Product Comparison Report</title>
        <meta charset="utf-8">
        <style>
          body { 
            font-family: Arial, sans-serif; 
            margin: 20px;
            background: white;
          }
          h1 { 
            color: #333; 
            margin-bottom: 20px; 
            font-size: 24px;
          }
          .report-info {
            margin-bottom: 20px;
            font-size: 14px;
            color: #666;
          }
          table { 
            border-collapse: collapse; 
            width: 100%; 
            margin-top: 20px;
            font-size: 12px;
          }
          th, td { 
            border: 1px solid #ddd; 
            padding: 8px; 
            text-align: left; 
            vertical-align: top;
          }
          th { 
            background-color: #f2f2f2; 
            font-weight: bold;
            font-size: 11px;
          }
          tr:nth-child(even) { 
            background-color: #f9f9f9; 
          }
          @media print {
            body { margin: 0; }
            table { font-size: 10px; }
            th, td { padding: 4px; }
          }
          @page {
            margin: 1cm;
            size: landscape;
          }
        </style>
      </head>
      <body>
        <h1>Product Comparison Report</h1>
        <div class="report-info">
          <p>Generated on: ${(/* @__PURE__ */ new Date()).toLocaleDateString()}</p>
          <p>Total Products: ${data.length}</p>
        </div>
        <table>
          <thead>
            <tr>`;
    headers.forEach((header) => {
      htmlContent += `<th>${header}</th>`;
    });
    htmlContent += `
            </tr>
          </thead>
          <tbody>`;
    data.forEach((row) => {
      htmlContent += "<tr>";
      headers.forEach((header) => {
        htmlContent += `<td>${row[header]}</td>`;
      });
      htmlContent += "</tr>";
    });
    htmlContent += `
          </tbody>
        </table>
        <script>
          window.onload = function() {
            // Auto-trigger print dialog after content loads
            setTimeout(function() {
              window.print();
            }, 500);
          };
          
          // Close window after printing (user action required)
          window.onafterprint = function() {
            setTimeout(function() {
              window.close();
            }, 1000);
          };
        <\/script>
      </body>
      </html>`;
    printWindow.document.write(htmlContent);
    printWindow.document.close();
    console.log("PDF export window opened successfully");
  } catch (error) {
    console.error("Error exporting PDF:", error);
    alert("Error opening PDF export. Please try using the Print button instead.");
  }
};
const generatePrintWindow = (data) => {
  if (data.length === 0) return null;
  const headers = Object.keys(data[0]);
  const printWindow = window.open("", "_blank", "width=800,height=600");
  if (!printWindow) {
    alert("Please allow popups for this site to print the comparison report.");
    return null;
  }
  let htmlContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>Product Comparison Report</title>
      <meta charset="utf-8">
      <style>
        body { 
          font-family: Arial, sans-serif; 
          margin: 20px;
          background: white;
        }
        h1 { 
          color: #333; 
          margin-bottom: 20px; 
          font-size: 24px;
        }
        .report-info {
          margin-bottom: 20px;
          font-size: 14px;
          color: #666;
        }
        table { 
          border-collapse: collapse; 
          width: 100%; 
          margin-top: 20px;
          font-size: 12px;
        }
        th, td { 
          border: 1px solid #ddd; 
          padding: 8px; 
          text-align: left; 
          vertical-align: top;
        }
        th { 
          background-color: #f2f2f2; 
          font-weight: bold;
          font-size: 11px;
        }
        tr:nth-child(even) { 
          background-color: #f9f9f9; 
        }
        @media print {
          body { margin: 0; }
          table { font-size: 10px; }
          th, td { padding: 4px; }
        }
        @page {
          margin: 1cm;
          size: landscape;
        }
      </style>
    </head>
    <body>
      <h1>Product Comparison Report</h1>
      <div class="report-info">
        <p>Generated on: ${(/* @__PURE__ */ new Date()).toLocaleDateString()}</p>
        <p>Total Products: ${data.length}</p>
      </div>
      <table>
        <thead>
          <tr>`;
  headers.forEach((header) => {
    htmlContent += `<th>${header}</th>`;
  });
  htmlContent += `
          </tr>
        </thead>
        <tbody>`;
  data.forEach((row) => {
    htmlContent += "<tr>";
    headers.forEach((header) => {
      htmlContent += `<td>${row[header]}</td>`;
    });
    htmlContent += "</tr>";
  });
  htmlContent += `
        </tbody>
      </table>
      <script>
        window.onload = function() {
          // Auto-trigger print dialog after content loads
          setTimeout(function() {
            window.print();
          }, 500);
        };
        
        // Close window after printing (user action required)
        window.onafterprint = function() {
          setTimeout(function() {
            window.close();
          }, 1000);
        };
      <\/script>
    </body>
    </html>`;
  printWindow.document.write(htmlContent);
  printWindow.document.close();
  return printWindow;
};
const prepareExportData = (filteredData, selectedColumns, productData) => {
  return filteredData.map((item, index) => {
    var _a;
    const row = {
      "Product Title": getProductName(item.product, index, productData)
    };
    if (selectedColumns.includes("fire_rated")) {
      row["Fire Rated"] = formatBooleanValue(item.fire_rated);
    }
    if (selectedColumns.includes("absorber")) {
      row["Absorber"] = formatBooleanValue(item.absorber);
    }
    if (selectedColumns.includes("thickness")) {
      row["Thickness"] = item.thickness || "N/A";
    }
    if (selectedColumns.includes("lowest_frequency")) {
      row["Lowest Frequency"] = ((_a = item.lowest_frequency) == null ? void 0 : _a.replace(" Hz", "")) || "N/A";
    }
    if (selectedColumns.includes("bass_control")) {
      row["Bass Control"] = formatBooleanValue(item.bass_control);
    }
    if (selectedColumns.includes("backing_type")) {
      row["Backing Type"] = item.backing_type || "N/A";
    }
    if (selectedColumns.includes("custom_sizes")) {
      row["Custom Sizes"] = formatBooleanValue(item.custom_sizes);
    }
    if (selectedColumns.includes("diffuser")) {
      row["Diffuser"] = item.diffuser || "N/A";
    }
    if (selectedColumns.includes("fits_in_corners")) {
      row["Fits in Corners"] = formatBooleanValue(item.fits_in_corners);
    }
    if (selectedColumns.includes("free_standing")) {
      row["Free Standing"] = item.free_standing || "N/A";
    }
    if (selectedColumns.includes("mounting_hardware")) {
      row["Mounting Hardware"] = item.mounting_hardware || "N/A";
    }
    if (selectedColumns.includes("stocked_fabrics")) {
      row["Stocked Fabrics"] = item.stocked_fabrics || "N/A";
    }
    if (selectedColumns.includes("variety_of_sizes")) {
      row["Variety of Sizes"] = formatBooleanValue(item.variety_of_sizes);
    }
    if (selectedColumns.includes("wall_mountable")) {
      row["Wall Mountable"] = formatBooleanValue(item.wall_mountable);
    }
    return row;
  });
};
const getProductData = async (productGid) => {
  var _a, _b, _c, _d;
  const productId = productGid.split("Product/")[1];
  if (!productId) {
    console.warn("Invalid product GID:", productGid);
    return null;
  }
  const query = `
    query getProduct($id: ID!) {
      product(id: $id) {
        id
        handle
        title
        featuredImage {
          id
          url
          altText
          width
          height
        }
        variants(first: 100) {
          nodes {
            id
            title
            price {
              amount
              currencyCode
            }
            availableForSale
            quantityAvailable
            selectedOptions {
              name
              value
            }
          }
        }
      }
    }
  `;
  try {
    const storefrontApiKey = (_b = (_a = window.theme) == null ? void 0 : _a.settings) == null ? void 0 : _b.storefront_api_key;
    const shopDomain = (_d = (_c = window == null ? void 0 : window.theme) == null ? void 0 : _c.routes) == null ? void 0 : _d.shop_url;
    if (!storefrontApiKey || !shopDomain) {
      throw new Error("Storefront API key or shop domain not found");
    }
    const response = await fetch(`${shopDomain}/api/2024-10/graphql.json`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": storefrontApiKey
      },
      body: JSON.stringify({
        query,
        variables: {
          id: productGid
        }
      })
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    if (data.errors) {
      console.error("GraphQL errors:", data.errors);
      return null;
    }
    return data.data.product;
  } catch (error) {
    console.error("Error fetching product data:", error);
    return null;
  }
};
const getProductGidFromExtras = (extras) => {
  if (!extras) return null;
  if (typeof extras === "string") {
    return extras.includes("Product/") ? extras : null;
  }
  if (Array.isArray(extras) && extras.length > 0) {
    const firstExtra = extras[0];
    return firstExtra && firstExtra.includes("Product/") ? firstExtra : null;
  }
  return null;
};
const fetchAllProductData = async (metaobjects, setProductData, setLoadingProducts) => {
  setLoadingProducts(true);
  const productPromises = metaobjects.filter((item) => {
    if ("product" in item && item.product && typeof item.product === "string" && item.product.includes("Product/")) {
      return true;
    }
    if ("extras" in item && item.extras) {
      const productGid = getProductGidFromExtras(item.extras);
      return productGid !== null;
    }
    return false;
  }).map(async (item) => {
    let productGid = null;
    if ("product" in item && item.product) {
      productGid = item.product;
    } else if ("extras" in item) {
      productGid = getProductGidFromExtras(item.extras);
    }
    if (!productGid) return null;
    const productInfo = await getProductData(productGid);
    return {
      gid: productGid,
      data: productInfo
    };
  });
  try {
    const results = await Promise.all(productPromises);
    const productMap = {};
    results.filter((result) => result !== null).forEach(({
      gid,
      data
    }) => {
      if (data) {
        productMap[gid] = data;
      }
    });
    setProductData(productMap);
  } catch (error) {
    console.error("Error fetching product data:", error);
  } finally {
    setLoadingProducts(false);
  }
};
var _jsxFileName$7 = "/home/runner/work/GIK2024_GIK/GIK2024_GIK/src/components/ComparisonTool/ComparisonTool.tsx";
const ComparisonTool = ({
  initialData = null,
  sectionId = null
}) => {
  const [parsedMetaobjects, setParsedMetaobjects] = t$3(d([]), "parsedMetaobjects");
  const [productData, setProductData] = t$3(d({}), "productData");
  const [loadingProducts, setLoadingProducts] = t$3(d(false), "loadingProducts");
  const [searchTerm, setSearchTerm] = t$3(d(""), "searchTerm");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = t$3(d(""), "debouncedSearchTerm");
  const [selectedFilters, setSelectedFilters] = t$3(d({
    selectedProducts: [],
    // Changed to array for multi-select
    effectiveRange: "",
    thickness: ""
  }), "selectedFilters");
  const [selectedColumns, setSelectedColumns] = t$3(d([]), "selectedColumns");
  const [currentPage, setCurrentPage] = t$3(d(1), "currentPage");
  const itemsPerPage = 15;
  const [sortOrder, setSortOrder] = t$3(d(null), "sortOrder");
  const handleSearchChange = q$1((term) => {
    setSearchTerm(term);
  }, []);
  const handleDebouncedSearchChange = q$1((term) => {
    setDebouncedSearchTerm(term);
  }, []);
  const handleFiltersChange = (filters) => {
    setSelectedFilters(filters);
  };
  const handleClearFilters = () => {
    setSelectedFilters({
      selectedProducts: [],
      effectiveRange: "",
      thickness: ""
    });
    setSearchTerm("");
    setDebouncedSearchTerm("");
    setCurrentPage(1);
    setSortOrder(null);
  };
  const handleColumnsChange = (columns) => {
    setSelectedColumns(columns);
  };
  const handleExport = (format) => {
    console.log("Export requested:", format);
    const exportData = prepareExportData(filteredData, selectedColumns, productData);
    if (exportData.length === 0) {
      alert("No data to export. Please ensure there are products in your comparison.");
      return;
    }
    switch (format) {
      case "csv":
        exportToCSV(exportData);
        break;
      case "excel":
        exportToExcel(exportData);
        break;
      case "pdf":
        exportToPDF(exportData);
        break;
      default:
        console.error("Unknown export format:", format);
    }
  };
  const handlePrint = () => {
    try {
      const printData = prepareExportData(filteredData, selectedColumns, productData);
      if (printData.length === 0) {
        alert("No data to print. Please ensure there are products in your comparison.");
        return;
      }
      const printWindow = generatePrintWindow(printData);
      if (printWindow) {
        console.log("Print window opened successfully");
      }
    } catch (error) {
      console.error("Error opening print dialog:", error);
      alert("Error opening print dialog. Please try again.");
    }
  };
  y(() => {
    if (initialData) {
      try {
        let parsedData;
        if (Array.isArray(initialData)) {
          parsedData = initialData;
        } else if (typeof initialData === "string") {
          parsedData = JSON.parse(initialData);
        } else if (typeof initialData === "object") {
          parsedData = initialData;
        }
        if (Array.isArray(parsedData)) {
          setParsedMetaobjects(parsedData);
        } else {
          console.warn("Parsed data is not an array:", parsedData);
          setParsedMetaobjects([]);
        }
      } catch (error) {
        console.error("Error parsing initialData:", error);
        setParsedMetaobjects([]);
      }
    } else {
      setParsedMetaobjects([]);
    }
  }, [initialData]);
  y(() => {
    if (Array.isArray(parsedMetaobjects) && parsedMetaobjects.length > 0) {
      fetchAllProductData(parsedMetaobjects, setProductData, setLoadingProducts);
    }
  }, [parsedMetaobjects]);
  const {
    frequencies,
    thicknesses,
    productTitles
  } = getUniqueValues(parsedMetaobjects, productData);
  const filteredData = Array.isArray(parsedMetaobjects) ? parsedMetaobjects.filter((item) => {
    const matchesSearch = debouncedSearchTerm === "" || (() => {
      const searchLower = debouncedSearchTerm.toLowerCase();
      const productName = getProductName(item.product, parsedMetaobjects.indexOf(item), productData);
      if (productName.toLowerCase().includes(searchLower)) {
        return true;
      }
      const searchableValues = [item.lowest_frequency, item.thickness, item.backing_type, item.diffuser, item.free_standing, item.mounting_hardware, item.stocked_fabrics, formatBooleanValue(item.fire_rated), formatBooleanValue(item.absorber), formatBooleanValue(item.bass_control), formatBooleanValue(item.custom_sizes), formatBooleanValue(item.fits_in_corners), formatBooleanValue(item.variety_of_sizes), formatBooleanValue(item.wall_mountable)];
      return searchableValues.some((value) => {
        if (value && value !== "N/A") {
          return String(value).toLowerCase().includes(searchLower);
        }
        return false;
      });
    })();
    const matchesCompare = selectedFilters.selectedProducts.length === 0 || selectedFilters.selectedProducts.some((selectedProduct) => getProductName(item.product, parsedMetaobjects.indexOf(item), productData) === selectedProduct);
    const matchesEffectiveRange = selectedFilters.effectiveRange === "" || item.lowest_frequency && String(item.lowest_frequency).trim() === selectedFilters.effectiveRange;
    const matchesThickness = selectedFilters.thickness === "" || item.thickness && String(item.thickness).trim() === selectedFilters.thickness;
    return matchesSearch && matchesCompare && matchesEffectiveRange && matchesThickness;
  }) : [];
  const sortedData = sortByFrequency(filteredData, sortOrder);
  const totalPages = Math.ceil(sortedData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentPageData = sortedData.slice(startIndex, endIndex);
  y(() => {
    setCurrentPage(1);
  }, [debouncedSearchTerm, selectedFilters, sortOrder]);
  const handleSortByFrequency = () => {
    if (sortOrder === null) {
      setSortOrder("asc");
    } else if (sortOrder === "asc") {
      setSortOrder("desc");
    } else {
      setSortOrder(null);
    }
  };
  const isColumnVisible = (columnKey) => {
    return selectedColumns.includes(columnKey);
  };
  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  return u$1("div", {
    className: "comparison-chart page-width",
    children: [u$1("div", {
      className: "comparison-chart__controls",
      children: [u$1("div", {
        className: "comparison-chart__header",
        children: [u$1(ComparisonSearch, {
          searchTerm,
          onSearchChange: handleSearchChange,
          onDebouncedSearchChange: handleDebouncedSearchChange
        }, void 0, false, {
          fileName: _jsxFileName$7,
          lineNumber: 269,
          columnNumber: 11
        }, void 0), u$1(ComparisonFilters, {
          selectedFilters,
          onFiltersChange: handleFiltersChange,
          parsedMetaobjects,
          productData,
          getProductName: (product, index) => getProductName(product, index, productData),
          onClearFilters: handleClearFilters
        }, void 0, false, {
          fileName: _jsxFileName$7,
          lineNumber: 275,
          columnNumber: 11
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$7,
        lineNumber: 268,
        columnNumber: 9
      }, void 0), u$1("div", {
        className: "comparison-chart__actions",
        children: u$1(ComparisonActions, {
          onColumnsChange: handleColumnsChange,
          onExport: handleExport,
          onPrint: handlePrint
        }, void 0, false, {
          fileName: _jsxFileName$7,
          lineNumber: 287,
          columnNumber: 11
        }, void 0)
      }, void 0, false, {
        fileName: _jsxFileName$7,
        lineNumber: 286,
        columnNumber: 9
      }, void 0)]
    }, void 0, true, {
      fileName: _jsxFileName$7,
      lineNumber: 266,
      columnNumber: 7
    }, void 0), u$1("div", {
      className: "comparison-chart__table-container",
      children: [loadingProducts && u$1("div", {
        className: "comparison-chart__loading",
        style: {
          textAlign: "center",
          padding: "20px"
        },
        children: "Loading product information..."
      }, void 0, false, {
        fileName: _jsxFileName$7,
        lineNumber: 298,
        columnNumber: 11
      }, void 0), u$1("div", {
        className: "comparison-chart__desktop-table",
        children: u$1("table", {
          className: "comparison-chart__table",
          children: [u$1("thead", {
            children: u$1("tr", {
              className: "comparison-chart__table-header",
              children: [u$1("th", {
                className: "comparison-chart__header-cell",
                children: "Products"
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 308,
                columnNumber: 17
              }, void 0), u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--image",
                children: "Image"
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 309,
                columnNumber: 17
              }, void 0), u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--name",
                children: "Shop"
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 310,
                columnNumber: 17
              }, void 0), isColumnVisible("lowest_frequency") && u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--frequency",
                children: u$1("button", {
                  className: "comparison-chart__sort-button",
                  onClick: handleSortByFrequency,
                  children: ["Lowest Freq.", u$1("svg", {
                    className: "comparison-chart__sort-icon",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24",
                    children: [sortOrder === null && u$1("path", {
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                      strokeWidth: 2,
                      d: "M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"
                    }, void 0, false, {
                      fileName: _jsxFileName$7,
                      lineNumber: 320,
                      columnNumber: 27
                    }, void 0), sortOrder === "asc" && u$1("path", {
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                      strokeWidth: 2,
                      d: "M5 15l7-7 7 7"
                    }, void 0, false, {
                      fileName: _jsxFileName$7,
                      lineNumber: 323,
                      columnNumber: 27
                    }, void 0), sortOrder === "desc" && u$1("path", {
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                      strokeWidth: 2,
                      d: "M19 9l-7 7-7-7"
                    }, void 0, false, {
                      fileName: _jsxFileName$7,
                      lineNumber: 326,
                      columnNumber: 27
                    }, void 0)]
                  }, void 0, true, {
                    fileName: _jsxFileName$7,
                    lineNumber: 318,
                    columnNumber: 23
                  }, void 0)]
                }, void 0, true, {
                  fileName: _jsxFileName$7,
                  lineNumber: 313,
                  columnNumber: 21
                }, void 0)
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 312,
                columnNumber: 19
              }, void 0), isColumnVisible("thickness") && u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--thickness",
                children: "Thickness"
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 333,
                columnNumber: 19
              }, void 0), isColumnVisible("fire_rated") && u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--fire-rated",
                children: "Fire Rated"
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 336,
                columnNumber: 19
              }, void 0), isColumnVisible("absorber") && u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--absorber",
                children: "Absorber"
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 339,
                columnNumber: 19
              }, void 0), isColumnVisible("bass_control") && u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--bass-control",
                children: "Bass Control"
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 342,
                columnNumber: 19
              }, void 0), isColumnVisible("backing_type") && u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--backing-type",
                children: "Backing Type"
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 345,
                columnNumber: 19
              }, void 0), isColumnVisible("custom_sizes") && u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--custom-sizes",
                children: "Custom Sizes"
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 348,
                columnNumber: 19
              }, void 0), isColumnVisible("diffuser") && u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--diffuser",
                children: "Diffuser"
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 351,
                columnNumber: 19
              }, void 0), isColumnVisible("fits_in_corners") && u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--fits-corners",
                children: "Fits in Corners"
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 354,
                columnNumber: 19
              }, void 0), isColumnVisible("free_standing") && u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--free-standing",
                children: "Free Standing"
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 357,
                columnNumber: 19
              }, void 0), isColumnVisible("mounting_hardware") && u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--mounting-hardware",
                children: "Mounting Hardware"
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 360,
                columnNumber: 19
              }, void 0), isColumnVisible("stocked_fabrics") && u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--stocked-fabrics",
                children: "Stocked Fabrics"
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 363,
                columnNumber: 19
              }, void 0), isColumnVisible("variety_of_sizes") && u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--variety-sizes",
                children: "Variety of Sizes"
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 366,
                columnNumber: 19
              }, void 0), isColumnVisible("wall_mountable") && u$1("th", {
                className: "comparison-chart__header-cell comparison-chart__header-cell--wall-mountable",
                children: "Wall Mountable"
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 369,
                columnNumber: 19
              }, void 0)]
            }, void 0, true, {
              fileName: _jsxFileName$7,
              lineNumber: 307,
              columnNumber: 15
            }, void 0)
          }, void 0, false, {
            fileName: _jsxFileName$7,
            lineNumber: 306,
            columnNumber: 13
          }, void 0), u$1("tbody", {
            children: currentPageData.map((item, index) => {
              const productImage = getProductImage(item.product, productData);
              const productHandle = getProductHandle(item.product, productData);
              return u$1("tr", {
                className: "comparison-chart__table-row",
                children: [u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: getProductName(item.product, index, productData)
                }, void 0, false, {
                  fileName: _jsxFileName$7,
                  lineNumber: 380,
                  columnNumber: 21
                }, void 0), u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: u$1("div", {
                    className: "comparison-chart__product-image",
                    children: productImage ? u$1("img", {
                      src: productImage.url,
                      alt: productImage.altText || "Product image",
                      style: {
                        width: "50px",
                        height: "50px",
                        objectFit: "cover"
                      }
                    }, void 0, false, {
                      fileName: _jsxFileName$7,
                      lineNumber: 386,
                      columnNumber: 27
                    }, void 0) : u$1("svg", {
                      className: "comparison-chart__image-icon",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24",
                      children: u$1("path", {
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: 2,
                        d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 002 2v12a2 2 0 002 2z"
                      }, void 0, false, {
                        fileName: _jsxFileName$7,
                        lineNumber: 393,
                        columnNumber: 29
                      }, void 0)
                    }, void 0, false, {
                      fileName: _jsxFileName$7,
                      lineNumber: 392,
                      columnNumber: 27
                    }, void 0)
                  }, void 0, false, {
                    fileName: _jsxFileName$7,
                    lineNumber: 384,
                    columnNumber: 23
                  }, void 0)
                }, void 0, false, {
                  fileName: _jsxFileName$7,
                  lineNumber: 383,
                  columnNumber: 21
                }, void 0), u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: productHandle ? u$1("a", {
                    href: `/products/${productHandle}`,
                    className: "comparison-chart__shop-button",
                    children: "Shop"
                  }, void 0, false, {
                    fileName: _jsxFileName$7,
                    lineNumber: 400,
                    columnNumber: 25
                  }, void 0) : u$1("button", {
                    className: "comparison-chart__shop-button",
                    disabled: true,
                    children: "Shop"
                  }, void 0, false, {
                    fileName: _jsxFileName$7,
                    lineNumber: 407,
                    columnNumber: 25
                  }, void 0)
                }, void 0, false, {
                  fileName: _jsxFileName$7,
                  lineNumber: 398,
                  columnNumber: 21
                }, void 0), isColumnVisible("lowest_frequency") && u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: item.lowest_frequency || "N/A"
                }, void 0, false, {
                  fileName: _jsxFileName$7,
                  lineNumber: 413,
                  columnNumber: 23
                }, void 0), isColumnVisible("thickness") && u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: item.thickness || "N/A"
                }, void 0, false, {
                  fileName: _jsxFileName$7,
                  lineNumber: 418,
                  columnNumber: 23
                }, void 0), isColumnVisible("fire_rated") && u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: formatBooleanValue(item.fire_rated)
                }, void 0, false, {
                  fileName: _jsxFileName$7,
                  lineNumber: 423,
                  columnNumber: 23
                }, void 0), isColumnVisible("absorber") && u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: formatBooleanValue(item.absorber)
                }, void 0, false, {
                  fileName: _jsxFileName$7,
                  lineNumber: 428,
                  columnNumber: 23
                }, void 0), isColumnVisible("bass_control") && u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: formatBooleanValue(item.bass_control)
                }, void 0, false, {
                  fileName: _jsxFileName$7,
                  lineNumber: 433,
                  columnNumber: 23
                }, void 0), isColumnVisible("backing_type") && u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: item.backing_type || "N/A"
                }, void 0, false, {
                  fileName: _jsxFileName$7,
                  lineNumber: 438,
                  columnNumber: 23
                }, void 0), isColumnVisible("custom_sizes") && u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: formatBooleanValue(item.custom_sizes)
                }, void 0, false, {
                  fileName: _jsxFileName$7,
                  lineNumber: 443,
                  columnNumber: 23
                }, void 0), isColumnVisible("diffuser") && u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: item.diffuser || "N/A"
                }, void 0, false, {
                  fileName: _jsxFileName$7,
                  lineNumber: 448,
                  columnNumber: 23
                }, void 0), isColumnVisible("fits_in_corners") && u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: formatBooleanValue(item.fits_in_corners)
                }, void 0, false, {
                  fileName: _jsxFileName$7,
                  lineNumber: 453,
                  columnNumber: 23
                }, void 0), isColumnVisible("free_standing") && u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: item.free_standing || "N/A"
                }, void 0, false, {
                  fileName: _jsxFileName$7,
                  lineNumber: 458,
                  columnNumber: 23
                }, void 0), isColumnVisible("mounting_hardware") && u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: item.mounting_hardware || "N/A"
                }, void 0, false, {
                  fileName: _jsxFileName$7,
                  lineNumber: 463,
                  columnNumber: 23
                }, void 0), isColumnVisible("stocked_fabrics") && u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: item.stocked_fabrics || "N/A"
                }, void 0, false, {
                  fileName: _jsxFileName$7,
                  lineNumber: 468,
                  columnNumber: 23
                }, void 0), isColumnVisible("variety_of_sizes") && u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: formatBooleanValue(item.variety_of_sizes)
                }, void 0, false, {
                  fileName: _jsxFileName$7,
                  lineNumber: 473,
                  columnNumber: 23
                }, void 0), isColumnVisible("wall_mountable") && u$1("td", {
                  className: "comparison-chart__table-cell",
                  children: formatBooleanValue(item.wall_mountable)
                }, void 0, false, {
                  fileName: _jsxFileName$7,
                  lineNumber: 478,
                  columnNumber: 23
                }, void 0)]
              }, index, true, {
                fileName: _jsxFileName$7,
                lineNumber: 379,
                columnNumber: 19
              }, void 0);
            })
          }, void 0, false, {
            fileName: _jsxFileName$7,
            lineNumber: 373,
            columnNumber: 13
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName$7,
          lineNumber: 305,
          columnNumber: 11
        }, void 0)
      }, void 0, false, {
        fileName: _jsxFileName$7,
        lineNumber: 304,
        columnNumber: 9
      }, void 0), u$1("div", {
        className: "comparison-chart__mobile-table",
        children: u$1("div", {
          className: "comparison-chart__mobile-table-wrapper",
          children: [u$1("div", {
            className: "comparison-chart__mobile-header",
            children: [u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Products"
            }, void 0, false, {
              fileName: _jsxFileName$7,
              lineNumber: 494,
              columnNumber: 15
            }, void 0), u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Image"
            }, void 0, false, {
              fileName: _jsxFileName$7,
              lineNumber: 495,
              columnNumber: 15
            }, void 0), u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Name"
            }, void 0, false, {
              fileName: _jsxFileName$7,
              lineNumber: 496,
              columnNumber: 15
            }, void 0), isColumnVisible("lowest_frequency") && u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Lowest Freq."
            }, void 0, false, {
              fileName: _jsxFileName$7,
              lineNumber: 498,
              columnNumber: 17
            }, void 0), isColumnVisible("thickness") && u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Thickness"
            }, void 0, false, {
              fileName: _jsxFileName$7,
              lineNumber: 501,
              columnNumber: 17
            }, void 0), isColumnVisible("fire_rated") && u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Fire Rated"
            }, void 0, false, {
              fileName: _jsxFileName$7,
              lineNumber: 504,
              columnNumber: 17
            }, void 0), isColumnVisible("absorber") && u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Absorber"
            }, void 0, false, {
              fileName: _jsxFileName$7,
              lineNumber: 507,
              columnNumber: 17
            }, void 0), isColumnVisible("bass_control") && u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Bass Control"
            }, void 0, false, {
              fileName: _jsxFileName$7,
              lineNumber: 510,
              columnNumber: 17
            }, void 0), isColumnVisible("backing_type") && u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Backing Type"
            }, void 0, false, {
              fileName: _jsxFileName$7,
              lineNumber: 513,
              columnNumber: 17
            }, void 0), isColumnVisible("custom_sizes") && u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Custom Sizes"
            }, void 0, false, {
              fileName: _jsxFileName$7,
              lineNumber: 516,
              columnNumber: 17
            }, void 0), isColumnVisible("diffuser") && u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Diffuser"
            }, void 0, false, {
              fileName: _jsxFileName$7,
              lineNumber: 519,
              columnNumber: 17
            }, void 0), isColumnVisible("fits_in_corners") && u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Fits in Corners"
            }, void 0, false, {
              fileName: _jsxFileName$7,
              lineNumber: 522,
              columnNumber: 17
            }, void 0), isColumnVisible("free_standing") && u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Free Standing"
            }, void 0, false, {
              fileName: _jsxFileName$7,
              lineNumber: 525,
              columnNumber: 17
            }, void 0), isColumnVisible("mounting_hardware") && u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Mounting Hardware"
            }, void 0, false, {
              fileName: _jsxFileName$7,
              lineNumber: 528,
              columnNumber: 17
            }, void 0), isColumnVisible("stocked_fabrics") && u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Stocked Fabrics"
            }, void 0, false, {
              fileName: _jsxFileName$7,
              lineNumber: 531,
              columnNumber: 17
            }, void 0), isColumnVisible("variety_of_sizes") && u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Variety of Sizes"
            }, void 0, false, {
              fileName: _jsxFileName$7,
              lineNumber: 534,
              columnNumber: 17
            }, void 0), isColumnVisible("wall_mountable") && u$1("div", {
              className: "comparison-chart__mobile-header-cell",
              children: "Wall Mountable"
            }, void 0, false, {
              fileName: _jsxFileName$7,
              lineNumber: 537,
              columnNumber: 17
            }, void 0)]
          }, void 0, true, {
            fileName: _jsxFileName$7,
            lineNumber: 493,
            columnNumber: 13
          }, void 0), currentPageData.map((item, index) => {
            var _a;
            const productImage = getProductImage(item.product, productData);
            const productHandle = getProductHandle(item.product, productData);
            return u$1("div", {
              className: "comparison-chart__mobile-row",
              children: [u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: getProductName(item.product, index, productData)
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 548,
                columnNumber: 19
              }, void 0), u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: u$1("div", {
                  className: "comparison-chart__mobile-product-image",
                  children: productImage ? u$1("img", {
                    src: productImage.url,
                    alt: productImage.altText || "Product image",
                    style: {
                      width: "32px",
                      height: "32px",
                      objectFit: "cover"
                    }
                  }, void 0, false, {
                    fileName: _jsxFileName$7,
                    lineNumber: 554,
                    columnNumber: 25
                  }, void 0) : u$1("svg", {
                    className: "comparison-chart__mobile-image-icon",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24",
                    children: u$1("path", {
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                      strokeWidth: 2,
                      d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 002 2v12a2 2 0 002 2z"
                    }, void 0, false, {
                      fileName: _jsxFileName$7,
                      lineNumber: 561,
                      columnNumber: 27
                    }, void 0)
                  }, void 0, false, {
                    fileName: _jsxFileName$7,
                    lineNumber: 560,
                    columnNumber: 25
                  }, void 0)
                }, void 0, false, {
                  fileName: _jsxFileName$7,
                  lineNumber: 552,
                  columnNumber: 21
                }, void 0)
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 551,
                columnNumber: 19
              }, void 0), u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: productHandle ? u$1("a", {
                  href: `/products/${productHandle}`,
                  className: "comparison-chart__mobile-shop-button",
                  children: "Shop"
                }, void 0, false, {
                  fileName: _jsxFileName$7,
                  lineNumber: 568,
                  columnNumber: 23
                }, void 0) : u$1("button", {
                  className: "comparison-chart__mobile-shop-button",
                  disabled: true,
                  children: "Shop"
                }, void 0, false, {
                  fileName: _jsxFileName$7,
                  lineNumber: 575,
                  columnNumber: 23
                }, void 0)
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 566,
                columnNumber: 19
              }, void 0), isColumnVisible("lowest_frequency") && u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: ((_a = item.lowest_frequency) == null ? void 0 : _a.replace(" Hz", "")) || "N/A"
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 581,
                columnNumber: 21
              }, void 0), isColumnVisible("thickness") && u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: item.thickness || "N/A"
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 586,
                columnNumber: 21
              }, void 0), isColumnVisible("fire_rated") && u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: formatBooleanValue(item.fire_rated)
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 591,
                columnNumber: 21
              }, void 0), isColumnVisible("absorber") && u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: formatBooleanValue(item.absorber)
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 596,
                columnNumber: 21
              }, void 0), isColumnVisible("bass_control") && u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: formatBooleanValue(item.bass_control)
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 601,
                columnNumber: 21
              }, void 0), isColumnVisible("backing_type") && u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: item.backing_type || "N/A"
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 606,
                columnNumber: 21
              }, void 0), isColumnVisible("custom_sizes") && u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: formatBooleanValue(item.custom_sizes)
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 611,
                columnNumber: 21
              }, void 0), isColumnVisible("diffuser") && u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: item.diffuser || "N/A"
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 616,
                columnNumber: 21
              }, void 0), isColumnVisible("fits_in_corners") && u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: formatBooleanValue(item.fits_in_corners)
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 621,
                columnNumber: 21
              }, void 0), isColumnVisible("free_standing") && u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: item.free_standing || "N/A"
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 626,
                columnNumber: 21
              }, void 0), isColumnVisible("mounting_hardware") && u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: item.mounting_hardware || "N/A"
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 631,
                columnNumber: 21
              }, void 0), isColumnVisible("stocked_fabrics") && u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: item.stocked_fabrics || "N/A"
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 636,
                columnNumber: 21
              }, void 0), isColumnVisible("variety_of_sizes") && u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: formatBooleanValue(item.variety_of_sizes)
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 641,
                columnNumber: 21
              }, void 0), isColumnVisible("wall_mountable") && u$1("div", {
                className: "comparison-chart__mobile-cell",
                children: formatBooleanValue(item.wall_mountable)
              }, void 0, false, {
                fileName: _jsxFileName$7,
                lineNumber: 646,
                columnNumber: 21
              }, void 0)]
            }, index, true, {
              fileName: _jsxFileName$7,
              lineNumber: 547,
              columnNumber: 17
            }, void 0);
          })]
        }, void 0, true, {
          fileName: _jsxFileName$7,
          lineNumber: 491,
          columnNumber: 11
        }, void 0)
      }, void 0, false, {
        fileName: _jsxFileName$7,
        lineNumber: 490,
        columnNumber: 9
      }, void 0)]
    }, void 0, true, {
      fileName: _jsxFileName$7,
      lineNumber: 296,
      columnNumber: 7
    }, void 0), u$1("div", {
      className: "comparison-chart__pagination",
      children: [u$1("div", {
        className: "comparison-chart__pagination-info",
        children: sortedData.length > 0 ? `Showing ${startIndex + 1} to ${Math.min(endIndex, sortedData.length)} of ${sortedData.length} entries` : "No entries found"
      }, void 0, false, {
        fileName: _jsxFileName$7,
        lineNumber: 659,
        columnNumber: 9
      }, void 0), u$1("div", {
        className: "comparison-chart__pagination-controls",
        children: totalPages > 1 && u$1(k$1, {
          children: [u$1("button", {
            className: "comparison-chart__pagination-button",
            onClick: goToPreviousPage,
            disabled: currentPage === 1,
            children: "Previous"
          }, void 0, false, {
            fileName: _jsxFileName$7,
            lineNumber: 670,
            columnNumber: 15
          }, void 0), u$1("button", {
            className: "comparison-chart__pagination-button",
            onClick: goToNextPage,
            disabled: currentPage === totalPages,
            children: "Next"
          }, void 0, false, {
            fileName: _jsxFileName$7,
            lineNumber: 677,
            columnNumber: 15
          }, void 0)]
        }, void 0, true)
      }, void 0, false, {
        fileName: _jsxFileName$7,
        lineNumber: 667,
        columnNumber: 9
      }, void 0)]
    }, void 0, true, {
      fileName: _jsxFileName$7,
      lineNumber: 658,
      columnNumber: 7
    }, void 0)]
  }, void 0, true, {
    fileName: _jsxFileName$7,
    lineNumber: 265,
    columnNumber: 5
  }, void 0);
};
register(ComparisonTool, "comparison-tool", ["initialData", "sectionId"]);
var _jsxFileName$6 = "/home/runner/work/GIK2024_GIK/GIK2024_GIK/src/components/DownloadsWidget.tsx";
function DownloadsWidget({
  title = "Downloads",
  items = "[]"
}) {
  const [downloadingItems, setDownloadingItems] = t$3(d(/* @__PURE__ */ new Set()), "downloadingItems");
  let parsedItems = [];
  try {
    parsedItems = JSON.parse(items);
  } catch (error) {
    console.error("Error parsing download items:", error);
  }
  const handleDownload = async (item) => {
    const itemKey = `${item.file_url}-${item.title}`;
    setDownloadingItems((prev) => new Set(prev).add(itemKey));
    try {
      const response = await fetch(item.file_url);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = item.title || "download";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      setTimeout(() => {
        setDownloadingItems((prev) => {
          const newSet = new Set(prev);
          newSet.delete(itemKey);
          return newSet;
        });
      }, 500);
    } catch (error) {
      console.error("Download failed:", error);
      setDownloadingItems((prev) => {
        const newSet = new Set(prev);
        newSet.delete(itemKey);
        return newSet;
      });
    }
  };
  const splitItemsIntoRows = (items2, isDesktop) => {
    const rows = [];
    const itemsPerFirstRow = isDesktop ? 3 : 2;
    if (items2.length === 0) return rows;
    rows.push(items2.slice(0, itemsPerFirstRow));
    let remainingItems = items2.slice(itemsPerFirstRow);
    while (remainingItems.length > 0) {
      if (isDesktop) {
        const nextRowSize = remainingItems.length >= 3 ? 3 : remainingItems.length;
        rows.push(remainingItems.slice(0, nextRowSize));
        remainingItems = remainingItems.slice(nextRowSize);
      } else {
        const nextRowSize = remainingItems.length >= 2 ? 2 : 1;
        rows.push(remainingItems.slice(0, nextRowSize));
        remainingItems = remainingItems.slice(nextRowSize);
      }
    }
    return rows;
  };
  const getGridColClass = (itemCount) => {
    switch (itemCount) {
      case 1:
        return "tw-grid-cols-1";
      case 2:
        return "tw-grid-cols-2";
      case 3:
        return "tw-grid-cols-3";
      default:
        return "tw-grid-cols-3";
    }
  };
  const renderDownloadButton = (item, index) => {
    const itemKey = `${item.file_url}-${item.title}`;
    const isDownloading = downloadingItems.has(itemKey);
    return u$1("button", {
      className: "tw-flex tw-flex-col tw-items-center tw-gap-3 tw-p-0 tw-bg-transparent tw-border-none tw-cursor-pointer tw-transition-transform hover:tw-transform hover:tw-scale-105 tw-w-full tw-max-w-[136px]",
      onClick: () => handleDownload(item),
      disabled: isDownloading,
      children: [u$1("div", {
        className: "tw-w-[75px] tw-h-[75px] md:tw-w-[85px] md:tw-h-[85px] tw-flex tw-items-center tw-justify-center",
        children: item.icon ? u$1("img", {
          src: item.icon,
          alt: `${item.title} icon`,
          className: "tw-w-full tw-h-full tw-object-contain"
        }, void 0, false, {
          fileName: _jsxFileName$6,
          lineNumber: 120,
          columnNumber: 13
        }, this) : u$1("div", {
          className: "tw-w-full tw-h-full tw-bg-gray-200 tw-rounded-lg tw-flex tw-items-center tw-justify-center",
          children: u$1("svg", {
            className: "tw-w-10 tw-h-10 md:tw-w-12 md:tw-h-12 tw-text-gray-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            children: u$1("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 2,
              d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            }, void 0, false, {
              fileName: _jsxFileName$6,
              lineNumber: 133,
              columnNumber: 17
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$6,
            lineNumber: 127,
            columnNumber: 15
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$6,
          lineNumber: 126,
          columnNumber: 13
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName$6,
        lineNumber: 118,
        columnNumber: 9
      }, this), u$1("div", {
        className: "tw-flex tw-items-center tw-gap-1 tw-justify-center tw-whitespace-break-spaces tw-min-h-[3rem] tw-flex-1",
        children: [u$1("div", {
          className: "tw-w-4 tw-h-4 md:tw-w-5 md:tw-h-5 tw-flex tw-items-center tw-justify-center tw-flex-shrink-0",
          children: isDownloading ? u$1("svg", {
            className: "tw-animate-spin tw-w-4 tw-h-4 md:tw-w-5 md:tw-h-5 tw-text-[#0b0e11] tw-opacity-50",
            fill: "none",
            viewBox: "0 0 24 24",
            children: [u$1("circle", {
              className: "tw-opacity-25",
              cx: "12",
              cy: "12",
              r: "10",
              stroke: "currentColor",
              strokeWidth: "4"
            }, void 0, false, {
              fileName: _jsxFileName$6,
              lineNumber: 154,
              columnNumber: 17
            }, this), u$1("path", {
              className: "tw-opacity-75",
              fill: "currentColor",
              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            }, void 0, false, {
              fileName: _jsxFileName$6,
              lineNumber: 162,
              columnNumber: 17
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName$6,
            lineNumber: 149,
            columnNumber: 15
          }, this) : u$1("svg", {
            className: "tw-w-4 tw-h-4 md:tw-w-5 md:tw-h-5 tw-text-[#0b0e11] tw-opacity-50",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            children: u$1("path", {
              d: "M17.3438 11.25V16.25C17.3438 16.3743 17.2944 16.4935 17.2065 16.5815C17.1185 16.6694 16.9993 16.7188 16.875 16.7188H3.125C3.00068 16.7188 2.88145 16.6694 2.79354 16.5815C2.70564 16.4935 2.65625 16.3743 2.65625 16.25V11.25C2.65625 11.1257 2.70564 11.0065 2.79354 10.9185C2.88145 10.8306 3.00068 10.7812 3.125 10.7812C3.24932 10.7812 3.36855 10.8306 3.45646 10.9185C3.54436 11.0065 3.59375 11.1257 3.59375 11.25V15.7812H16.4062V11.25C16.4062 11.1257 16.4556 11.0065 16.5435 10.9185C16.6315 10.8306 16.7507 10.7812 16.875 10.7812C16.9993 10.7812 17.1185 10.8306 17.2065 10.9185C17.2944 11.0065 17.3438 11.1257 17.3438 11.25ZM9.66875 11.5813C9.75664 11.669 9.87578 11.7183 10 11.7183C10.1242 11.7183 10.2434 11.669 10.3313 11.5813L13.4563 8.45625C13.5391 8.36739 13.5841 8.24986 13.582 8.12842C13.5798 8.00699 13.5306 7.89112 13.4448 7.80524C13.3589 7.71935 13.243 7.67016 13.1216 7.66802C13.0001 7.66587 12.8826 7.71095 12.7937 7.79375L10.4688 10.118V2.5C10.4688 2.37568 10.4194 2.25645 10.3315 2.16854C10.2435 2.08064 10.1243 2.03125 10 2.03125C9.87568 2.03125 9.75645 2.08064 9.66854 2.16854C9.58064 2.25645 9.53125 2.37568 9.53125 2.5V10.118L7.20625 7.79375C7.11739 7.71095 6.99986 7.66587 6.87842 7.66802C6.75699 7.67016 6.64112 7.71935 6.55524 7.80524C6.46935 7.89112 6.42016 8.00699 6.41802 8.12842C6.41587 8.24986 6.46095 8.36739 6.54375 8.45625L9.66875 11.5813Z"
            }, void 0, false, {
              fileName: _jsxFileName$6,
              lineNumber: 174,
              columnNumber: 17
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName$6,
            lineNumber: 169,
            columnNumber: 15
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName$6,
          lineNumber: 147,
          columnNumber: 11
        }, this), u$1("p", {
          className: "tw-text-sm md:tw-text-base tw-font-light tw-text-[#0b0e11] tw-tracking-[0.02em] tw-leading-relaxed tw-text-center tw-break-words",
          style: {
            fontFamily: "'Lexend', sans-serif"
          },
          children: isDownloading ? "Downloading..." : item.title
        }, void 0, false, {
          fileName: _jsxFileName$6,
          lineNumber: 180,
          columnNumber: 11
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName$6,
        lineNumber: 145,
        columnNumber: 9
      }, this)]
    }, index, true, {
      fileName: _jsxFileName$6,
      lineNumber: 111,
      columnNumber: 7
    }, this);
  };
  const renderDownloadsGrid = () => {
    const desktopRows = splitItemsIntoRows(parsedItems, true);
    const mobileRows = splitItemsIntoRows(parsedItems, false);
    return u$1("div", {
      className: "tw-flex tw-flex-col tw-gap-10 tw-flex-1 tw-content-start",
      children: [u$1("div", {
        className: "tw-hidden sm:tw-flex tw-flex-col tw-gap-10",
        children: desktopRows.map((row, rowIndex) => {
          const isLastRow = rowIndex === desktopRows.length - 1;
          const isIncompleteRow = row.length < 3;
          if (isLastRow && isIncompleteRow) {
            return u$1("div", {
              className: "tw-flex tw-justify-center tw-gap-10",
              children: row.map((item, itemIndex) => renderDownloadButton(item, rowIndex * 3 + itemIndex))
            }, `desktop-row-${rowIndex}`, false, {
              fileName: _jsxFileName$6,
              lineNumber: 203,
              columnNumber: 17
            }, this);
          }
          return u$1("div", {
            className: `tw-grid ${getGridColClass(row.length)} tw-gap-10 tw-justify-items-center`,
            children: row.map((item, itemIndex) => renderDownloadButton(item, rowIndex * 3 + itemIndex))
          }, `desktop-row-${rowIndex}`, false, {
            fileName: _jsxFileName$6,
            lineNumber: 213,
            columnNumber: 15
          }, this);
        })
      }, void 0, false, {
        fileName: _jsxFileName$6,
        lineNumber: 196,
        columnNumber: 9
      }, this), u$1("div", {
        className: "tw-flex tw-flex-col tw-gap-10 sm:tw-hidden",
        children: mobileRows.map((row, rowIndex) => {
          const isLastRow = rowIndex === mobileRows.length - 1;
          const isIncompleteRow = row.length < 2;
          if (isLastRow && isIncompleteRow) {
            return u$1("div", {
              className: "tw-flex tw-justify-center tw-gap-10",
              children: row.map((item, itemIndex) => renderDownloadButton(item, rowIndex * 2 + itemIndex))
            }, `mobile-row-${rowIndex}`, false, {
              fileName: _jsxFileName$6,
              lineNumber: 231,
              columnNumber: 17
            }, this);
          }
          return u$1("div", {
            className: `tw-grid ${getGridColClass(row.length)} tw-gap-10 tw-justify-items-center`,
            children: row.map((item, itemIndex) => renderDownloadButton(item, rowIndex * 2 + itemIndex))
          }, `mobile-row-${rowIndex}`, false, {
            fileName: _jsxFileName$6,
            lineNumber: 241,
            columnNumber: 15
          }, this);
        })
      }, void 0, false, {
        fileName: _jsxFileName$6,
        lineNumber: 224,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName$6,
      lineNumber: 194,
      columnNumber: 7
    }, this);
  };
  if (!parsedItems.length) {
    return u$1("div", {
      className: "tw-bg-[#f3f6f6] tw-rounded-xl tw-px-5 lg:tw-px-8 tw-py-6 tw-w-full tw-min-h-[400px] tw-flex tw-items-center tw-justify-center tw-h-full",
      children: u$1("div", {
        className: "tw-text-center tw-text-gray-500",
        children: "No downloads available"
      }, void 0, false, {
        fileName: _jsxFileName$6,
        lineNumber: 257,
        columnNumber: 9
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$6,
      lineNumber: 256,
      columnNumber: 7
    }, this);
  }
  return u$1("div", {
    className: "tw-bg-[#f3f6f6] tw-rounded-xl tw-px-5 lg:tw-px-8 tw-py-6 tw-w-full tw-min-h-[400px] lg:tw-min-w-[37vw] tw-flex tw-flex-col tw-h-full",
    children: [u$1("div", {
      className: "tw-mb-14",
      children: u$1("h3", {
        className: "tw-text-2xl tw-font-semibold tw-text-[#0b0e11] tw-text-center tw-tracking-[-0.11em] tw-leading-tight",
        style: {
          fontFamily: "'Lexend Giga', sans-serif"
        },
        children: title
      }, void 0, false, {
        fileName: _jsxFileName$6,
        lineNumber: 268,
        columnNumber: 9
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName$6,
      lineNumber: 267,
      columnNumber: 7
    }, this), renderDownloadsGrid()]
  }, void 0, true, {
    fileName: _jsxFileName$6,
    lineNumber: 265,
    columnNumber: 5
  }, this);
}
register(DownloadsWidget, "downloads-widget");
const convertUnit = (value, toUnit) => {
  if (!value) return "";
  const num = parseFloat(value);
  if (isNaN(num)) return value;
  if (toUnit === "inches") {
    return (num / 2.54).toFixed(0);
  } else {
    return (num * 2.54).toFixed(0);
  }
};
const getMinMax = (minHeight, maxHeight, minWidth, maxWidth, unit) => {
  const result = {};
  if (minHeight !== null && maxHeight !== null) {
    const minH = parseFloat(minHeight);
    const maxH = parseFloat(maxHeight);
    if (unit === "inches") {
      result.minHeight = minH / 2.54;
      result.maxHeight = maxH / 2.54;
    } else {
      result.minHeight = minH;
      result.maxHeight = maxH;
    }
  }
  if (minWidth !== null && maxWidth !== null) {
    const minW = parseFloat(minWidth);
    const maxW = parseFloat(maxWidth);
    if (unit === "inches") {
      result.minWidth = minW / 2.54;
      result.maxWidth = maxW / 2.54;
    } else {
      result.minWidth = minW;
      result.maxWidth = maxW;
    }
  }
  return result;
};
const convertToMillimeters = (value, currentUnit) => {
  if (!value) return null;
  const num = parseFloat(value);
  if (isNaN(num)) return null;
  if (currentUnit === "cm") {
    return num * 10;
  } else {
    return num * 25.4;
  }
};
const parseHelpContent = (helpContent) => {
  if (!helpContent) return {};
  try {
    const helpData = JSON.parse(helpContent);
    if (!helpData || !Array.isArray(helpData)) {
      return {};
    }
    return helpData.reduce((acc, item) => {
      if (item.option_target && item.tooltip_text) {
        acc[item.option_target.toLowerCase()] = item.tooltip_text;
      }
      return acc;
    }, {});
  } catch (error) {
    console.error("Failed to parse helpContent:", error);
    return {};
  }
};
const getTooltipText = (optionName, helpContentLookup, customMappings = {}) => {
  const normalizedOptionName = optionName.toLowerCase();
  if (helpContentLookup[normalizedOptionName]) {
    return helpContentLookup[normalizedOptionName];
  }
  const defaultMappings = {
    "panel pattern": "pattern",
    "panel finish": "finish",
    "sound frequency": "absorb"
  };
  const allMappings = {
    ...defaultMappings,
    ...customMappings
  };
  if (allMappings[normalizedOptionName] && helpContentLookup[allMappings[normalizedOptionName]]) {
    return helpContentLookup[allMappings[normalizedOptionName]];
  }
  return "";
};
const renderTooltipIcon = (tooltipText) => {
  if (!tooltipText) {
    return `
      <div className="frequency-swatches__icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M10.9375 14.875C10.9375 15.0604 10.8825 15.2417 10.7795 15.3958C10.6765 15.55 10.5301 15.6702 10.3588 15.7411C10.1875 15.8121 9.99896 15.8307 9.81711 15.7945C9.63525 15.7583 9.4682 15.669 9.33709 15.5379C9.20598 15.4068 9.11669 15.2398 9.08052 15.0579C9.04434 14.876 9.06291 14.6875 9.13387 14.5162C9.20482 14.3449 9.32499 14.1985 9.47916 14.0955C9.63333 13.9925 9.81458 13.9375 10 13.9375C10.2486 13.9375 10.4871 14.0363 10.6629 14.2121C10.8387 14.3879 10.9375 14.6264 10.9375 14.875ZM10 4.9375C8.03125 4.9375 6.4375 6.36719 6.4375 8.125V8.5C6.4375 8.64918 6.49677 8.79226 6.60226 8.89775C6.70775 9.00324 6.85082 9.0625 7 9.0625C7.14919 9.0625 7.29226 9.00324 7.39775 8.89775C7.50324 8.79226 7.5625 8.64918 7.5625 8.5V8.125C7.5625 6.98781 8.65563 6.0625 10 6.0625C11.3444 6.0625 12.4375 6.98781 12.4375 8.125C12.4375 9.26219 11.3444 10.1875 10 10.1875C9.85082 10.1875 9.70775 10.2468 9.60226 10.3523C9.49677 10.4577 9.4375 10.6008 9.4375 10.75V11.5C9.4375 11.6492 9.49677 11.7923 9.60226 11.8977C9.70775 12.0032 9.85082 12.0625 10 12.0625C10.1492 12.0625 10.2923 12.0032 10.3978 11.8977C10.5032 11.7923 10.5625 11.6492 10.5625 11.5V11.2731C12.2603 11.0312 13.5625 9.71125 13.5625 8.125C13.5625 6.36719 11.9688 4.9375 10 4.9375ZM19.5625 10C19.5625 11.8913 19.0017 13.7401 17.9509 15.3126C16.9002 16.8852 15.4067 18.1108 13.6594 18.8346C11.9121 19.5584 9.9894 19.7477 8.13445 19.3788C6.27951 19.0098 4.57564 18.099 3.2383 16.7617C1.90096 15.4244 0.990216 13.7205 0.621245 11.8656C0.252274 10.0106 0.441643 8.08791 1.16541 6.34059C1.88917 4.59327 3.11482 3.09981 4.68736 2.04907C6.25991 0.998331 8.10872 0.4375 10 0.4375C12.5352 0.440477 14.9658 1.44891 16.7584 3.24158C18.5511 5.03425 19.5595 7.46478 19.5625 10ZM18.4375 10C18.4375 8.33122 17.9427 6.69992 17.0155 5.31238C16.0884 3.92484 14.7706 2.84338 13.2289 2.20477C11.6871 1.56615 9.99064 1.39906 8.35393 1.72462C6.71722 2.05019 5.2138 2.85378 4.03379 4.03379C2.85379 5.21379 2.05019 6.71721 1.72463 8.35393C1.39907 9.99064 1.56616 11.6871 2.20477 13.2289C2.84338 14.7706 3.92484 16.0884 5.31238 17.0155C6.69992 17.9426 8.33122 18.4375 10 18.4375C12.237 18.435 14.3817 17.5453 15.9635 15.9635C17.5453 14.3817 18.435 12.237 18.4375 10Z" fill="#051719"/>
        </svg>
      </div>
    `;
  }
  const escapedTooltipText = tooltipText.replace(/"/g, "&quot;");
  return `
    <magnet-element class="block" style="width: 24px; height: 24px;">
      <div class="cursor-help inline-block relative" title="${escapedTooltipText}">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M10.9375 14.875C10.9375 15.0604 10.8825 15.2417 10.7795 15.3958C10.6765 15.55 10.5301 15.6702 10.3588 15.7411C10.1875 15.8121 9.99896 15.8307 9.81711 15.7945C9.63525 15.7583 9.4682 15.669 9.33709 15.5379C9.20598 15.4068 9.11669 15.2398 9.08052 15.0579C9.04434 14.876 9.06291 14.6875 9.13387 14.5162C9.20482 14.3449 9.32499 14.1985 9.47916 14.0955C9.63333 13.9925 9.81458 13.9375 10 13.9375C10.2486 13.9375 10.4871 14.0363 10.6629 14.2121C10.8387 14.3879 10.9375 14.6264 10.9375 14.875ZM10 4.9375C8.03125 4.9375 6.4375 6.36719 6.4375 8.125V8.5C6.4375 8.64918 6.49677 8.79226 6.60226 8.89775C6.70775 9.00324 6.85082 9.0625 7 9.0625C7.14919 9.0625 7.29226 9.00324 7.39775 8.89775C7.50324 8.79226 7.5625 8.64918 7.5625 8.5V8.125C7.5625 6.98781 8.65563 6.0625 10 6.0625C11.3444 6.0625 12.4375 6.98781 12.4375 8.125C12.4375 9.26219 11.3444 10.1875 10 10.1875C9.85082 10.1875 9.70775 10.2468 9.60226 10.3523C9.49677 10.4577 9.4375 10.6008 9.4375 10.75V11.5C9.4375 11.6492 9.49677 11.7923 9.60226 11.8977C9.70775 12.0032 9.85082 12.0625 10 12.0625C10.1492 12.0625 10.2923 12.0032 10.3978 11.8977C10.5032 11.7923 10.5625 11.6492 10.5625 11.5V11.2731C12.2603 11.0312 13.5625 9.71125 13.5625 8.125C13.5625 6.36719 11.9688 4.9375 10 4.9375ZM19.5625 10C19.5625 11.8913 19.0017 13.7401 17.9509 15.3126C16.9002 16.8852 15.4067 18.1108 13.6594 18.8346C11.9121 19.5584 9.9894 19.7477 8.13445 19.3788C6.27951 19.0098 4.57564 18.099 3.2383 16.7617C1.90096 15.4244 0.990216 13.7205 0.621245 11.8656C0.252274 10.0106 0.441643 8.08791 1.16541 6.34059C1.88917 4.59327 3.11482 3.09981 4.68736 2.04907C6.25991 0.998331 8.10872 0.4375 10 0.4375C12.5352 0.440477 14.9658 1.44891 16.7584 3.24158C18.5511 5.03425 19.5595 7.46478 19.5625 10ZM18.4375 10C18.4375 8.33122 17.9427 6.69992 17.0155 5.31238C16.0884 3.92484 14.7706 2.84338 13.2289 2.20477C11.6871 1.56615 9.99064 1.39906 8.35393 1.72462C6.71722 2.05019 5.2138 2.85378 4.03379 4.03379C2.85379 5.21379 2.05019 6.71721 1.72463 8.35393C1.39907 9.99064 1.56616 11.6871 2.20477 13.2289C2.84338 14.7706 3.92484 16.0884 5.31238 17.0155C6.69992 17.9426 8.33122 18.4375 10 18.4375C12.237 18.435 14.3817 17.5453 15.9635 15.9635C17.5453 14.3817 18.435 12.237 18.4375 10Z" fill="#051719"/>
        </svg>
        <span class="tooltip opacity-0 pointer-events-none text-xs rounded-full z-10">
          ${tooltipText}
        </span>
      </div>
    </magnet-element>
  `;
};
var _jsxFileName$5 = "/home/runner/work/GIK2024_GIK/GIK2024_GIK/src/components/SecondarySwatches/SecondarySwatches.tsx";
const SecondarySwatches = ({
  swatchValues = null,
  productFormId = null,
  optionName = null,
  preSelect = null,
  relatedOptions = null,
  relatedOptionsName = null,
  helpContent = null,
  roomlePatternMapping = null,
  roomleFinishMapping = null,
  primaryAttrName = null,
  secondaryAttrName = null,
  swatchValueTranslations = null,
  shopLocale = null
}) => {
  const [productData, setProductData] = t$3(d({}), "productData");
  const [loadingProducts, setLoadingProducts] = t$3(d(false), "loadingProducts");
  const [selectedSwatches, setSelectedSwatches] = t$3(d(/* @__PURE__ */ new Set()), "selectedSwatches");
  const [selectedRelatedOptions, setSelectedRelatedOptions] = t$3(d(/* @__PURE__ */ new Set()), "selectedRelatedOptions");
  const [relatedOptionsBaseSwatch, setRelatedOptionsBaseSwatch] = t$3(d(""), "relatedOptionsBaseSwatch");
  const [selectedValueText, setSelectedValueText] = t$3(d(""), "selectedValueText");
  const [selectedRelatedText, setSelectedRelatedText] = t$3(d(""), "selectedRelatedText");
  const [componentId] = t$3(d(() => `secondary-swatches-${Math.random().toString(36).substr(2, 9)}`), "componentId");
  const [hasPreSelected, setHasPreSelected] = t$3(d(false), "hasPreSelected");
  const [disabledSwatches, setDisabledSwatches] = t$3(d(/* @__PURE__ */ new Set()), "disabledSwatches");
  const [disabledRelatedOptions, setDisabledRelatedOptions] = t$3(d(/* @__PURE__ */ new Set()), "disabledRelatedOptions");
  const translationsArray = t$3(T$1(() => {
    if (!swatchValueTranslations) return [];
    try {
      return JSON.parse(swatchValueTranslations);
    } catch {
      return [];
    }
  }, [swatchValueTranslations]), "translationsArray: SwatchValueTranslation[]");
  const getTranslatedValue = (value) => {
    if (!value || (translationsArray == null ? void 0 : translationsArray.length) === 0) return value;
    const normalizedValue = value.toLowerCase();
    const translation = translationsArray == null ? void 0 : translationsArray.find((t2) => {
      var _a;
      return ((_a = t2.english_swatch_value) == null ? void 0 : _a.toLowerCase()) === normalizedValue;
    });
    if (!translation) return value;
    const locale = (shopLocale == null ? void 0 : shopLocale.toLowerCase()) || "en";
    switch (locale) {
      case "fr":
        return translation.french_translation || value;
      case "de":
        return translation.german_translation || value;
      case "it":
        return translation.italian_translation || value;
      case "en":
      default:
        return value;
    }
  };
  const swatchValuesArray = t$3(T$1(() => {
    if (!swatchValues) return [];
    return JSON.parse(swatchValues);
  }, [swatchValues]), "swatchValuesArray: SecondarySwatchItem[]");
  const relatedOptionsArray = relatedOptions ? JSON.parse(relatedOptions) : [];
  const patternMapping = roomlePatternMapping ? JSON.parse(roomlePatternMapping) : {};
  const finishMapping = roomleFinishMapping ? JSON.parse(roomleFinishMapping) : {};
  const isPatternOption = optionName && (["pattern", "muster", "motif", "wzór", "model", "motivo", "front", "devant"].some((term) => optionName.toLowerCase().includes(term.toLowerCase())) || optionName.toLowerCase().includes("panel-") && ["pattern", "muster", "motif", "wzór", "model", "motivo", "front", "devant"].some((term) => optionName.toLowerCase().includes(term.toLowerCase())));
  const isFinishRelatedOption = relatedOptionsName && (["finish", "oberfläche", "oberflache", "finition", "wykończenie", "finisaj", "finitura", "superficie"].some((term) => relatedOptionsName.toLowerCase().includes(term.toLowerCase())) || relatedOptionsName.toLowerCase().includes("panel-") && ["finish", "oberfläche", "oberflache", "finition", "wykończenie", "finisaj", "finitura", "superficie"].some((term) => relatedOptionsName.toLowerCase().includes(term.toLowerCase())));
  const helpContentLookup = t$3(T$1(() => parseHelpContent(helpContent), [helpContent]), "helpContentLookup");
  const getExtrasKey = (extras) => {
    if (!extras) return "";
    return Array.isArray(extras) ? extras[0] || "" : extras;
  };
  const hasValidExtras = (swatch) => {
    if (swatch.handle && swatch.handle.toLowerCase() === "none") return true;
    if (!swatch.extras) return false;
    if (typeof swatch.extras === "string") {
      return swatch.extras.includes("Product/");
    }
    if (Array.isArray(swatch.extras) && swatch.extras.length > 0) {
      const firstExtra = swatch.extras[0];
      return typeof firstExtra === "string" && firstExtra.includes("Product/");
    }
    return false;
  };
  const getRoomlePatternValue = (productTitle) => {
    if (!isPatternOption || !patternMapping) return "";
    if (patternMapping[productTitle]) {
      return patternMapping[productTitle];
    }
    for (const [patternName, roomleValue] of Object.entries(patternMapping)) {
      if (productTitle.toLowerCase().includes(patternName.toLowerCase())) {
        return roomleValue;
      }
    }
    return "";
  };
  const getRoomleFinishValue = (optionName2) => {
    if (!isFinishRelatedOption || !finishMapping) return "";
    if (finishMapping[optionName2]) {
      return finishMapping[optionName2];
    }
    for (const [finishName, roomleValue] of Object.entries(finishMapping)) {
      if (optionName2.toLowerCase().includes(finishName.toLowerCase())) {
        return roomleValue;
      }
    }
    return "";
  };
  const shouldPreSelect = preSelect === "true";
  const filteredSwatchValues = swatchValuesArray.filter(hasValidExtras);
  const groupedSwatches = optionName ? {
    [optionName]: filteredSwatchValues
  } : {
    "accessories": filteredSwatchValues
  };
  const groupedRelatedOptions = relatedOptions && relatedOptionsName ? {
    [relatedOptionsName]: relatedOptionsArray
  } : {};
  const getSwatchId = (optionName2, swatch, index) => {
    const extrasKey = getExtrasKey(swatch.extras);
    if (extrasKey) {
      const productId = extrasKey.split("/").pop() || "";
      return productId || index.toString();
    }
    return index.toString();
  };
  const getRelatedOptionId = (optionName2, option, index) => {
    return `related-${option.name || index}`;
  };
  const getTooltipText$1 = (optionName2) => {
    const customMappings = {
      "sound frequency": ""
    };
    return getTooltipText(optionName2, helpContentLookup, customMappings);
  };
  const hasAvailableVariants = (productKey) => {
    const product = productData[productKey];
    if (!product || !product.variants || !product.variants.nodes) {
      return false;
    }
    return product.variants.nodes.some((variant) => variant.availableForSale);
  };
  const isSwatchDisabled = (swatchId) => {
    return disabledSwatches.has(swatchId);
  };
  const isRelatedOptionDisabled = (optionId) => {
    return disabledRelatedOptions.has(optionId);
  };
  const hasAvailableVariantsForRelatedOption = (relatedOptionName, baseProductKey) => {
    const baseProduct = productData[baseProductKey];
    if (!baseProduct || !baseProduct.variants || !baseProduct.variants.nodes) {
      return false;
    }
    let hasMatch = baseProduct.variants.nodes.some((variant) => {
      var _a;
      const hasRelatedOption = (_a = variant.selectedOptions) == null ? void 0 : _a.some((option) => option.value.toLowerCase() === relatedOptionName.toLowerCase());
      return hasRelatedOption && variant.availableForSale;
    });
    if (hasMatch) return true;
    const translationMap = {
      "buche": ["beech", "blonde", "blond"],
      "walnuss": ["walnut", "nut"],
      "graue ulme": ["gray elm", "grey elm", "elm"],
      "weiß": ["white"],
      "schwarz": ["black"],
      "black": ["black", "schwarz"]
    };
    const normalizedOptionName = relatedOptionName.toLowerCase();
    const possibleMatches = translationMap[normalizedOptionName] || [];
    return baseProduct.variants.nodes.some((variant) => {
      var _a;
      const hasRelatedOption = (_a = variant.selectedOptions) == null ? void 0 : _a.some((option) => {
        const optionValue = option.value.toLowerCase();
        return possibleMatches.some((match) => optionValue.includes(match.toLowerCase()) || match.toLowerCase().includes(optionValue));
      });
      return hasRelatedOption && variant.availableForSale;
    });
  };
  const getSelectedValueText = () => {
    if (selectedSwatches.size === 0) return "";
    const selectedSwatchId = Array.from(selectedSwatches)[0];
    for (const [optionName2, swatches] of Object.entries(groupedSwatches)) {
      for (let index = 0; index < swatches.length; index++) {
        const swatch = swatches[index];
        const swatchId = getSwatchId(optionName2, swatch, index);
        if (swatchId === selectedSwatchId) {
          const extrasKey = getExtrasKey(swatch.extras);
          const product = productData[extrasKey];
          return (product == null ? void 0 : product.title) || "";
        }
      }
    }
    return "";
  };
  const getSelectedRelatedText = () => {
    if (selectedRelatedOptions.size === 0) return "";
    const selectedOptionId = Array.from(selectedRelatedOptions)[0];
    for (const [optionName2, options] of Object.entries(groupedRelatedOptions)) {
      for (let index = 0; index < options.length; index++) {
        const option = options[index];
        const optionId = getRelatedOptionId(optionName2, option, index);
        if (optionId === selectedOptionId) {
          return option.name || "";
        }
      }
    }
    return "";
  };
  const updateLineItemProperty = (formId, propertyName, value) => {
    const productForms = [document.getElementById(formId), document.querySelector('.product-form-wrapper form[is="product-form"]')].filter(Boolean);
    if (productForms.length === 0) return;
    productForms.forEach((form) => {
      const existingInputs = form == null ? void 0 : form.querySelectorAll(`input[name="properties[${propertyName}]"]`);
      existingInputs == null ? void 0 : existingInputs.forEach((input) => input.remove());
      if (value) {
        const propertyInput = document.createElement("input");
        propertyInput.type = "hidden";
        propertyInput.name = `properties[${propertyName}]`;
        propertyInput.value = formatName(value);
        form == null ? void 0 : form.appendChild(propertyInput);
      }
    });
  };
  const toggleSwatchSelection = (swatchId, optionGroupName) => {
    let selectedSwatchName = "";
    let previousSwatchName = "";
    const previousSwatchId = Array.from(selectedSwatches)[0];
    if (previousSwatchId) {
      for (const [optName, swatches] of Object.entries(groupedSwatches)) {
        for (let index = 0; index < swatches.length; index++) {
          const swatch = swatches[index];
          const loopSwatchId = getSwatchId(optName, swatch, index);
          if (loopSwatchId === previousSwatchId) {
            const extrasKey = getExtrasKey(swatch.extras);
            const product = productData[extrasKey];
            previousSwatchName = (swatch.name || (product == null ? void 0 : product.title) || "").toLowerCase();
            break;
          }
        }
        if (previousSwatchName) break;
      }
    }
    for (const [optName, swatches] of Object.entries(groupedSwatches)) {
      for (let index = 0; index < swatches.length; index++) {
        const swatch = swatches[index];
        const loopSwatchId = getSwatchId(optName, swatch, index);
        if (loopSwatchId === swatchId) {
          const extrasKey = getExtrasKey(swatch.extras);
          const product = productData[extrasKey];
          selectedSwatchName = (swatch.name || (product == null ? void 0 : product.title) || "").toLowerCase();
          break;
        }
      }
      if (selectedSwatchName) break;
    }
    setSelectedSwatches((prev) => {
      var _a, _b, _c;
      const newSelected = new Set(prev);
      if (newSelected.has(swatchId)) {
        return newSelected;
      } else {
        newSelected.clear();
        newSelected.add(swatchId);
        if (relatedOptionsArray.length > 0) {
          setRelatedOptionsBaseSwatch(swatchId);
          const isNoPlateSelected = selectedSwatchName.includes("no plate");
          const wasNoPlateSelected = previousSwatchName.includes("no plate");
          if (isNoPlateSelected) {
            for (const [optName, options] of Object.entries(groupedRelatedOptions)) {
              for (let index = 0; index < options.length; index++) {
                const option = options[index];
                if ((_a = option.name) == null ? void 0 : _a.toLowerCase().includes("no finish")) {
                  const noFinishOptionId = getRelatedOptionId(optName, option, index);
                  setSelectedRelatedOptions(/* @__PURE__ */ new Set([noFinishOptionId]));
                  if (isFinishRelatedOption && option.name) {
                    const roomleFinishValue = getRoomleFinishValue(option.name);
                    if (roomleFinishValue) {
                      const roomleEvent = new CustomEvent("roomle-finish-update", {
                        detail: {
                          parameterName: "finish",
                          value: roomleFinishValue
                        },
                        bubbles: true
                      });
                      document.dispatchEvent(roomleEvent);
                    }
                  }
                  break;
                }
              }
            }
          } else if (wasNoPlateSelected && !isNoPlateSelected) {
            let newSwatchProductKey = "";
            for (const [optName, swatches] of Object.entries(groupedSwatches)) {
              for (let index = 0; index < swatches.length; index++) {
                const swatch = swatches[index];
                const loopSwatchId = getSwatchId(optName, swatch, index);
                if (loopSwatchId === swatchId) {
                  newSwatchProductKey = getExtrasKey(swatch.extras);
                  break;
                }
              }
              if (newSwatchProductKey) break;
            }
            const currentRelatedOptionId = Array.from(selectedRelatedOptions)[0];
            let currentSelectionIsValid = false;
            let currentSelectionIsNoFinish = false;
            if (currentRelatedOptionId) {
              for (const [optName, options] of Object.entries(groupedRelatedOptions)) {
                for (let index = 0; index < options.length; index++) {
                  const option = options[index];
                  const optionId = getRelatedOptionId(optName, option, index);
                  if (optionId === currentRelatedOptionId) {
                    currentSelectionIsNoFinish = ((_b = option.name) == null ? void 0 : _b.toLowerCase().includes("no finish")) || false;
                    if (!currentSelectionIsNoFinish && option.name && newSwatchProductKey) {
                      currentSelectionIsValid = hasAvailableVariantsForRelatedOption(option.name, newSwatchProductKey);
                    }
                    break;
                  }
                }
              }
            }
            if (currentSelectionIsNoFinish || !currentSelectionIsValid) {
              let foundOption = false;
              for (const [optName, options] of Object.entries(groupedRelatedOptions)) {
                for (let index = 0; index < options.length; index++) {
                  const option = options[index];
                  const optionId = getRelatedOptionId(optName, option, index);
                  const isNoFinish = (_c = option.name) == null ? void 0 : _c.toLowerCase().includes("no finish");
                  const isAvailable = option.name && newSwatchProductKey ? hasAvailableVariantsForRelatedOption(option.name, newSwatchProductKey) : true;
                  if (!isNoFinish && isAvailable) {
                    setSelectedRelatedOptions(/* @__PURE__ */ new Set([optionId]));
                    if (isFinishRelatedOption && option.name) {
                      const roomleFinishValue = getRoomleFinishValue(option.name);
                      if (roomleFinishValue) {
                        const roomleEvent = new CustomEvent("roomle-finish-update", {
                          detail: {
                            parameterName: "finish",
                            value: roomleFinishValue
                          },
                          bubbles: true
                        });
                        document.dispatchEvent(roomleEvent);
                      }
                    }
                    foundOption = true;
                    break;
                  }
                }
                if (foundOption) break;
              }
            }
          }
        }
      }
      return newSelected;
    });
  };
  const toggleRelatedOptionSelection = (optionId, optionGroupName) => {
    setSelectedRelatedOptions((prev) => {
      const newSelected = new Set(prev);
      if (newSelected.has(optionId)) {
        return newSelected;
      } else {
        newSelected.clear();
        newSelected.add(optionId);
        if (isFinishRelatedOption) {
          for (const [groupName, options] of Object.entries(groupedRelatedOptions)) {
            for (let index = 0; index < options.length; index++) {
              const option = options[index];
              const currentOptionId = getRelatedOptionId(groupName, option, index);
              if (currentOptionId === optionId && option.name) {
                const roomleFinishValue = getRoomleFinishValue(option.name);
                if (roomleFinishValue) {
                  const roomleEvent = new CustomEvent("roomle-finish-update", {
                    detail: {
                      parameterName: "finish",
                      value: roomleFinishValue
                    },
                    bubbles: true
                  });
                  document.dispatchEvent(roomleEvent);
                }
                break;
              }
            }
          }
        }
      }
      return newSelected;
    });
  };
  const formatName = (name) => {
    if (name.includes(": ")) {
      return name.split(": ")[1];
    }
    return name;
  };
  y(() => {
    if (filteredSwatchValues.length > 0) {
      fetchAllProductData(filteredSwatchValues, setProductData, setLoadingProducts);
    } else {
      setLoadingProducts(false);
    }
  }, [swatchValues]);
  y(() => {
    if (Object.keys(productData).length > 0) {
      const newDisabledSwatches = /* @__PURE__ */ new Set();
      for (const [optionName2, swatches] of Object.entries(groupedSwatches)) {
        swatches.forEach((swatch, index) => {
          const extrasKey = getExtrasKey(swatch.extras);
          const swatchId = getSwatchId(optionName2, swatch, index);
          if (extrasKey && !hasAvailableVariants(extrasKey)) {
            newDisabledSwatches.add(swatchId);
          }
        });
      }
      setDisabledSwatches(newDisabledSwatches);
    }
  }, [productData, groupedSwatches]);
  y(() => {
    if (Object.keys(productData).length > 0 && relatedOptionsBaseSwatch && relatedOptionsArray.length > 0) {
      const newDisabledRelatedOptions = /* @__PURE__ */ new Set();
      let baseProductKey = "";
      for (const [optionName2, swatches] of Object.entries(groupedSwatches)) {
        for (let index = 0; index < swatches.length; index++) {
          const swatch = swatches[index];
          const swatchId = getSwatchId(optionName2, swatch, index);
          if (swatchId === relatedOptionsBaseSwatch) {
            baseProductKey = getExtrasKey(swatch.extras);
            break;
          }
        }
        if (baseProductKey) break;
      }
      if (baseProductKey) {
        for (const [optionName2, options] of Object.entries(groupedRelatedOptions)) {
          options.forEach((option, index) => {
            const optionId = getRelatedOptionId(optionName2, option, index);
            if (option.name && !hasAvailableVariantsForRelatedOption(option.name, baseProductKey)) {
              newDisabledRelatedOptions.add(optionId);
            }
          });
        }
      }
      setDisabledRelatedOptions(newDisabledRelatedOptions);
    } else {
      setDisabledRelatedOptions(/* @__PURE__ */ new Set());
    }
  }, [productData, relatedOptionsBaseSwatch, groupedSwatches, groupedRelatedOptions, relatedOptionsArray]);
  y(() => {
    if (shouldPreSelect && !hasPreSelected && filteredSwatchValues.length > 0 && Object.keys(productData).length > 0 && !loadingProducts) {
      const firstOptionGroup = Object.keys(groupedSwatches)[0];
      const swatches = groupedSwatches[firstOptionGroup];
      if (swatches && firstOptionGroup) {
        let firstAvailableSwatch = null;
        let firstAvailableIndex = -1;
        for (let i2 = 0; i2 < swatches.length; i2++) {
          const swatch = swatches[i2];
          const swatchId = getSwatchId(firstOptionGroup, swatch, i2);
          if (!isSwatchDisabled(swatchId)) {
            firstAvailableSwatch = swatch;
            firstAvailableIndex = i2;
            break;
          }
        }
        if (firstAvailableSwatch && firstAvailableIndex >= 0) {
          const firstSwatchId = getSwatchId(firstOptionGroup, firstAvailableSwatch, firstAvailableIndex);
          setSelectedSwatches(/* @__PURE__ */ new Set([firstSwatchId]));
          if (relatedOptionsArray.length > 0) {
            setRelatedOptionsBaseSwatch(firstSwatchId);
          }
          setHasPreSelected(true);
        }
      }
    }
  }, [shouldPreSelect, hasPreSelected, filteredSwatchValues, productData, loadingProducts, groupedSwatches, relatedOptionsArray, disabledSwatches]);
  y(() => {
    if (shouldPreSelect && !hasPreSelected && relatedOptionsArray.length > 0 && Object.keys(groupedRelatedOptions).length > 0) {
      const firstRelatedOptionGroup = Object.keys(groupedRelatedOptions)[0];
      const relatedOptions2 = groupedRelatedOptions[firstRelatedOptionGroup];
      if (relatedOptions2 && firstRelatedOptionGroup) {
        let firstAvailableRelatedOption = null;
        let firstAvailableIndex = -1;
        for (let i2 = 0; i2 < relatedOptions2.length; i2++) {
          const relatedOption = relatedOptions2[i2];
          const relatedOptionId = getRelatedOptionId(firstRelatedOptionGroup, relatedOption, i2);
          if (!isRelatedOptionDisabled(relatedOptionId)) {
            firstAvailableRelatedOption = relatedOption;
            firstAvailableIndex = i2;
            break;
          }
        }
        if (firstAvailableRelatedOption && firstAvailableIndex >= 0) {
          const firstRelatedOptionId = getRelatedOptionId(firstRelatedOptionGroup, firstAvailableRelatedOption, firstAvailableIndex);
          setSelectedRelatedOptions(/* @__PURE__ */ new Set([firstRelatedOptionId]));
        }
      }
    }
  }, [shouldPreSelect, hasPreSelected, relatedOptionsArray, groupedRelatedOptions, disabledRelatedOptions]);
  y(() => {
    const newSelectedText = getSelectedValueText();
    setSelectedValueText(newSelectedText);
    if (productFormId && primaryAttrName) {
      updateLineItemProperty(productFormId, primaryAttrName, newSelectedText);
    }
  }, [selectedSwatches, productData, productFormId, primaryAttrName]);
  y(() => {
    const newSelectedRelatedText = getSelectedRelatedText();
    setSelectedRelatedText(newSelectedRelatedText);
    if (productFormId && secondaryAttrName) {
      updateLineItemProperty(productFormId, secondaryAttrName, newSelectedRelatedText);
    }
  }, [selectedRelatedOptions, productFormId, secondaryAttrName]);
  y(() => {
    return () => {
      if (productFormId && primaryAttrName) {
        if (optionName) {
          updateLineItemProperty(productFormId, primaryAttrName, "");
        }
        if (relatedOptionsName && secondaryAttrName) {
          updateLineItemProperty(productFormId, secondaryAttrName, "");
        }
      }
    };
  }, []);
  return u$1("div", {
    className: "secondary-swatches",
    children: u$1("div", {
      className: "secondary-swatches__content",
      children: loadingProducts ? u$1("p", {
        className: "secondary-swatches__loading",
        children: "Loading product data..."
      }, void 0, false, {
        fileName: _jsxFileName$5,
        lineNumber: 686,
        columnNumber: 11
      }, void 0) : u$1("div", {
        className: "secondary-swatches__options",
        children: [Object.keys(groupedSwatches).length > 0 ? Object.entries(groupedSwatches).map(([optionName2, swatches]) => u$1("fieldset", {
          className: "secondary-swatches__option-group variant-input-wrapper border-0",
          children: [u$1("legend", {
            className: "sr-only",
            children: optionName2
          }, void 0, false, {
            fileName: _jsxFileName$5,
            lineNumber: 692,
            columnNumber: 19
          }, void 0), u$1("div", {
            className: "form__label flex items-center justify-between gap-2 w-full",
            children: [u$1("div", {
              className: "flex gap-2",
              children: [u$1("span", {
                className: "form__label-pretext",
                children: [optionName2, ":"]
              }, void 0, true, {
                fileName: _jsxFileName$5,
                lineNumber: 695,
                columnNumber: 23
              }, void 0), u$1("span", {
                className: "font-medium form__label-text",
                id: `${componentId}-${optionName2}-selected`,
                children: getTranslatedValue(formatName(selectedValueText))
              }, void 0, false, {
                fileName: _jsxFileName$5,
                lineNumber: 698,
                columnNumber: 23
              }, void 0)]
            }, void 0, true, {
              fileName: _jsxFileName$5,
              lineNumber: 694,
              columnNumber: 21
            }, void 0), getTooltipText$1(optionName2) && u$1("div", {
              className: "block cursor-help inline-block relative",
              style: {
                width: "24px",
                height: "24px"
              },
              title: getTooltipText$1(optionName2),
              dangerouslySetInnerHTML: {
                __html: renderTooltipIcon(getTooltipText$1(optionName2))
              }
            }, void 0, false, {
              fileName: _jsxFileName$5,
              lineNumber: 703,
              columnNumber: 23
            }, void 0)]
          }, void 0, true, {
            fileName: _jsxFileName$5,
            lineNumber: 693,
            columnNumber: 19
          }, void 0), u$1("ul", {
            className: "swatches swatches--rounded flex items-start flex-wrap gap-4",
            children: swatches.map((swatch, index) => {
              const extrasKey = getExtrasKey(swatch.extras);
              const product = productData[extrasKey];
              const swatchId = getSwatchId(optionName2, swatch, index);
              const isSelected = selectedSwatches.has(swatchId);
              const isDisabled = isSwatchDisabled(swatchId);
              const isNoneSwatch = swatch.handle && swatch.handle.toLowerCase() === "none";
              return u$1("li", {
                children: u$1("div", {
                  className: "block",
                  children: product || isNoneSwatch ? u$1("div", {
                    className: `label-swatch swatches--round-slight inline-block text-sm font-medium leading-none relative px-3 py-2 border border-gray-300 rounded ${isSelected ? "selected cursor-default" : "cursor-pointer"} ${isDisabled ? "disabled" : ""}`,
                    title: getTranslatedValue(isNoneSwatch ? swatch.name || "" : formatName(product.title)),
                    onClick: () => !isSelected && toggleSwatchSelection(swatchId),
                    ...isPatternOption && product && {
                      "data-roomle-pattern": getRoomlePatternValue(product.title)
                    },
                    children: getTranslatedValue(isNoneSwatch ? swatch.name || "" : formatName(product.title))
                  }, void 0, false, {
                    fileName: _jsxFileName$5,
                    lineNumber: 726,
                    columnNumber: 31
                  }, void 0) : u$1("span", {
                    className: "secondary-swatch__placeholder text-sm",
                    children: "Loading..."
                  }, void 0, false, {
                    fileName: _jsxFileName$5,
                    lineNumber: 735,
                    columnNumber: 31
                  }, void 0)
                }, void 0, false, {
                  fileName: _jsxFileName$5,
                  lineNumber: 724,
                  columnNumber: 27
                }, void 0)
              }, `${optionName2}-${index}`, false, {
                fileName: _jsxFileName$5,
                lineNumber: 723,
                columnNumber: 25
              }, void 0);
            })
          }, void 0, false, {
            fileName: _jsxFileName$5,
            lineNumber: 713,
            columnNumber: 19
          }, void 0)]
        }, optionName2, true, {
          fileName: _jsxFileName$5,
          lineNumber: 691,
          columnNumber: 17
        }, void 0)) : u$1("p", {
          className: "secondary-swatches__placeholder",
          children: ["Swatch values: ", filteredSwatchValues.length > 0 ? filteredSwatchValues.length + " items" : "None provided"]
        }, void 0, true, {
          fileName: _jsxFileName$5,
          lineNumber: 745,
          columnNumber: 15
        }, void 0), Object.keys(groupedRelatedOptions).length > 0 && Object.entries(groupedRelatedOptions).map(([optionName2, options]) => u$1("fieldset", {
          className: "secondary-swatches__option-group variant-input-wrapper border-0 mt-4",
          children: [u$1("legend", {
            className: "sr-only",
            children: optionName2
          }, void 0, false, {
            fileName: _jsxFileName$5,
            lineNumber: 753,
            columnNumber: 19
          }, void 0), u$1("div", {
            className: "form__label flex items-center justify-between gap-2 w-full",
            children: [u$1("div", {
              className: "flex gap-2",
              children: [u$1("span", {
                className: "form__label-pretext",
                children: [optionName2, ":"]
              }, void 0, true, {
                fileName: _jsxFileName$5,
                lineNumber: 756,
                columnNumber: 23
              }, void 0), u$1("span", {
                className: "font-medium form__label-text",
                id: `${componentId}-related-${optionName2}-selected`,
                children: getTranslatedValue(selectedRelatedText)
              }, void 0, false, {
                fileName: _jsxFileName$5,
                lineNumber: 759,
                columnNumber: 23
              }, void 0)]
            }, void 0, true, {
              fileName: _jsxFileName$5,
              lineNumber: 755,
              columnNumber: 21
            }, void 0), getTooltipText$1(optionName2) && u$1("div", {
              className: "block cursor-help inline-block relative",
              style: {
                width: "24px",
                height: "24px"
              },
              title: getTooltipText$1(optionName2),
              dangerouslySetInnerHTML: {
                __html: renderTooltipIcon(getTooltipText$1(optionName2))
              }
            }, void 0, false, {
              fileName: _jsxFileName$5,
              lineNumber: 764,
              columnNumber: 23
            }, void 0)]
          }, void 0, true, {
            fileName: _jsxFileName$5,
            lineNumber: 754,
            columnNumber: 19
          }, void 0), u$1("ul", {
            className: "swatches swatches--rounded flex items-start flex-wrap gap-4",
            children: options.map((option, index) => {
              const optionId = getRelatedOptionId(optionName2, option, index);
              const isSelected = selectedRelatedOptions.has(optionId);
              const isDisabled = isRelatedOptionDisabled(optionId);
              return u$1("li", {
                children: u$1("div", {
                  className: "block",
                  children: u$1("div", {
                    className: `label-swatch swatches--round-slight inline-block text-sm font-medium leading-none relative px-3 py-2 border border-gray-300 rounded ${isSelected ? "selected cursor-default" : "cursor-pointer"} ${isDisabled ? "disabled" : ""}`,
                    title: getTranslatedValue(option.name || ""),
                    onClick: () => !isSelected && toggleRelatedOptionSelection(optionId),
                    ...isFinishRelatedOption && {
                      "data-roomle-finish": getRoomleFinishValue(option.name || "")
                    },
                    children: getTranslatedValue(option.name || "")
                  }, void 0, false, {
                    fileName: _jsxFileName$5,
                    lineNumber: 782,
                    columnNumber: 29
                  }, void 0)
                }, void 0, false, {
                  fileName: _jsxFileName$5,
                  lineNumber: 781,
                  columnNumber: 27
                }, void 0)
              }, `related-${optionName2}-${index}`, false, {
                fileName: _jsxFileName$5,
                lineNumber: 780,
                columnNumber: 25
              }, void 0);
            })
          }, void 0, false, {
            fileName: _jsxFileName$5,
            lineNumber: 774,
            columnNumber: 19
          }, void 0)]
        }, `related-${optionName2}`, true, {
          fileName: _jsxFileName$5,
          lineNumber: 752,
          columnNumber: 17
        }, void 0))]
      }, void 0, true, {
        fileName: _jsxFileName$5,
        lineNumber: 688,
        columnNumber: 11
      }, void 0)
    }, void 0, false, {
      fileName: _jsxFileName$5,
      lineNumber: 684,
      columnNumber: 7
    }, void 0)
  }, void 0, false, {
    fileName: _jsxFileName$5,
    lineNumber: 683,
    columnNumber: 5
  }, void 0);
};
register(SecondarySwatches, "secondary-swatches", ["swatchValues", "productFormId", "optionName", "preSelect", "relatedOptions", "relatedOptionsName", "roomlePatternMapping", "roomleFinishMapping", "swatchValueTranslations", "shopLocale"]);
function g(n2, t2) {
  for (var e2 in t2) n2[e2] = t2[e2];
  return n2;
}
function E(n2, t2) {
  for (var e2 in n2) if ("__source" !== e2 && !(e2 in t2)) return true;
  for (var r2 in t2) if ("__source" !== r2 && n2[r2] !== t2[r2]) return true;
  return false;
}
function N(n2, t2) {
  this.props = n2, this.context = t2;
}
(N.prototype = new x()).isPureReactComponent = true, N.prototype.shouldComponentUpdate = function(n2, t2) {
  return E(this.props, n2) || E(this.state, t2);
};
var T = l$4.__b;
l$4.__b = function(n2) {
  n2.type && n2.type.__f && n2.ref && (n2.props.ref = n2.ref, n2.ref = null), T && T(n2);
};
var A = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function D(n2) {
  function t2(t3) {
    var e2 = g({}, t3);
    return delete e2.ref, n2(e2, t3.ref || null);
  }
  return t2.$$typeof = A, t2.render = n2, t2.prototype.isReactComponent = t2.__f = true, t2.displayName = "ForwardRef(" + (n2.displayName || n2.name) + ")", t2;
}
var F = l$4.__e;
l$4.__e = function(n2, t2, e2, r2) {
  if (n2.then) {
    for (var u2, o2 = t2; o2 = o2.__; ) if ((u2 = o2.__c) && u2.__c) return null == t2.__e && (t2.__e = e2.__e, t2.__k = e2.__k), u2.__c(n2, t2);
  }
  F(n2, t2, e2, r2);
};
var U = l$4.unmount;
function V(n2, t2, e2) {
  return n2 && (n2.__c && n2.__c.__H && (n2.__c.__H.__.forEach(function(n3) {
    "function" == typeof n3.__c && n3.__c();
  }), n2.__c.__H = null), null != (n2 = g({}, n2)).__c && (n2.__c.__P === e2 && (n2.__c.__P = t2), n2.__c.__e = true, n2.__c = null), n2.__k = n2.__k && n2.__k.map(function(n3) {
    return V(n3, t2, e2);
  })), n2;
}
function W(n2, t2, e2) {
  return n2 && e2 && (n2.__v = null, n2.__k = n2.__k && n2.__k.map(function(n3) {
    return W(n3, t2, e2);
  }), n2.__c && n2.__c.__P === t2 && (n2.__e && e2.appendChild(n2.__e), n2.__c.__e = true, n2.__c.__P = e2)), n2;
}
function P() {
  this.__u = 0, this.o = null, this.__b = null;
}
function j(n2) {
  var t2 = n2.__.__c;
  return t2 && t2.__a && t2.__a(n2);
}
function B() {
  this.i = null, this.l = null;
}
l$4.unmount = function(n2) {
  var t2 = n2.__c;
  t2 && t2.__R && t2.__R(), t2 && 32 & n2.__u && (n2.type = null), U && U(n2);
}, (P.prototype = new x()).__c = function(n2, t2) {
  var e2 = t2.__c, r2 = this;
  null == r2.o && (r2.o = []), r2.o.push(e2);
  var u2 = j(r2.__v), o2 = false, i2 = function() {
    o2 || (o2 = true, e2.__R = null, u2 ? u2(l2) : l2());
  };
  e2.__R = i2;
  var l2 = function() {
    if (!--r2.__u) {
      if (r2.state.__a) {
        var n3 = r2.state.__a;
        r2.__v.__k[0] = W(n3, n3.__c.__P, n3.__c.__O);
      }
      var t3;
      for (r2.setState({ __a: r2.__b = null }); t3 = r2.o.pop(); ) t3.forceUpdate();
    }
  };
  r2.__u++ || 32 & t2.__u || r2.setState({ __a: r2.__b = r2.__v.__k[0] }), n2.then(i2, i2);
}, P.prototype.componentWillUnmount = function() {
  this.o = [];
}, P.prototype.render = function(n2, e2) {
  if (this.__b) {
    if (this.__v.__k) {
      var r2 = document.createElement("div"), o2 = this.__v.__k[0].__c;
      this.__v.__k[0] = V(this.__b, r2, o2.__O = o2.__P);
    }
    this.__b = null;
  }
  var i2 = e2.__a && _$1(k$1, null, n2.fallback);
  return i2 && (i2.__u &= -33), [_$1(k$1, null, e2.__a ? null : n2.children), i2];
};
var H = function(n2, t2, e2) {
  if (++e2[1] === e2[0] && n2.l.delete(t2), n2.props.revealOrder && ("t" !== n2.props.revealOrder[0] || !n2.l.size)) for (e2 = n2.i; e2; ) {
    for (; e2.length > 3; ) e2.pop()();
    if (e2[1] < e2[0]) break;
    n2.i = e2 = e2[2];
  }
};
(B.prototype = new x()).__a = function(n2) {
  var t2 = this, e2 = j(t2.__v), r2 = t2.l.get(n2);
  return r2[0]++, function(u2) {
    var o2 = function() {
      t2.props.revealOrder ? (r2.push(u2), H(t2, n2, r2)) : u2();
    };
    e2 ? e2(o2) : o2();
  };
}, B.prototype.render = function(n2) {
  this.i = null, this.l = /* @__PURE__ */ new Map();
  var t2 = H$1(n2.children);
  n2.revealOrder && "b" === n2.revealOrder[0] && t2.reverse();
  for (var e2 = t2.length; e2--; ) this.l.set(t2[e2], this.i = [1, 0, this.i]);
  return n2.children;
}, B.prototype.componentDidUpdate = B.prototype.componentDidMount = function() {
  var n2 = this;
  this.l.forEach(function(t2, e2) {
    H(n2, e2, t2);
  });
};
var q = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, G = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, J = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, K = /[A-Z0-9]/g, Q = "undefined" != typeof document, X = function(n2) {
  return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/ : /fil|che|ra/).test(n2);
};
x.prototype.isReactComponent = {}, ["componentWillMount", "componentWillReceiveProps", "componentWillUpdate"].forEach(function(t2) {
  Object.defineProperty(x.prototype, t2, { configurable: true, get: function() {
    return this["UNSAFE_" + t2];
  }, set: function(n2) {
    Object.defineProperty(this, t2, { configurable: true, writable: true, value: n2 });
  } });
});
var en = l$4.event;
function rn() {
}
function un() {
  return this.cancelBubble;
}
function on() {
  return this.defaultPrevented;
}
l$4.event = function(n2) {
  return en && (n2 = en(n2)), n2.persist = rn, n2.isPropagationStopped = un, n2.isDefaultPrevented = on, n2.nativeEvent = n2;
};
var cn = { enumerable: false, configurable: true, get: function() {
  return this.class;
} }, fn = l$4.vnode;
l$4.vnode = function(n2) {
  "string" == typeof n2.type && function(n3) {
    var t2 = n3.props, e2 = n3.type, u2 = {}, o2 = -1 === e2.indexOf("-");
    for (var i2 in t2) {
      var l2 = t2[i2];
      if (!("value" === i2 && "defaultValue" in t2 && null == l2 || Q && "children" === i2 && "noscript" === e2 || "class" === i2 || "className" === i2)) {
        var c2 = i2.toLowerCase();
        "defaultValue" === i2 && "value" in t2 && null == t2.value ? i2 = "value" : "download" === i2 && true === l2 ? l2 = "" : "translate" === c2 && "no" === l2 ? l2 = false : "o" === c2[0] && "n" === c2[1] ? "ondoubleclick" === c2 ? i2 = "ondblclick" : "onchange" !== c2 || "input" !== e2 && "textarea" !== e2 || X(t2.type) ? "onfocus" === c2 ? i2 = "onfocusin" : "onblur" === c2 ? i2 = "onfocusout" : J.test(i2) && (i2 = c2) : c2 = i2 = "oninput" : o2 && G.test(i2) ? i2 = i2.replace(K, "-$&").toLowerCase() : null === l2 && (l2 = void 0), "oninput" === c2 && u2[i2 = c2] && (i2 = "oninputCapture"), u2[i2] = l2;
      }
    }
    "select" == e2 && u2.multiple && Array.isArray(u2.value) && (u2.value = H$1(t2.children).forEach(function(n4) {
      n4.props.selected = -1 != u2.value.indexOf(n4.props.value);
    })), "select" == e2 && null != u2.defaultValue && (u2.value = H$1(t2.children).forEach(function(n4) {
      n4.props.selected = u2.multiple ? -1 != u2.defaultValue.indexOf(n4.props.value) : u2.defaultValue == n4.props.value;
    })), t2.class && !t2.className ? (u2.class = t2.class, Object.defineProperty(u2, "className", cn)) : (t2.className && !t2.class || t2.class && t2.className) && (u2.class = u2.className = t2.className), n3.props = u2;
  }(n2), n2.$$typeof = q, fn && fn(n2);
};
var an = l$4.__r;
l$4.__r = function(n2) {
  an && an(n2), n2.__c;
};
var sn = l$4.diffed;
l$4.diffed = function(n2) {
  sn && sn(n2);
  var t2 = n2.props, e2 = n2.__e;
  null != e2 && "textarea" === n2.type && "value" in t2 && t2.value !== e2.value && (e2.value = null == t2.value ? "" : t2.value);
};
const _RoomleSwatchHandler = class _RoomleSwatchHandler {
  constructor() {
    this.roomleViewer = null;
    this.isInitialized = false;
    this.init();
  }
  static getInstance() {
    if (!_RoomleSwatchHandler.instance) {
      _RoomleSwatchHandler.instance = new _RoomleSwatchHandler();
    }
    return _RoomleSwatchHandler.instance;
  }
  init() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.setupEventListeners());
    } else {
      this.setupEventListeners();
    }
  }
  setupEventListeners() {
    document.addEventListener("roomle-custom-size-update", (event) => {
      const {
        parameterName,
        value
      } = event.detail;
      this.handleCustomSizeUpdate(parameterName, value);
    });
    document.addEventListener("roomle-finish-update", async (event) => {
      const customEvent = event;
      const {
        parameterName,
        value
      } = customEvent.detail;
      try {
        await this.updateRoomleParameter(parameterName, value);
      } catch (error) {
        console.error("❌ Error in roomle-finish-update handler:", error);
      }
    });
    document.addEventListener("click", (event) => {
      const target = event.target;
      let currentElement = target;
      let roomleFabric = null;
      let roomleFrequency = null;
      let roomleShape = null;
      let roomlePattern = null;
      let roomleFinish = null;
      let roomleSize = null;
      let roomleStanding = null;
      let roomleElement = null;
      let roomleEndCaps = null;
      for (let i2 = 0; i2 < 5 && currentElement; i2++) {
        roomleFabric = currentElement.getAttribute("data-roomle-fabric") || currentElement.getAttribute("data-roomle-color");
        roomleFrequency = currentElement.getAttribute("data-roomle-frequency");
        roomleShape = currentElement.getAttribute("data-roomle-shape");
        roomlePattern = currentElement.getAttribute("data-roomle-pattern");
        roomleFinish = currentElement.getAttribute("data-roomle-finish");
        roomleSize = currentElement.getAttribute("data-roomle-custom-size");
        roomleStanding = currentElement.getAttribute("data-roomle-standing");
        roomleEndCaps = currentElement.getAttribute("data-roomle-endcaps");
        if (roomleFabric || roomleFrequency || roomleShape || roomlePattern || roomleFinish || roomleSize || roomleStanding || roomleEndCaps) {
          roomleElement = currentElement;
          break;
        }
        currentElement = currentElement.parentElement;
      }
      if (roomleFabric && roomleElement) {
        this.handleSwatchClick(roomleFabric, roomleElement, "fabric");
      } else if (roomleFrequency && roomleElement) {
        this.handleSwatchClick(roomleFrequency, roomleElement, "frequency");
      } else if (roomleShape && roomleElement) {
        this.handleSwatchClick(roomleShape, roomleElement, "shape");
      } else if (roomlePattern && roomleElement) {
        this.handleSwatchClick(roomlePattern, roomleElement, "pattern");
      } else if (roomleFinish && roomleElement) {
        this.handleSwatchClick(roomleFinish, roomleElement, "finish");
      } else if (roomleSize && roomleElement) {
        this.handleSwatchClick(roomleSize, roomleElement, "customSize");
      } else if (roomleStanding && roomleElement) {
        this.handleSwatchClick(roomleStanding, roomleElement, "standing");
      }
    });
    document.addEventListener("change", (event) => {
      const target = event.target;
      if (target.type === "radio" && target.form) {
        const label = document.querySelector(`label[for="${target.id}"]`);
        if (label) {
          const roomleFabric = label.getAttribute("data-roomle-fabric") || label.getAttribute("data-roomle-color");
          const roomleFrequency = label.getAttribute("data-roomle-frequency");
          const roomleShape = label.getAttribute("data-roomle-shape");
          const roomlePattern = label.getAttribute("data-roomle-pattern");
          const roomleFinish = label.getAttribute("data-roomle-finish");
          const roomleSize = label.getAttribute("data-roomle-custom-size");
          const roomleStanding = label.getAttribute("data-roomle-standing");
          const roomleEndCaps = label.getAttribute("data-roomle-endcaps");
          if (roomleFabric) {
            this.handleSwatchClick(roomleFabric, label, "fabric");
          } else if (roomleFrequency) {
            this.handleSwatchClick(roomleFrequency, label, "frequency");
          } else if (roomleShape) {
            this.handleSwatchClick(roomleShape, label, "shape");
          } else if (roomlePattern) {
            this.handleSwatchClick(roomlePattern, label, "pattern");
          } else if (roomleFinish) {
            this.handleSwatchClick(roomleFinish, label, "finish");
          } else if (roomleSize) {
            this.handleSwatchClick(roomleSize, label, "customSize");
          } else if (roomleStanding) {
            this.handleSwatchClick(roomleStanding, label, "standing");
          } else if (roomleEndCaps) {
            this.handleSwatchClick(roomleEndCaps, label, "endCaps");
          }
        }
      }
    });
  }
  async handleSwatchClick(roomleValue, element, parameterType) {
    try {
      if (!this.roomleViewer) {
        this.roomleViewer = document.querySelector("roomle-viewer");
      }
      if (!this.roomleViewer) {
        console.warn("RoomleViewer not found in DOM");
        return;
      }
      await this.updateRoomleParameter(parameterType, roomleValue);
    } catch (error) {
      console.error("Error updating Roomle parameter:", error);
    }
  }
  async handleCustomSizeUpdate(parameterName, value) {
    try {
      if (!this.roomleViewer) {
        this.roomleViewer = document.querySelector("roomle-viewer");
      }
      if (!this.roomleViewer) {
        console.warn("RoomleViewer not found in DOM");
        return;
      }
      await this.updateRoomleParameter(parameterName, value);
    } catch (error) {
      console.error("Error updating Roomle custom size parameter:", error);
    }
  }
  async updateRoomleParameter(parameterName, value) {
    if (!this.roomleViewer) {
      this.roomleViewer = document.querySelector("roomle-viewer");
      if (!this.roomleViewer) {
        console.error("❌ No roomle-viewer element found in DOM");
        return;
      }
    }
    if (typeof this.roomleViewer.updateRoomleParameter === "function") {
      try {
        await this.roomleViewer.updateRoomleParameter(parameterName, value);
      } catch (error) {
        console.error("❌ Error in updateRoomleParameter:", error);
      }
      return;
    }
    const updateEvent = new CustomEvent("roomle-update-parameter", {
      detail: {
        parameterName,
        value
      },
      bubbles: true
    });
    this.roomleViewer.dispatchEvent(updateEvent);
    if (this.roomleViewer._componentInstance) {
      const component = this.roomleViewer._componentInstance;
      if (component && typeof component.updateParameter === "function") {
        try {
          await component.updateParameter(parameterName, value);
        } catch (error) {
          console.error("❌ Error in component.updateParameter:", error);
        }
      }
    }
  }
};
_RoomleSwatchHandler.instance = null;
let RoomleSwatchHandler = _RoomleSwatchHandler;
const initRoomleSwatchHandler = () => {
  return RoomleSwatchHandler.getInstance();
};
const setupRoomleDebugFunctions = (configuratorInstance, ref, parameters, currentValues, getSelectedSwatchValues, isLoading, error, updateParameterForAllComponents, forceStandingParameterRefresh) => {
  window.debugRoomleParameters = async () => {
    var _a, _b, _c, _d;
    console.group("🔧 Roomle Parameters Debug");
    try {
      const roomleViewer = document.querySelector("roomle-viewer");
      if (!roomleViewer) {
        console.error("❌ No Roomle viewer found in DOM");
        return;
      }
      if (!configuratorInstance) {
        console.error("❌ Configurator not initialized");
        return;
      }
      const parameterAPI = configuratorInstance.configurator;
      console.log("📋 Configurator API:", parameterAPI);
      try {
        const currentConfig = await configuratorInstance.getCurrentConfiguration();
        console.log("⚙️ Current Configuration:", currentConfig);
      } catch (err) {
        console.warn("⚠️ Could not get current configuration:", err);
      }
      try {
        const allParameters = await ((_b = (_a = ref.current) == null ? void 0 : _a.getParameters) == null ? void 0 : _b.call(_a));
        if (allParameters && allParameters.length > 0) {
          console.group("📊 All Available Parameters (" + allParameters.length + " total)");
          const paramGroups = {};
          allParameters.forEach((param) => {
            const group = param.type || "unknown";
            if (!paramGroups[group]) paramGroups[group] = [];
            paramGroups[group].push(param);
          });
          Object.entries(paramGroups).forEach(([type, params]) => {
            console.group(`📁 ${type.toUpperCase()} Parameters (${params.length})`);
            params.forEach((param) => {
              console.log(`🔹 ${param.key}:`, {
                value: param.value || param.currentValue,
                type: param.type,
                label: param.label,
                options: param.possibleValues || param.options,
                min: param.min,
                max: param.max,
                full: param
              });
            });
            console.groupEnd();
          });
          console.groupEnd();
        } else {
          console.warn("⚠️ No parameters found or parameters array is empty");
        }
      } catch (err) {
        console.error("❌ Error getting all parameters:", err);
      }
      try {
        if (typeof parameterAPI.getParametersOfRootComponent === "function") {
          const rootParams = await parameterAPI.getParametersOfRootComponent();
          console.group("🌿 Root Component Parameters (" + rootParams.length + ")");
          rootParams.forEach((param, index) => {
            console.log(`${index + 1}. ${param.key}:`, param);
          });
          console.groupEnd();
        }
      } catch (err) {
        console.warn("⚠️ Could not get root parameters:", err);
      }
      try {
        if (typeof parameterAPI.getParametersOfPlanObject === "function") {
          const planParams = await parameterAPI.getParametersOfPlanObject();
          if (planParams && planParams.length > 0) {
            console.group("📐 Plan Object Parameters (" + planParams.length + ")");
            planParams.forEach((param, index) => {
              console.log(`${index + 1}. ${param.key}:`, param);
            });
            console.groupEnd();
          }
        }
      } catch (err) {
        console.debug("ℹ️ No plan object parameters (this is normal for simple products)");
      }
      try {
        if (typeof parameterAPI.getPartList === "function") {
          const partList = await parameterAPI.getPartList();
          if (partList && partList.length > 0) {
            console.group("🧩 Component Parts (" + partList.length + ")");
            for (const [index, part] of partList.entries()) {
              console.log(`${index + 1}. ${part.name || part.id}:`, part);
              if (part.runtimeId && typeof parameterAPI.getParametersOfComponent === "function") {
                try {
                  const componentParams = await parameterAPI.getParametersOfComponent(part.runtimeId);
                  if (componentParams && componentParams.length > 0) {
                    console.group(`  📋 Parameters for ${part.name || part.id}`);
                    componentParams.forEach((param) => {
                      console.log(`    🔸 ${param.key}:`, param);
                    });
                    console.groupEnd();
                  }
                } catch (err) {
                  console.debug(`    ℹ️ Could not get parameters for component ${part.runtimeId}`);
                }
              }
            }
            console.groupEnd();
          }
        }
      } catch (err) {
        console.warn("⚠️ Could not get part list:", err);
      }
      console.group("🎨 Current Swatch Values");
      const swatchValues = getSelectedSwatchValues();
      if (Object.keys(swatchValues).length > 0) {
        Object.entries(swatchValues).forEach(([key, value]) => {
          const isStructural = ["standing", "mounting", "feet", "base", "support", "frame", "structure"].includes(key.toLowerCase());
          console.log(`🎯 ${key}: "${value}"${isStructural ? " (🔧 structural)" : ""}`);
        });
      } else {
        console.log("ℹ️ No swatch values currently selected");
      }
      console.groupEnd();
      console.group("🔧 Structural Parameter Analysis");
      try {
        const allParametersForAnalysis = await ((_d = (_c = ref.current) == null ? void 0 : _c.getParameters) == null ? void 0 : _d.call(_c)) || [];
        const structuralParams = allParametersForAnalysis == null ? void 0 : allParametersForAnalysis.filter((param) => {
          var _a2;
          return ["standing", "mounting", "feet", "base", "support", "frame", "structure"].includes((_a2 = param.key) == null ? void 0 : _a2.toLowerCase());
        });
        if (structuralParams && structuralParams.length > 0) {
          console.log("📋 Found structural parameters:");
          structuralParams.forEach((param) => {
            console.log(`🔧 ${param.key}:`, {
              currentValue: param.value || param.currentValue,
              validValues: param.validValues || param.possibleValues,
              type: param.type,
              source: param.source,
              label: param.label
            });
          });
          console.group("🔄 Available Refresh Methods");
          const refreshMethods = ["updateScene", "refreshScene", "rebuild", "rebuildScene", "updateVisuals", "refresh", "rebuildGeometry", "updateGeometry", "forceRebuild", "resetScene", "reloadConfiguration"];
          refreshMethods.forEach((method) => {
            const available = typeof parameterAPI[method] === "function";
            console.log(`${available ? "✅" : "❌"} ${method}`);
          });
          console.groupEnd();
        } else {
          console.log("ℹ️ No structural parameters detected");
        }
      } catch (err) {
        console.warn("⚠️ Could not analyze structural parameters:", err);
      }
      console.groupEnd();
      console.group("📊 Component State");
      console.log("🔄 Current Values:", currentValues);
      console.log("📋 Stored Parameters:", parameters);
      console.log("🏗️ Configurator Instance:", configuratorInstance);
      console.log("⚡ Is Loading:", isLoading);
      console.log("🚫 Error:", error);
      console.groupEnd();
      console.log("✅ Debug complete! All available parameter information has been logged above.");
    } catch (err) {
      console.error("❌ Error in debugRoomleParameters:", err);
    }
    console.groupEnd();
  };
  window.debugStandingParameter = async () => {
    console.group("🦵 Standing Parameter Debug");
    try {
      if (!configuratorInstance) {
        console.error("❌ Configurator not initialized");
        return;
      }
      const parameterAPI = configuratorInstance.configurator;
      try {
        const currentConfig = await configuratorInstance.getCurrentConfiguration();
        console.log("⚙️ Current Configuration:", currentConfig);
      } catch (err) {
        console.warn("⚠️ Could not get configuration:", err);
      }
      console.group("🔍 Standing Parameter Search");
      try {
        const planParams = await parameterAPI.getParametersOfPlanObject();
        const standingPlanParam = planParams == null ? void 0 : planParams.find((p2) => p2.key === "standing");
        if (standingPlanParam) {
          console.log("📐 Found standing parameter in plan object:", standingPlanParam);
        } else {
          console.log("ℹ️ No standing parameter in plan object");
        }
      } catch (err) {
        console.debug("ℹ️ No plan object or plan parameters");
      }
      try {
        const rootParams = await parameterAPI.getParametersOfRootComponent();
        const standingRootParam = rootParams == null ? void 0 : rootParams.find((p2) => p2.key === "standing");
        if (standingRootParam) {
          console.log("🌿 Found standing parameter in root component:", standingRootParam);
        } else {
          console.log("ℹ️ No standing parameter in root component");
        }
      } catch (err) {
        console.warn("⚠️ Could not get root parameters:", err);
      }
      console.groupEnd();
      console.group("🧪 Test Standing Parameter Updates");
      const testUpdate = async (value) => {
        console.log(`
🔄 Testing update to "${value}"`);
        const expectedBehavior = value.toLowerCase() === "freestand" ? "(should ADD feet with aggressive refresh)" : "(should REMOVE feet with original logic - no additional refresh)";
        console.log(`🎯 Expected behavior: ${expectedBehavior}`);
        try {
          await updateParameterForAllComponents(parameterAPI, "standing", value);
          await new Promise((resolve) => setTimeout(resolve, 500));
          try {
            const planParams = await parameterAPI.getParametersOfPlanObject();
            const standingParam = planParams == null ? void 0 : planParams.find((p2) => p2.key === "standing");
            if (standingParam) {
              console.log(`✅ Plan object standing value after update: "${standingParam.value}"`);
            }
          } catch (err) {
            try {
              const rootParams = await parameterAPI.getParametersOfRootComponent();
              const standingParam = rootParams == null ? void 0 : rootParams.find((p2) => p2.key === "standing");
              if (standingParam) {
                console.log(`✅ Root component standing value after update: "${standingParam.value}"`);
              }
            } catch (rootErr) {
              console.warn("⚠️ Could not verify parameter value after update");
            }
          }
        } catch (err) {
          console.error(`❌ Failed to update standing to "${value}":`, err);
        }
      };
      console.log("📝 Instructions: This will test switching between freestand and wallmount");
      console.log("🎯 Watch the 3D model to see if feet appear/disappear correctly");
      console.log("🔧 Use these commands to test:");
      console.log("  window.testStandingFreestand() - Switch to freestand");
      console.log("  window.testStandingWallmount() - Switch to wallmount");
      window.testStandingFreestand = () => testUpdate("freestand");
      window.testStandingWallmount = () => testUpdate("wallmount");
      window.testAggressiveRefresh = async () => {
        console.log("🚀 Testing aggressive refresh for standing parameter...");
        try {
          await forceStandingParameterRefresh(parameterAPI, "freestand");
          console.log("✅ Aggressive refresh test completed");
        } catch (err) {
          console.error("❌ Aggressive refresh test failed:", err);
        }
      };
      console.log("  window.testAggressiveRefresh() - Test aggressive geometry refresh");
      console.groupEnd();
    } catch (err) {
      console.error("❌ Error in debugStandingParameter:", err);
    }
    console.groupEnd();
  };
};
const cleanupRoomleDebugFunctions = () => {
  delete window.debugRoomleParameters;
  delete window.debugStandingParameter;
  delete window.testStandingFreestand;
  delete window.testStandingWallmount;
  delete window.testAggressiveRefresh;
};
const getRoomleUIConfig = () => ({
  locale: "en",
  showHints: false,
  showShare: false,
  showPrice: false,
  showBranding: false,
  showConfiguration: false,
  showSettings: false,
  showAR: false,
  showFullscreen: false,
  showHelp: false,
  hideInteractionPopup: true,
  buttons: {
    savedraft: false,
    requestproduct: false,
    startconfigure: false,
    "2dview": false,
    "3dview": false,
    add_measurement_line: false,
    add_room: false,
    add_to_basket: false,
    addons: false,
    ar: false,
    close_view: false,
    configure_in_room: false,
    dimensions: false,
    export3d: false,
    firstperson: false,
    fullscreen: false,
    help_center: false,
    load_product: false,
    multiselect: false,
    partlist: false,
    partlist_planner: false,
    partlist_print: false,
    pauseconfigure: false,
    productlist: false,
    redo: false,
    renderimage: false,
    requestplan: false,
    resetcamera: false,
    rotate: false,
    snapping: false,
    startPlanner: false,
    swap_product: false,
    undo: false,
    view_mode: false
  },
  notifications: {
    "first-person-controls": false,
    interaction: {
      "add-element": false,
      "confirm-ghosts": false,
      "parameters-changed": false,
      "root-element": false
    },
    "load-idb-config": false,
    "stop-configure-hint": false
  },
  interactionsCollapsed: true,
  elements: {
    bottom_bar: false,
    moc: true,
    interaction_notes: false,
    parameter_groups: false,
    partlist_bounds: false
  },
  roomDesignerActive: false
});
var _jsxFileName$4 = "/home/runner/work/GIK2024_GIK/GIK2024_GIK/src/components/Roomle/RoomleViewer.tsx";
const RoomleViewer = D(({
  productId = "",
  configuratorId = "gikacoustics",
  catalogId = "gik"
}, ref) => {
  const containerRef = t$3(A$1(null), "containerRef");
  const viewerRef = t$3(A$1(null), "viewerRef");
  const [isLoading, setIsLoading] = t$3(d(true), "isLoading");
  const [error, setError] = t$3(d(null), "error");
  const [configuratorInstance, setConfiguratorInstance] = t$3(d(null), "configuratorInstance");
  const [parameters, setParameters] = t$3(d([]), "parameters");
  const [currentValues, setCurrentValues] = t$3(d({}), "currentValues");
  y(() => {
    initRoomleSwatchHandler();
  }, []);
  y(() => {
    const calculateStickyTop = () => {
      const topbar = document.querySelector(".topbar");
      const headerSection = document.querySelector(".header-section");
      let totalHeight = 0;
      if (topbar) {
        totalHeight += topbar.offsetHeight;
      }
      if (headerSection) {
        totalHeight += headerSection.offsetHeight;
      }
      if (viewerRef.current) {
        const galleryContainer = viewerRef.current.closest(".product__gallery-container");
        if (galleryContainer) {
          galleryContainer.style.setProperty("--roomle-sticky-top", `${totalHeight}px`);
        }
      }
    };
    calculateStickyTop();
    window.addEventListener("resize", calculateStickyTop);
    return () => {
      window.removeEventListener("resize", calculateStickyTop);
    };
  }, []);
  y(() => {
    const handleResponsivePosition = () => {
      var _a;
      const isMobile = window.innerWidth < 1024;
      const customElement = (_a = viewerRef.current) == null ? void 0 : _a.closest("roomle-viewer");
      const mobilePlaceholder = document.getElementById("roomle-viewer-mobile-placeholder");
      const desktopContainer = document.querySelector(".product__gallery-container");
      if (!customElement) {
        console.warn("⚠️ Could not find roomle-viewer custom element");
        return;
      }
      if (isMobile && mobilePlaceholder && customElement.parentElement !== mobilePlaceholder) {
        mobilePlaceholder.appendChild(customElement);
      } else if (!isMobile && desktopContainer && customElement.parentElement !== desktopContainer) {
        desktopContainer.insertBefore(customElement, desktopContainer.firstChild);
      }
    };
    const timer = setTimeout(() => {
      handleResponsivePosition();
    }, 100);
    const resizeHandler = () => {
      handleResponsivePosition();
    };
    window.addEventListener("resize", resizeHandler);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", resizeHandler);
    };
  }, []);
  const forceSceneRefresh = async (parameterAPI, isStructuralParameter = false) => {
    try {
      const refreshMethods = ["updateScene", "refreshScene", "rebuild", "rebuildScene", "updateVisuals", "refresh"];
      for (const method of refreshMethods) {
        if (typeof parameterAPI[method] === "function") {
          try {
            await parameterAPI[method]();
          } catch (err) {
            console.debug(`⚠️ ${method} not available or failed:`, err);
          }
        }
      }
      if (isStructuralParameter) {
        const structuralRefreshMethods = ["rebuildGeometry", "updateGeometry", "forceRebuild", "resetScene", "reloadConfiguration"];
        for (const method of structuralRefreshMethods) {
          if (typeof parameterAPI[method] === "function") {
            try {
              await parameterAPI[method]();
            } catch (err) {
              console.debug(`⚠️ Structural method ${method} not available:`, err);
            }
          }
        }
        await new Promise((resolve) => setTimeout(resolve, 150));
      }
    } catch (err) {
      console.warn("Error during scene refresh:", err);
    }
  };
  const forceStandingParameterRefresh = async (parameterAPI, value) => {
    var _a;
    try {
      const aggressiveRefreshSequence = [{
        method: "updateScene",
        delay: 50
      }, {
        method: "rebuild",
        delay: 100
      }, {
        method: "rebuildGeometry",
        delay: 100
      }, {
        method: "updateVisuals",
        delay: 50
      }, {
        method: "refreshScene",
        delay: 100
      }, {
        method: "rebuildScene",
        delay: 150
      }, {
        method: "updateGeometry",
        delay: 100
      }, {
        method: "forceRebuild",
        delay: 150
      }, {
        method: "resetScene",
        delay: 200
      }];
      for (const {
        method,
        delay
      } of aggressiveRefreshSequence) {
        if (typeof parameterAPI[method] === "function") {
          try {
            await parameterAPI[method]();
            await new Promise((resolve) => setTimeout(resolve, delay));
          } catch (err) {
            console.debug(`⚠️ ${method} failed:`, err);
          }
        }
      }
      if (value.toLowerCase() === "freestand") {
        try {
          const currentConfig = await parameterAPI.getCurrentConfiguration();
          if (configuratorInstance && typeof ((_a = configuratorInstance.ui) == null ? void 0 : _a.loadConfiguration) === "function") {
            await new Promise((resolve) => setTimeout(resolve, 100));
            await configuratorInstance.ui.loadConfiguration(currentConfig);
          }
        } catch (reloadErr) {
          console.debug("ℹ️ Configuration reload not available or failed:", reloadErr);
        }
        try {
          const planParams = await parameterAPI.getParametersOfPlanObject();
          const standingParam = planParams == null ? void 0 : planParams.find((p2) => p2.key.toLowerCase() === "standing");
          if (standingParam && standingParam.value !== value) {
            await parameterAPI.setParameterOfPlanObject(standingParam, value);
            await parameterAPI.updateScene();
          }
        } catch (reapplyErr) {
          console.debug("ℹ️ Parameter re-application failed:", reapplyErr);
        }
      }
      await new Promise((resolve) => setTimeout(resolve, 200));
    } catch (err) {
      console.warn("Error during standing parameter refresh:", err);
    }
  };
  const updateParameterForAllComponents = async (parameterAPI, parameterKey, value) => {
    try {
      const structuralParameters = ["standing", "mounting", "feet", "base", "support", "frame", "structure"];
      const isStructuralParameter = structuralParameters.includes(parameterKey.toLowerCase());
      const isStandingParameter = parameterKey.toLowerCase() === "standing";
      let hasNestedComponents = false;
      let parameterUpdated = false;
      let updateMethod = "";
      try {
        const currentConfigRaw = await parameterAPI.getCurrentConfiguration();
        const currentConfig = typeof currentConfigRaw === "string" ? JSON.parse(currentConfigRaw) : currentConfigRaw;
        hasNestedComponents = currentConfig && currentConfig.children && currentConfig.children.length > 0;
      } catch (err) {
        hasNestedComponents = false;
      }
      if (hasNestedComponents) {
        try {
          const planParams = await parameterAPI.getParametersOfPlanObject();
          const planParam = planParams == null ? void 0 : planParams.find((p2) => p2.key.toLowerCase() === parameterKey.toLowerCase());
          if (planParam && typeof parameterAPI.setParameterOfPlanObject === "function") {
            await parameterAPI.setParameterOfPlanObject(planParam, value);
            parameterUpdated = true;
            updateMethod = "plan object";
          }
        } catch (planErr) {
          console.debug("Plan parameter update failed, trying root component:", planErr);
        }
      }
      if (!parameterUpdated || !hasNestedComponents) {
        try {
          const rootParams = await parameterAPI.getParametersOfRootComponent();
          const rootParam = rootParams == null ? void 0 : rootParams.find((p2) => p2.key.toLowerCase() === parameterKey.toLowerCase());
          if (rootParam && typeof parameterAPI.setParameterOfRootComponent === "function") {
            await parameterAPI.setParameterOfRootComponent(rootParam, value);
            parameterUpdated = true;
            updateMethod = parameterUpdated ? `${updateMethod} + root` : "root component";
          }
        } catch (rootErr) {
          console.warn("Root parameter update failed:", rootErr);
        }
      }
      if (parameterUpdated && isStructuralParameter) {
        if (isStandingParameter) {
          if (value.toLowerCase() === "freestand") {
            await forceStandingParameterRefresh(parameterAPI, value);
          }
        } else {
          await forceSceneRefresh(parameterAPI, isStructuralParameter);
        }
      } else if (parameterUpdated && !isStandingParameter) {
        await forceSceneRefresh(parameterAPI, false);
      }
      if (!parameterUpdated) {
        if (isStructuralParameter) {
          if (isStandingParameter) {
            if (value.toLowerCase() === "freestand") {
              await forceStandingParameterRefresh(parameterAPI, value);
            }
          } else {
            await forceSceneRefresh(parameterAPI, true);
          }
        }
      }
    } catch (err) {
      console.error("Error updating parameter:", err);
      throw err;
    }
  };
  F$1(ref, () => ({
    updateParameter: async (parameterName, value) => {
      if (!configuratorInstance) {
        throw new Error("Configurator not initialized");
      }
      try {
        const parameterAPI = configuratorInstance.configurator;
        await updateParameterForAllComponents(parameterAPI, parameterName, value);
      } catch (err) {
        console.error("Error updating parameter:", err);
        throw err;
      }
    },
    getParameters: async () => {
      if (!configuratorInstance) {
        throw new Error("Configurator not initialized");
      }
      const parameterAPI = configuratorInstance.configurator;
      const allParams = [];
      if (typeof parameterAPI.getParametersOfRootComponent === "function") {
        const rootParams = await parameterAPI.getParametersOfRootComponent();
        allParams.push(...rootParams);
      }
      if (typeof parameterAPI.getPartList === "function") {
        const partList = await parameterAPI.getPartList();
        for (const part of partList) {
          if (part.runtimeId && typeof parameterAPI.getParametersOfComponent === "function") {
            try {
              const componentParams = await parameterAPI.getParametersOfComponent(part.runtimeId);
              allParams.push(...componentParams);
            } catch (err) {
              console.debug(`Couldn't get parameters for component ${part.runtimeId}:`, err);
            }
          }
        }
      }
      return allParams;
    },
    getConfiguration: async () => {
      if (!configuratorInstance) {
        throw new Error("Configurator not initialized");
      }
      return await configuratorInstance.getCurrentConfiguration();
    }
  }), [configuratorInstance]);
  const getSelectedSwatchValues = () => {
    const swatchValues = {};
    const checkedInputs = document.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked');
    checkedInputs.forEach((input) => {
      const inputElement = input;
      let label = null;
      if (inputElement.id) {
        label = document.querySelector(`label[for="${inputElement.id}"]`);
      }
      if (!label && inputElement.parentElement) {
        label = inputElement.parentElement.querySelector("label");
        if (!label) {
          const parent = inputElement.parentElement;
          label = parent.tagName.toLowerCase() === "label" ? parent : null;
        }
      }
      if (label) {
        const roomleFabric = label.getAttribute("data-roomle-fabric");
        const roomleColor = label.getAttribute("data-roomle-color");
        const roomleFrequency = label.getAttribute("data-roomle-frequency");
        const roomleShape = label.getAttribute("data-roomle-shape");
        const roomlePattern = label.getAttribute("data-roomle-pattern");
        const roomleFinish = label.getAttribute("data-roomle-finish");
        const roomleStanding = label.getAttribute("data-roomle-standing");
        const roomleEndCaps = label.getAttribute("data-roomle-endCaps");
        if (roomleFabric) swatchValues["fabric"] = roomleFabric;
        if (roomleColor) swatchValues["fabric"] = roomleColor;
        if (roomleFrequency) swatchValues["frequency"] = roomleFrequency;
        if (roomleShape) swatchValues["shape"] = roomleShape;
        if (roomlePattern) swatchValues["pattern"] = roomlePattern;
        if (roomleFinish) swatchValues["finish"] = roomleFinish;
        if (roomleStanding) swatchValues["standing"] = roomleStanding;
        if (roomleEndCaps) swatchValues["endCaps"] = roomleEndCaps;
      }
    });
    const selectedSecondarySwatches = document.querySelectorAll(".selected[data-roomle-pattern], .selected[data-roomle-finish], .selected[data-roomle-standing], .selected[data-roomle-endCaps]");
    selectedSecondarySwatches.forEach((element) => {
      const swatchElement = element;
      const roomlePattern = swatchElement.getAttribute("data-roomle-pattern");
      const roomleFinish = swatchElement.getAttribute("data-roomle-finish");
      const roomleEndCaps = swatchElement.getAttribute("data-roomle-endCaps");
      if (roomlePattern) swatchValues["pattern"] = roomlePattern;
      if (roomleFinish) swatchValues["finish"] = roomleFinish;
      if (roomleEndCaps) swatchValues["endCaps"] = roomleEndCaps;
    });
    return swatchValues;
  };
  const updateParameter = async (parameterKey, value) => {
    if (!configuratorInstance) {
      return;
    }
    try {
      const parameterAPI = configuratorInstance.configurator;
      if (parameterAPI) {
        await updateParameterForAllComponents(parameterAPI, parameterKey, value);
        setCurrentValues((prev) => ({
          ...prev,
          [parameterKey]: value
        }));
      }
    } catch (err) {
      console.error("Error updating parameter:", err);
    }
  };
  y(() => {
    if (!productId || !configuratorId || !containerRef.current) {
      return;
    }
    if (configuratorInstance) {
      return;
    }
    const createViewer = async () => {
      setIsLoading(true);
      setError(null);
      try {
        if (containerRef.current) {
          containerRef.current.innerHTML = "";
        }
        const uiInitData = getRoomleUIConfig();
        const configurator = await u.createConfigurator(configuratorId, containerRef.current, uiInitData);
        await configurator.ui.loadObject(`${catalogId}:${productId}`);
        setConfiguratorInstance(configurator);
        setIsLoading(false);
        setTimeout(async () => {
          if (configurator) {
            try {
              const parameterAPI = configurator.configurator;
              if (parameterAPI && typeof parameterAPI.getParametersOfRootComponent === "function") {
                const params = await parameterAPI.getParametersOfRootComponent();
                setParameters(params);
                const initialValues = {};
                params.forEach((param) => {
                  initialValues[param.key] = param.value || param.currentValue || "";
                });
                const selectedSwatchValues = getSelectedSwatchValues();
                const mergedValues = {
                  ...initialValues,
                  ...selectedSwatchValues
                };
                setCurrentValues(mergedValues);
                for (const [parameterName, value] of Object.entries(selectedSwatchValues)) {
                  if (value) {
                    try {
                      await updateParameterForAllComponents(parameterAPI, parameterName, value);
                    } catch (err) {
                      console.warn(`Failed to set parameter ${parameterName} to ${value}:`, err);
                    }
                  }
                }
                if (typeof parameterAPI.updateScene === "function") {
                  await parameterAPI.updateScene();
                }
              }
            } catch (err) {
              console.error("Error loading parameters:", err);
            }
          }
        }, 100);
      } catch (err) {
        setError("Failed to load 3D viewer");
        setIsLoading(false);
      }
    };
    createViewer();
    return () => {
      var _a;
      if (configuratorInstance) {
        try {
          (_a = configuratorInstance.destroy) == null ? void 0 : _a.call(configuratorInstance);
        } catch (err) {
          console.error("Error destroying configurator:", err);
        }
        setConfiguratorInstance(null);
        setParameters([]);
        setCurrentValues({});
      }
    };
  }, [productId, configuratorId]);
  y(() => {
    if (!containerRef.current) return;
    const handleParameterUpdate = (event) => {
      const {
        parameterName,
        value
      } = event.detail;
      updateParameter(parameterName, value);
    };
    const container = containerRef.current;
    container.addEventListener("roomle-update-parameter", handleParameterUpdate);
    const element = container.closest("roomle-viewer");
    if (element) {
      element.updateRoomleParameter = async (parameterName, value) => {
        await updateParameter(parameterName, value);
      };
      element.getRoomleParameters = async () => {
        return parameters;
      };
    }
    setupRoomleDebugFunctions(configuratorInstance, ref, parameters, currentValues, getSelectedSwatchValues, isLoading, error, updateParameterForAllComponents, forceStandingParameterRefresh);
    return () => {
      container.removeEventListener("roomle-update-parameter", handleParameterUpdate);
      if (element) {
        delete element.updateRoomleParameter;
        delete element.getRoomleParameters;
      }
      cleanupRoomleDebugFunctions();
    };
  }, [configuratorInstance, parameters, currentValues, getSelectedSwatchValues, isLoading, error]);
  return u$1("div", {
    ref: viewerRef,
    className: "roomle-viewer",
    children: [error && u$1("div", {
      className: "roomle-viewer__error",
      role: "alert",
      children: error
    }, void 0, false, {
      fileName: _jsxFileName$4,
      lineNumber: 569,
      columnNumber: 9
    }, void 0), u$1("div", {
      ref: containerRef,
      className: "roomle-viewer__container",
      children: isLoading && u$1("div", {
        className: "roomle-viewer__loading",
        children: "Loading 3D viewer..."
      }, void 0, false, {
        fileName: _jsxFileName$4,
        lineNumber: 578,
        columnNumber: 11
      }, void 0)
    }, void 0, false, {
      fileName: _jsxFileName$4,
      lineNumber: 573,
      columnNumber: 7
    }, void 0)]
  }, void 0, true, {
    fileName: _jsxFileName$4,
    lineNumber: 564,
    columnNumber: 5
  }, void 0);
});
register(RoomleViewer, "roomle-viewer");
var _jsxFileName$3 = "/home/runner/work/GIK2024_GIK/GIK2024_GIK/src/components/SecondarySwatches/CustomSize.tsx";
const CustomSize = ({
  optionName = null,
  maxHeight = null,
  minHeight = null,
  maxWidth = null,
  minWidth = null,
  defaultUnit = "imperial",
  // Translation props
  description = null,
  heightLabel = null,
  widthLabel = null,
  cmButton = "cm",
  inchesButton = "inches",
  validationInvalid = null,
  validationHeightTooLow = null,
  validationHeightTooHigh = null,
  validationWidthTooLow = null,
  validationWidthTooHigh = null,
  heightAttrName = null,
  widthAttrName = null
}) => {
  const [unit, setUnit] = t$3(d(defaultUnit === "metric" ? "cm" : "inches"), "unit");
  const [height, setHeight] = t$3(d(""), "height");
  const [width, setWidth] = t$3(d(""), "width");
  const [heightError, setHeightError] = t$3(d(null), "heightError");
  const [widthError, setWidthError] = t$3(d(null), "widthError");
  const [isVisible, setIsVisible] = t$3(d(false), "isVisible");
  const handleUnitToggle = (newUnit) => {
    if (newUnit === unit) return;
    if (height) {
      setHeight(convertUnit(height, newUnit));
    }
    if (width) {
      setWidth(convertUnit(width, newUnit));
    }
    setUnit(newUnit);
    setHeightError(null);
    setWidthError(null);
  };
  const validateHeightInputWithProps = (value) => {
    if (!value) return null;
    const num = parseFloat(value);
    if (isNaN(num)) {
      return validationInvalid || "Please enter a valid number";
    }
    const currentUnitLabel = unit === "cm" ? "cm" : "inches";
    if (dimensions.minHeight !== void 0 && num < dimensions.minHeight) {
      return (validationHeightTooLow == null ? void 0 : validationHeightTooLow.replace(/{{ min }}/g, dimensions.minHeight.toFixed(0)).replace(/{{ unit }}/g, currentUnitLabel)) || `Height must be at least ${dimensions.minHeight.toFixed(0)}${currentUnitLabel}`;
    }
    if (dimensions.maxHeight !== void 0 && num > dimensions.maxHeight) {
      return (validationHeightTooHigh == null ? void 0 : validationHeightTooHigh.replace(/{{ max }}/g, dimensions.maxHeight.toFixed(0)).replace(/{{ unit }}/g, currentUnitLabel)) || `Height must not exceed ${dimensions.maxHeight.toFixed(0)}${currentUnitLabel}`;
    }
    return null;
  };
  const validateWidthInputWithProps = (value) => {
    if (!value) return null;
    const num = parseFloat(value);
    if (isNaN(num)) {
      return validationInvalid || "Please enter a valid number";
    }
    const currentUnitLabel = unit === "cm" ? "cm" : "inches";
    if (dimensions.minWidth !== void 0 && num < dimensions.minWidth) {
      return (validationWidthTooLow == null ? void 0 : validationWidthTooLow.replace(/{{ min }}/g, dimensions.minWidth.toFixed(0)).replace(/{{ unit }}/g, currentUnitLabel)) || `Width must be at least ${dimensions.minWidth.toFixed(0)}${currentUnitLabel}`;
    }
    if (dimensions.maxWidth !== void 0 && num > dimensions.maxWidth) {
      return (validationWidthTooHigh == null ? void 0 : validationWidthTooHigh.replace(/{{ max }}/g, dimensions.maxWidth.toFixed(0)).replace(/{{ unit }}/g, currentUnitLabel)) || `Width must not exceed ${dimensions.maxWidth.toFixed(0)}${currentUnitLabel}`;
    }
    return null;
  };
  const handleHeightInputChange = (value) => {
    setHeight(value);
    const validationError = validateHeightInputWithProps(value);
    setHeightError(validationError);
  };
  const handleWidthInputChange = (value) => {
    setWidth(value);
    const validationError = validateWidthInputWithProps(value);
    setWidthError(validationError);
  };
  const updateFormInput = () => {
    const productForms = [document.querySelector('.product-form-wrapper form[is="product-form"]')].filter(Boolean);
    if (productForms.length === 0) return;
    const unitLabel2 = unit === "cm" ? cmButton : inchesButton;
    productForms.forEach((cartForm) => {
      if (heightAttrName) {
        const existingHeightInputs = cartForm == null ? void 0 : cartForm.querySelectorAll(`input[name="properties[${heightAttrName}]"]`);
        existingHeightInputs == null ? void 0 : existingHeightInputs.forEach((input) => input.remove());
        if (isVisible && height && !heightError) {
          const heightInput = document.createElement("input");
          heightInput.type = "hidden";
          heightInput.name = `properties[${heightAttrName}]`;
          heightInput.value = `${height} ${unitLabel2}`;
          cartForm == null ? void 0 : cartForm.appendChild(heightInput);
        }
      }
      if (widthAttrName) {
        const existingWidthInputs = cartForm == null ? void 0 : cartForm.querySelectorAll(`input[name="properties[${widthAttrName}]"]`);
        existingWidthInputs == null ? void 0 : existingWidthInputs.forEach((input) => input.remove());
        if (isVisible && width && !widthError) {
          const widthInput = document.createElement("input");
          widthInput.type = "hidden";
          widthInput.name = `properties[${widthAttrName}]`;
          widthInput.value = `${width} ${unitLabel2}`;
          cartForm == null ? void 0 : cartForm.appendChild(widthInput);
        }
      }
    });
  };
  const updateRoomleParameters = () => {
    if (!isVisible) return;
    if (height && minHeight !== null && maxHeight !== null && !heightError) {
      const heightInMm = convertToMillimeters(height, unit);
      if (heightInMm !== null) {
        const heightEvent = new CustomEvent("roomle-custom-size-update", {
          detail: {
            parameterName: "height",
            value: heightInMm.toFixed(0),
            originalValue: height,
            unit
          },
          bubbles: true
        });
        document.dispatchEvent(heightEvent);
      }
    }
    if (width && minWidth !== null && maxWidth !== null && !widthError) {
      const widthInMm = convertToMillimeters(width, unit);
      if (widthInMm !== null) {
        const widthEvent = new CustomEvent("roomle-custom-size-update", {
          detail: {
            parameterName: "width",
            value: widthInMm.toFixed(0),
            originalValue: width,
            unit
          },
          bubbles: true
        });
        document.dispatchEvent(widthEvent);
      }
    }
  };
  const dimensions = getMinMax(minHeight, maxHeight, minWidth, maxWidth, unit);
  const unitLabel = unit === "cm" ? "cm" : "inches";
  const shouldRenderHeight = dimensions.minHeight !== void 0 && dimensions.maxHeight !== void 0;
  const shouldRenderWidth = dimensions.minWidth !== void 0 && dimensions.maxWidth !== void 0;
  const normalizeSlug = (text) => {
    return text.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");
  };
  const checkVisibility = () => {
    var _a;
    if (!optionName) return false;
    const slug = normalizeSlug(optionName);
    const fieldset = document.querySelector(`[data-option-slug="${slug}"]`);
    if (!fieldset) return false;
    const selectedInput = fieldset.querySelector("input:checked, select option[selected]");
    if (!selectedInput) return false;
    const selectedValue = selectedInput.value || ((_a = selectedInput.textContent) == null ? void 0 : _a.trim()) || "";
    return selectedValue.toLowerCase().includes("custom") || selectedValue.toLowerCase().includes("personnal") || selectedValue.toLowerCase().includes("personali") || selectedValue.toLowerCase().includes("benutz");
  };
  const updateVisibility = () => {
    const shouldBeVisible = checkVisibility();
    setIsVisible(shouldBeVisible);
  };
  y(() => {
    var _a, _b, _c;
    updateVisibility();
    const handleOptionChange = () => {
      updateVisibility();
    };
    const variantSelects = document.querySelector("variant-selects");
    if (variantSelects) {
      variantSelects.addEventListener("change", handleOptionChange);
    }
    if (((_b = (_a = window.theme) == null ? void 0 : _a.pubsub) == null ? void 0 : _b.subscribe) && ((_c = window.theme.pubsub.PUB_SUB_EVENTS) == null ? void 0 : _c.optionValueSelectionChange)) {
      const unsubscriber = window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, handleOptionChange);
      return () => {
        if (variantSelects) {
          variantSelects.removeEventListener("change", handleOptionChange);
        }
        if (unsubscriber) {
          unsubscriber();
        }
      };
    }
    return () => {
      if (variantSelects) {
        variantSelects.removeEventListener("change", handleOptionChange);
      }
    };
  }, [optionName]);
  y(() => {
    if (isVisible) {
      updateFormInput();
      updateRoomleParameters();
    } else {
      const productForms = [document.querySelector('.product-form-wrapper form[is="product-form"]')].filter(Boolean);
      productForms.forEach((cartForm) => {
        if (heightAttrName) {
          const heightInputs = cartForm == null ? void 0 : cartForm.querySelectorAll(`input[name="properties[${heightAttrName}]"]`);
          heightInputs == null ? void 0 : heightInputs.forEach((input) => input.remove());
        }
        if (widthAttrName) {
          const widthInputs = cartForm == null ? void 0 : cartForm.querySelectorAll(`input[name="properties[${widthAttrName}]"]`);
          widthInputs == null ? void 0 : widthInputs.forEach((input) => input.remove());
        }
      });
    }
  }, [height, width, unit, shouldRenderHeight, shouldRenderWidth, isVisible, heightError, widthError, heightAttrName, widthAttrName]);
  y(() => {
    return () => {
      const productForms = [document.querySelector('.product-form-wrapper form[is="product-form"]')].filter(Boolean);
      productForms.forEach((cartForm) => {
        if (heightAttrName) {
          const heightInputs = cartForm == null ? void 0 : cartForm.querySelectorAll(`input[name="properties[${heightAttrName}]"]`);
          heightInputs == null ? void 0 : heightInputs.forEach((input) => input.remove());
        }
        if (widthAttrName) {
          const widthInputs = cartForm == null ? void 0 : cartForm.querySelectorAll(`input[name="properties[${widthAttrName}]"]`);
          widthInputs == null ? void 0 : widthInputs.forEach((input) => input.remove());
        }
      });
    };
  }, [heightAttrName, widthAttrName]);
  if (!shouldRenderHeight && !shouldRenderWidth || !isVisible) {
    return null;
  }
  return u$1("div", {
    className: "custom-size-component",
    children: [u$1("div", {
      className: "custom-size-component__description",
      children: description ? description.replace(/{{ optionName }}/g, optionName || "") : `Enter your custom dimensions for "${optionName}"`
    }, void 0, false, {
      fileName: _jsxFileName$3,
      lineNumber: 357,
      columnNumber: 7
    }, void 0), u$1("div", {
      className: "custom-size-component__form",
      children: [u$1("div", {
        className: "custom-size-component__unit-toggle",
        children: [u$1("button", {
          type: "button",
          onClick: () => handleUnitToggle("cm"),
          className: `custom-size-component__unit-btn ${unit === "cm" ? "active" : ""}`,
          children: cmButton || "cm"
        }, void 0, false, {
          fileName: _jsxFileName$3,
          lineNumber: 363,
          columnNumber: 11
        }, void 0), u$1("button", {
          type: "button",
          onClick: () => handleUnitToggle("inches"),
          className: `custom-size-component__unit-btn ${unit === "inches" ? "active" : ""}`,
          children: inchesButton || "inches"
        }, void 0, false, {
          fileName: _jsxFileName$3,
          lineNumber: 370,
          columnNumber: 11
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$3,
        lineNumber: 362,
        columnNumber: 9
      }, void 0), u$1("div", {
        className: "custom-size-component__inputs",
        children: [shouldRenderHeight && u$1("div", {
          className: "custom-size-component__input-group",
          children: [u$1("label", {
            className: "custom-size-component__label",
            children: heightLabel ? heightLabel.replace(/{{ unit }}/g, unit === "cm" ? cmButton : inchesButton) : `Height (${unitLabel})`
          }, void 0, false, {
            fileName: _jsxFileName$3,
            lineNumber: 382,
            columnNumber: 15
          }, void 0), u$1("input", {
            type: "number",
            value: height,
            onInput: (e2) => handleHeightInputChange(e2.target.value),
            placeholder: `${dimensions.minHeight.toFixed(0)} - ${dimensions.maxHeight.toFixed(0)}`,
            className: `custom-size-component__input ${heightError ? "error" : ""}`,
            min: dimensions.minHeight,
            max: dimensions.maxHeight,
            step: "1"
          }, void 0, false, {
            fileName: _jsxFileName$3,
            lineNumber: 385,
            columnNumber: 15
          }, void 0), heightError && u$1("span", {
            className: "custom-size-component__error",
            children: heightError
          }, void 0, false, {
            fileName: _jsxFileName$3,
            lineNumber: 396,
            columnNumber: 17
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName$3,
          lineNumber: 381,
          columnNumber: 13
        }, void 0), shouldRenderWidth && u$1("div", {
          className: "custom-size-component__input-group",
          children: [u$1("label", {
            className: "custom-size-component__label",
            children: widthLabel ? widthLabel.replace(/{{ unit }}/g, unitLabel) : `Width (${unitLabel})`
          }, void 0, false, {
            fileName: _jsxFileName$3,
            lineNumber: 403,
            columnNumber: 15
          }, void 0), u$1("input", {
            type: "number",
            value: width,
            onInput: (e2) => handleWidthInputChange(e2.target.value),
            placeholder: `${dimensions.minWidth.toFixed(0)} - ${dimensions.maxWidth.toFixed(0)}`,
            className: `custom-size-component__input ${widthError ? "error" : ""}`,
            min: dimensions.minWidth,
            max: dimensions.maxWidth,
            step: "1"
          }, void 0, false, {
            fileName: _jsxFileName$3,
            lineNumber: 406,
            columnNumber: 15
          }, void 0), widthError && u$1("span", {
            className: "custom-size-component__error",
            children: widthError
          }, void 0, false, {
            fileName: _jsxFileName$3,
            lineNumber: 417,
            columnNumber: 17
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName$3,
          lineNumber: 402,
          columnNumber: 13
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$3,
        lineNumber: 379,
        columnNumber: 9
      }, void 0)]
    }, void 0, true, {
      fileName: _jsxFileName$3,
      lineNumber: 361,
      columnNumber: 7
    }, void 0)]
  }, void 0, true, {
    fileName: _jsxFileName$3,
    lineNumber: 356,
    columnNumber: 5
  }, void 0);
};
register(CustomSize, "custom-size", ["optionName", "productFormId", "optionValues", "sectionId", "productId", "maxHeight", "minHeight", "maxWidth", "minWidth", "description", "heightLabel", "widthLabel", "cmButton", "inchesButton", "validationInvalid", "validationHeightTooLow", "validationHeightTooHigh", "validationWidthTooLow", "validationWidthTooHigh", "heightAttrName", "widthAttrName"]);
var _jsxFileName$2 = "/home/runner/work/GIK2024_GIK/GIK2024_GIK/src/components/SecondarySwatches/CustomFrequency.tsx";
const CustomFrequency = ({
  optionName = null,
  minFrequency = "40",
  maxFrequency = "150",
  placeholder = null,
  label = null,
  range = null,
  validationRequired = null,
  validationInvalid = null,
  validationTooLow = null,
  validationTooHigh = null,
  frequencyAttrName = null
}) => {
  const [frequency, setFrequency] = t$3(d(""), "frequency");
  const [frequencyError, setFrequencyError] = t$3(d(null), "frequencyError");
  const [isVisible, setIsVisible] = t$3(d(false), "isVisible");
  const minFreq = parseInt(minFrequency || "40", 10);
  const maxFreq = parseInt(maxFrequency || "150", 10);
  const validateFrequencyInput = (value) => {
    if (!value) {
      return validationRequired || "Frequency is required";
    }
    const numValue = parseFloat(value);
    if (isNaN(numValue)) {
      return validationInvalid || "Please enter a valid number";
    }
    if (numValue < minFreq) {
      return (validationTooLow == null ? void 0 : validationTooLow.replace(/{{ minFreq }}/g, minFreq.toString())) || `Frequency must be at least ${minFreq} Hz`;
    }
    if (numValue > maxFreq) {
      return (validationTooHigh == null ? void 0 : validationTooHigh.replace(/{{ maxFreq }}/g, maxFreq.toString())) || `Frequency cannot exceed ${maxFreq} Hz`;
    }
    return null;
  };
  const handleFrequencyInputChange = (value) => {
    setFrequency(value);
    const validationError = validateFrequencyInput(value);
    setFrequencyError(validationError);
  };
  const updateFormInput = () => {
    const productForms = [document.querySelector('.product-form-wrapper form[is="product-form"]')].filter(Boolean);
    if (productForms.length === 0) return;
    productForms.forEach((cartForm) => {
      let customFrequencyInput = cartForm == null ? void 0 : cartForm.querySelector(`input[name="properties[${frequencyAttrName}]"]`);
      if (!isVisible) {
        if (customFrequencyInput) {
          customFrequencyInput.remove();
        }
        return;
      }
      if (!customFrequencyInput) {
        customFrequencyInput = document.createElement("input");
        customFrequencyInput.type = "hidden";
        customFrequencyInput.name = `properties[${frequencyAttrName}]`;
        cartForm == null ? void 0 : cartForm.appendChild(customFrequencyInput);
      }
      if (!frequencyError && frequency) {
        customFrequencyInput.value = `${frequency}Hz`;
      } else {
        customFrequencyInput.value = "";
      }
    });
  };
  const updateRoomleParameters = () => {
    if (!isVisible || !frequency || frequencyError) return;
    const frequencyEvent = new CustomEvent("roomle-custom-frequency-update", {
      detail: {
        parameterName: "frequency",
        value: frequency,
        unit: "Hz"
      },
      bubbles: true
    });
    document.dispatchEvent(frequencyEvent);
  };
  const normalizeSlug = (text) => {
    return text.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");
  };
  const checkVisibility = () => {
    var _a;
    if (!optionName) return false;
    const slug = normalizeSlug(optionName);
    const fieldset = document.querySelector(`[data-option-slug="${slug}"]`);
    if (!fieldset) return false;
    const selectedInput = fieldset.querySelector("input:checked, select option[selected]");
    if (!selectedInput) return false;
    const selectedValue = selectedInput.value || ((_a = selectedInput.textContent) == null ? void 0 : _a.trim()) || "";
    const lowerValue = selectedValue.toLowerCase();
    return lowerValue.includes("custom") || lowerValue.includes("personnal") || lowerValue.includes("personali") || lowerValue.includes("benutz");
  };
  const updateVisibility = () => {
    const shouldBeVisible = checkVisibility();
    setIsVisible(shouldBeVisible);
    if (shouldBeVisible && !frequency) {
      setFrequency("");
      setFrequencyError(null);
    }
  };
  y(() => {
    var _a, _b, _c;
    updateVisibility();
    const handleOptionChange = () => {
      updateVisibility();
    };
    const variantSelects = document.querySelector("variant-selects");
    if (variantSelects) {
      variantSelects.addEventListener("change", handleOptionChange);
    }
    if (((_b = (_a = window.theme) == null ? void 0 : _a.pubsub) == null ? void 0 : _b.subscribe) && ((_c = window.theme.pubsub.PUB_SUB_EVENTS) == null ? void 0 : _c.optionValueSelectionChange)) {
      const unsubscriber = window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, handleOptionChange);
      return () => {
        if (variantSelects) {
          variantSelects.removeEventListener("change", handleOptionChange);
        }
        if (unsubscriber) {
          unsubscriber();
        }
      };
    }
    return () => {
      if (variantSelects) {
        variantSelects.removeEventListener("change", handleOptionChange);
      }
    };
  }, [optionName]);
  y(() => {
    if (isVisible) {
      updateFormInput();
      updateRoomleParameters();
    } else {
      const productForms = [document.querySelector('.product-form-wrapper form[is="product-form"]')].filter(Boolean);
      productForms.forEach((cartForm) => {
        const customFrequencyInput = cartForm == null ? void 0 : cartForm.querySelector(`input[name="properties[${frequencyAttrName}]"]`);
        if (customFrequencyInput) {
          customFrequencyInput.remove();
        }
      });
    }
  }, [frequency, isVisible, frequencyError]);
  y(() => {
    return () => {
      const productForms = [document.querySelector('.product-form-wrapper form[is="product-form"]')].filter(Boolean);
      productForms.forEach((cartForm) => {
        const customFrequencyInput = cartForm == null ? void 0 : cartForm.querySelector(`input[name="properties[${frequencyAttrName}]"]`);
        if (customFrequencyInput) {
          customFrequencyInput.remove();
        }
      });
    };
  }, []);
  if (!isVisible) {
    return null;
  }
  return u$1("div", {
    className: "custom-frequency-component",
    children: [u$1("div", {
      className: "custom-frequency-component__description",
      children: placeholder || "Enter your custom tuning frequency"
    }, void 0, false, {
      fileName: _jsxFileName$2,
      lineNumber: 218,
      columnNumber: 7
    }, void 0), u$1("div", {
      className: "custom-frequency-component__form",
      children: [u$1("div", {
        className: "custom-frequency-component__input-group",
        children: [u$1("label", {
          className: "custom-frequency-component__label",
          children: label || "Frequency (Hz)"
        }, void 0, false, {
          fileName: _jsxFileName$2,
          lineNumber: 224,
          columnNumber: 11
        }, void 0), u$1("div", {
          className: "custom-frequency-component__input-wrapper",
          children: [u$1("input", {
            type: "number",
            value: frequency,
            onInput: (e2) => handleFrequencyInputChange(e2.target.value),
            placeholder: `${minFreq} - ${maxFreq}`,
            className: `custom-frequency-component__input ${frequencyError ? "error" : ""}`,
            min: minFreq,
            max: maxFreq,
            step: "1"
          }, void 0, false, {
            fileName: _jsxFileName$2,
            lineNumber: 228,
            columnNumber: 13
          }, void 0), u$1("span", {
            className: "custom-frequency-component__input-suffix",
            children: "Hz"
          }, void 0, false, {
            fileName: _jsxFileName$2,
            lineNumber: 238,
            columnNumber: 13
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName$2,
          lineNumber: 227,
          columnNumber: 11
        }, void 0), frequencyError && u$1("span", {
          className: "custom-frequency-component__error",
          children: frequencyError
        }, void 0, false, {
          fileName: _jsxFileName$2,
          lineNumber: 241,
          columnNumber: 13
        }, void 0)]
      }, void 0, true, {
        fileName: _jsxFileName$2,
        lineNumber: 223,
        columnNumber: 9
      }, void 0), u$1("div", {
        className: "custom-frequency-component__range-display",
        children: range ? range.replace(/{{ minFreq }}/g, minFreq.toString()).replace(/{{ maxFreq }}/g, maxFreq.toString()) : `Range: ${minFreq} Hz - ${maxFreq} Hz`
      }, void 0, false, {
        fileName: _jsxFileName$2,
        lineNumber: 245,
        columnNumber: 9
      }, void 0)]
    }, void 0, true, {
      fileName: _jsxFileName$2,
      lineNumber: 222,
      columnNumber: 7
    }, void 0)]
  }, void 0, true, {
    fileName: _jsxFileName$2,
    lineNumber: 217,
    columnNumber: 5
  }, void 0);
};
register(CustomFrequency, "custom-frequency", ["optionName", "minFrequency", "maxFrequency", "placeholder", "label", "range", "validationRequired", "validationInvalid", "validationTooLow", "validationTooHigh"]);
var _jsxFileName$1 = "/home/runner/work/GIK2024_GIK/GIK2024_GIK/src/components/FlexRangeSwatches.tsx";
const FlexRangeSwatches = ({
  swatchValues = null,
  optionName = null,
  productFormId = null,
  flexrangeAttrName = null,
  swatchValueTranslations = null,
  shopLocale = null
}) => {
  const [selectedSwatch, setSelectedSwatch] = t$3(d(null), "selectedSwatch");
  const [componentId] = t$3(d(() => `flexrange-swatches-${Math.random().toString(36).substr(2, 9)}`), "componentId");
  const [hasPreSelected, setHasPreSelected] = t$3(d(false), "hasPreSelected");
  const swatchValuesArray = swatchValues ? JSON.parse(swatchValues) : [];
  const translationsArray = t$3(T$1(() => {
    if (!swatchValueTranslations) return [];
    try {
      return JSON.parse(swatchValueTranslations);
    } catch {
      return [];
    }
  }, [swatchValueTranslations]), "translationsArray: SwatchValueTranslation[]");
  const getTranslatedValue = (value) => {
    if (!value || (translationsArray == null ? void 0 : translationsArray.length) === 0) return value;
    const normalizedValue = value.toLowerCase();
    const translation = translationsArray == null ? void 0 : translationsArray.find((t2) => {
      var _a;
      return ((_a = t2.english_swatch_value) == null ? void 0 : _a.toLowerCase()) === normalizedValue;
    });
    if (!translation) return value;
    const locale = (shopLocale == null ? void 0 : shopLocale.toLowerCase()) || "en";
    switch (locale) {
      case "fr":
        return translation.french_translation || value;
      case "de":
        return translation.german_translation || value;
      case "it":
        return translation.italian_translation || value;
      case "en":
      default:
        return value;
    }
  };
  const toggleSwatchSelection = (variant) => {
    setSelectedSwatch((prev) => prev === variant ? prev : variant);
  };
  const getSelectedText = () => {
    if (!selectedSwatch) return "";
    const selected = swatchValuesArray.find((swatch) => swatch.flexrange_variant === selectedSwatch);
    return (selected == null ? void 0 : selected.name) || "";
  };
  const updateLineItemProperty = (value) => {
    if (!productFormId) return;
    const productForms = [document.getElementById(productFormId), document.querySelector('.product-form-wrapper form[is="product-form"]')].filter(Boolean);
    if (productForms.length === 0) return;
    productForms.forEach((form) => {
      const existingInputs = form == null ? void 0 : form.querySelectorAll(`input[name="properties[${flexrangeAttrName}]"]`);
      existingInputs == null ? void 0 : existingInputs.forEach((input) => input.remove());
      if (value) {
        const propertyInput = document.createElement("input");
        propertyInput.type = "hidden";
        propertyInput.name = `properties[${flexrangeAttrName}]`;
        propertyInput.value = value;
        form == null ? void 0 : form.appendChild(propertyInput);
      }
    });
  };
  y(() => {
    if (!hasPreSelected && swatchValuesArray.length > 0) {
      const firstSwatch = swatchValuesArray[0];
      if (firstSwatch == null ? void 0 : firstSwatch.flexrange_variant) {
        setSelectedSwatch(firstSwatch.flexrange_variant);
        setHasPreSelected(true);
      }
    }
  }, [swatchValuesArray, hasPreSelected]);
  y(() => {
    const selectedText = getSelectedText();
    updateLineItemProperty(selectedText);
  }, [selectedSwatch, productFormId]);
  y(() => {
    return () => {
      if (productFormId) {
        updateLineItemProperty("");
      }
    };
  }, []);
  return u$1("div", {
    className: "secondary-swatches",
    children: u$1("div", {
      className: "secondary-swatches__content",
      children: u$1("div", {
        className: "secondary-swatches__options",
        children: u$1("fieldset", {
          className: "secondary-swatches__option-group variant-input-wrapper border-0",
          children: [u$1("legend", {
            className: "sr-only",
            children: optionName || "FlexRange Technology"
          }, void 0, false, {
            fileName: _jsxFileName$1,
            lineNumber: 135,
            columnNumber: 13
          }, void 0), u$1("div", {
            className: "form__label flex items-center justify-between gap-2 w-full",
            children: u$1("div", {
              className: "flex gap-2",
              children: [u$1("span", {
                className: "form__label-pretext",
                children: [optionName || "FlexRange Technology", ":"]
              }, void 0, true, {
                fileName: _jsxFileName$1,
                lineNumber: 138,
                columnNumber: 17
              }, void 0), u$1("span", {
                className: "font-medium form__label-text",
                id: `${componentId}-selected`,
                children: getTranslatedValue(getSelectedText())
              }, void 0, false, {
                fileName: _jsxFileName$1,
                lineNumber: 141,
                columnNumber: 17
              }, void 0)]
            }, void 0, true, {
              fileName: _jsxFileName$1,
              lineNumber: 137,
              columnNumber: 15
            }, void 0)
          }, void 0, false, {
            fileName: _jsxFileName$1,
            lineNumber: 136,
            columnNumber: 13
          }, void 0), u$1("ul", {
            className: "swatches swatches--rounded flex items-start flex-wrap gap-4",
            children: swatchValuesArray.map((swatch, index) => {
              const isSelected = selectedSwatch === swatch.flexrange_variant;
              return u$1("li", {
                children: u$1("div", {
                  className: "block",
                  children: u$1("div", {
                    className: `label-swatch swatches--round-slight inline-block text-sm font-medium leading-none relative px-3 py-2 border border-gray-300 rounded ${isSelected ? "selected cursor-default" : "cursor-pointer"}`,
                    title: getTranslatedValue(swatch.name),
                    onClick: () => !isSelected && toggleSwatchSelection(swatch.flexrange_variant),
                    children: getTranslatedValue(swatch.name)
                  }, void 0, false, {
                    fileName: _jsxFileName$1,
                    lineNumber: 153,
                    columnNumber: 23
                  }, void 0)
                }, void 0, false, {
                  fileName: _jsxFileName$1,
                  lineNumber: 152,
                  columnNumber: 21
                }, void 0)
              }, `flexrange-${index}`, false, {
                fileName: _jsxFileName$1,
                lineNumber: 151,
                columnNumber: 19
              }, void 0);
            })
          }, void 0, false, {
            fileName: _jsxFileName$1,
            lineNumber: 146,
            columnNumber: 13
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName$1,
          lineNumber: 134,
          columnNumber: 11
        }, void 0)
      }, void 0, false, {
        fileName: _jsxFileName$1,
        lineNumber: 133,
        columnNumber: 9
      }, void 0)
    }, void 0, false, {
      fileName: _jsxFileName$1,
      lineNumber: 132,
      columnNumber: 7
    }, void 0)
  }, void 0, false, {
    fileName: _jsxFileName$1,
    lineNumber: 131,
    columnNumber: 5
  }, void 0);
};
register(FlexRangeSwatches, "flexrange-swatches", ["swatchValues", "optionName", "productFormId", "swatchValueTranslations", "shopLocale"]);
var _jsxFileName = "/home/runner/work/GIK2024_GIK/GIK2024_GIK/src/components/CustomColorSwatches.tsx";
const CustomColorSwatches = ({
  colorPattern = null,
  productFormId = null,
  optionName = null,
  colorAttrName = null,
  roomleColorMapping = null
}) => {
  const [selectedSwatch, setSelectedSwatch] = t$3(d(null), "selectedSwatch");
  const [componentId] = t$3(d(() => `custom-color-swatches-${Math.random().toString(36).substr(2, 9)}`), "componentId");
  const [hasPreSelected, setHasPreSelected] = t$3(d(false), "hasPreSelected");
  const colorPatternArray = colorPattern ? JSON.parse(colorPattern) : [];
  const colorMapping = roomleColorMapping ? JSON.parse(roomleColorMapping) : {};
  const getRoomleColorValue = (label) => {
    if (!colorMapping) return "";
    if (colorMapping[label]) {
      return colorMapping[label];
    }
    for (const [colorName, roomleValue] of Object.entries(colorMapping)) {
      if (label.toLowerCase().includes(colorName.toLowerCase())) {
        return roomleValue;
      }
    }
    return "";
  };
  const toggleSwatchSelection = (label) => {
    if (selectedSwatch === label) return;
    setSelectedSwatch(label);
    const roomleColorValue = getRoomleColorValue(label);
    if (roomleColorValue) {
      const roomleEvent = new CustomEvent("roomle-color-update", {
        detail: {
          parameterName: "color",
          value: roomleColorValue
        },
        bubbles: true
      });
      document.dispatchEvent(roomleEvent);
    }
  };
  const getSelectedText = () => {
    if (!selectedSwatch) return "";
    const selected = colorPatternArray.find((swatch) => swatch.label === selectedSwatch);
    return (selected == null ? void 0 : selected.label) || "";
  };
  const updateLineItemProperty = (value) => {
    if (!productFormId) return;
    const productForms = [document.getElementById(productFormId), document.querySelector('.product-form-wrapper form[is="product-form"]')].filter(Boolean);
    if (productForms.length === 0) return;
    productForms.forEach((form) => {
      const existingInputs = form == null ? void 0 : form.querySelectorAll(`input[name="properties[${colorAttrName}]"]`);
      existingInputs == null ? void 0 : existingInputs.forEach((input) => input.remove());
      if (value) {
        const propertyInput = document.createElement("input");
        propertyInput.type = "hidden";
        propertyInput.name = `properties[${colorAttrName}]`;
        propertyInput.value = value;
        form == null ? void 0 : form.appendChild(propertyInput);
      }
    });
  };
  y(() => {
    if (!hasPreSelected && colorPatternArray.length > 0) {
      const firstSwatch = colorPatternArray[0];
      if (firstSwatch == null ? void 0 : firstSwatch.label) {
        setSelectedSwatch(firstSwatch.label);
        setHasPreSelected(true);
      }
    }
  }, [colorPatternArray, hasPreSelected]);
  y(() => {
    const selectedText = getSelectedText();
    updateLineItemProperty(selectedText);
  }, [selectedSwatch, productFormId]);
  y(() => {
    return () => {
      if (productFormId) {
        updateLineItemProperty("");
      }
    };
  }, []);
  return u$1("div", {
    className: "secondary-swatches custom-color-swatches",
    children: u$1("div", {
      className: "secondary-swatches__content",
      children: u$1("div", {
        className: "secondary-swatches__options",
        children: u$1("fieldset", {
          className: "secondary-swatches__option-group variant-input-wrapper border-0",
          children: [u$1("legend", {
            className: "sr-only",
            children: optionName || "Color"
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 126,
            columnNumber: 13
          }, void 0), u$1("div", {
            className: "form__label flex items-center justify-between gap-2 w-full",
            children: u$1("div", {
              className: "flex gap-2",
              children: [u$1("span", {
                className: "form__label-pretext",
                children: [optionName || "Color", ":"]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 129,
                columnNumber: 17
              }, void 0), u$1("span", {
                className: "font-medium form__label-text",
                id: `${componentId}-selected`,
                children: getSelectedText()
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 132,
                columnNumber: 17
              }, void 0)]
            }, void 0, true, {
              fileName: _jsxFileName,
              lineNumber: 128,
              columnNumber: 15
            }, void 0)
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 127,
            columnNumber: 13
          }, void 0), u$1("ul", {
            className: "swatches swatches--rounded flex items-start flex-wrap gap-4",
            children: colorPatternArray.map((swatch, index) => {
              const isSelected = selectedSwatch === swatch.label;
              const inputId = `${componentId}-${index}`;
              const roomleColorValue = getRoomleColorValue(swatch.label);
              return u$1("li", {
                children: u$1("magnet-element", {
                  className: "block",
                  children: [u$1("input", {
                    type: "radio",
                    className: `sr-only${isSelected ? " checked" : ""}`,
                    id: inputId,
                    name: `${componentId}-color`,
                    value: swatch.label,
                    checked: isSelected ? true : false,
                    onChange: () => toggleSwatchSelection(swatch.label)
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 147,
                    columnNumber: 23
                  }, void 0), u$1("label", {
                    htmlFor: inputId,
                    className: `color-swatch${swatch.image ? " with-image" : ""} inline-block cursor-pointer relative`,
                    title: swatch.label,
                    style: {
                      "--swatch-background": swatch.color,
                      ...swatch.image && {
                        "--swatch-background-image": `url(${swatch.image})`
                      }
                    },
                    ...roomleColorValue && {
                      "data-roomle-color": roomleColorValue
                    },
                    children: u$1("span", {
                      className: "tooltip opacity-0 pointer-events-none text-xs rounded-full z-10",
                      children: swatch.label
                    }, void 0, false, {
                      fileName: _jsxFileName,
                      lineNumber: 166,
                      columnNumber: 25
                    }, void 0)
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 156,
                    columnNumber: 23
                  }, void 0)]
                }, void 0, true, {
                  fileName: _jsxFileName,
                  lineNumber: 146,
                  columnNumber: 21
                }, void 0)
              }, `color-${index}`, false, {
                fileName: _jsxFileName,
                lineNumber: 144,
                columnNumber: 19
              }, void 0);
            })
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 137,
            columnNumber: 13
          }, void 0)]
        }, void 0, true, {
          fileName: _jsxFileName,
          lineNumber: 125,
          columnNumber: 11
        }, void 0)
      }, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 124,
        columnNumber: 9
      }, void 0)
    }, void 0, false, {
      fileName: _jsxFileName,
      lineNumber: 123,
      columnNumber: 7
    }, void 0)
  }, void 0, false, {
    fileName: _jsxFileName,
    lineNumber: 122,
    columnNumber: 5
  }, void 0);
};
register(CustomColorSwatches, "custom-color-swatches", ["colorPattern", "productFormId", "optionName", "colorAttrName", "roomleColorMapping"]);
